angular.module('app').controller('reviewReportsController', function ($scope, $routeParams, $http, $window, $location, safeApply, $sce, allowedFileTypesConfig) {

  // The Review Tool theme (sass/_review_modern.scss) is scoped to body.ep-rt so the client portal keeps its look
  $window.document.body.classList.add('ep-rt')
  $scope.$on('$destroy', function () {
    $window.document.body.classList.remove('ep-rt')
  })

  $scope.crm_user_id = $routeParams.crm_user_id
  $scope.crm_user_password = $routeParams.crm_user_password
  $scope.tax_year = $routeParams.tax_year

  $scope.counties = []
  $scope.selectedCounty = null
  $scope.reports = []
  $scope.filteredReports = []
  $scope.filterType = 'all'
  $scope.reviewStatusFilter = 'all'
  $scope.reviewerFilter = 'all'
  $scope.reviewerFilterOptions = [
    { value: 'all', label: 'ALL Reviewers' }
  ]
  $scope.itemsToReviewOnly = false
  $scope.showUnreadOnly = false
  $scope.showNeedsResponseOverdueOnly = false
  $scope.showNeedsFollowUpOnly = false
  // Only properties with an AI discrepancy (a listing screenshot / agent CMA an agent set to Use on Report)
  $scope.showAiDiscrepancyOnly = false
  $scope.filtersCollapsed = false
  $scope.sortOption = ''
  $scope.sortOptions = [
    { value: '', label: 'Not Sorted' },
    { value: 'photo_count', label: '# of Photos' },
    { value: 'document_count', label: '# of Docs' },
    { value: 'last_updated', label: 'Last Updated' }
  ]
  $scope.searchText = ''
  $scope.currentYear = new Date().getFullYear()
  $scope.pdfGenerating = false
  $scope.reportsLoading = false
  $scope.evidenceUsageStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'use_on_report', label: 'Use on Report' },
    { value: 'do_not_use_on_report', label: 'Do Not Use on Report' }
  ]

  // Agent valuation rows in the Property Info panel - edit these lists to change the dropdown options.
  // Values live on report.agentValuation (per property) and save to z_evidence_portal_3_agent_opinon_of_value.
  $scope.agentStartingValueSources = [
    'CAD Notified Value',
    'Appraisal',
    'Equity',
    'Closing Docs',
    'Recent Sales (COMPS)',
    'Manual Input'
  ]
  $scope.agentReduceByOptions = [
    'Repair Estimates',
    'Repair Invoices',
    'Photos',
    'Insurance Claim'
  ]

  // Starting source/value default to the CAD notified Total Market value once the property details are loaded
  const AGENT_STARTING_VALUE_DEFAULT_SOURCE = 'CAD Notified Value'
  // Picking this source opens the Manual Input modal (reason + whole-dollar value)
  const AGENT_STARTING_VALUE_MANUAL_SOURCE = 'Manual Input'

  // The CAD notified Total Market value (whole dollars), or null until the property details have loaded
  function getCadTotalMarketValue(report) {
    const totalMarket = report && report.propertyDetails ? Number(report.propertyDetails.total_market) : NaN
    return Number.isFinite(totalMarket) ? Math.round(totalMarket) : null
  }

  $scope.getAgentValuation = function (report) {
    if (!report.agentValuation) {
      report.agentValuation = { starting_source: AGENT_STARTING_VALUE_DEFAULT_SOURCE, starting_value: null, manual_reason: null, reduce_by: [], reduce_value: null, opinion_value: null, _defaulted: false, _committed_source: AGENT_STARTING_VALUE_DEFAULT_SOURCE }
    }
    const av = report.agentValuation
    const totalMarket = getCadTotalMarketValue(report)
    if (!av._defaulted && totalMarket !== null) {
      av._defaulted = true
      if (av.starting_value === null || av.starting_value === undefined) av.starting_value = totalMarket
      $scope.recalcAgentOpinionOfValue(report)
    }
    return av
  }

  $scope.isAgentManualStartingSource = function (report) {
    return !!(report.agentValuation && report.agentValuation.starting_source === AGENT_STARTING_VALUE_MANUAL_SOURCE)
  }

  // Manual Input modal state; the source only becomes 'Manual Input' once the modal is accepted
  $scope.agentManualInput = { report: null, reason: '', value: null }
  let _agentManualInputModal = null
  let _agentManualInputModalBound = false
  let _agentManualInputAccepted = false

  function getAgentManualInputModal() {
    try {
      let el = document.getElementById('epAgentManualInputModal')
      if (!el) return null
      if (!_agentManualInputModal && $window.bootstrap && $window.bootstrap.Modal) {
        _agentManualInputModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_agentManualInputModalBound) {
        _agentManualInputModalBound = true
        el.addEventListener('shown.bs.modal', function () {
          let input = el.querySelector('#epAgentManualInputReason')
          if (input) input.focus()
        })
        // Any close other than Accept puts the dropdown back on the previously committed source
        el.addEventListener('hidden.bs.modal', function () {
          const report = $scope.agentManualInput.report
          if (!_agentManualInputAccepted && report && report.agentValuation) {
            report.agentValuation.starting_source = report.agentValuation._committed_source || null
          }
          _agentManualInputAccepted = false
          $scope.agentManualInput = { report: null, reason: '', value: null }
          safeApply($scope)
        })
      }
      return _agentManualInputModal
    } catch (e) {
      return null
    }
  }

  $scope.openAgentManualInput = function (report) {
    const av = $scope.getAgentValuation(report)
    const isManual = av._committed_source === AGENT_STARTING_VALUE_MANUAL_SOURCE
    _agentManualInputAccepted = false
    $scope.agentManualInput = {
      report: report,
      reason: isManual ? (av.manual_reason || '') : '',
      value: isManual ? av.starting_value : null
    }
    let modal = getAgentManualInputModal()
    if (modal) modal.show()
  }

  $scope.onAgentStartingSourceChange = function (report) {
    const av = $scope.getAgentValuation(report)
    if (av.starting_source === AGENT_STARTING_VALUE_MANUAL_SOURCE) {
      $scope.openAgentManualInput(report)
      return
    }
    av._committed_source = av.starting_source
    av.manual_reason = null
    // Switching (back) to CAD Notified Value resets the $ value to the CAD Total Market, same as the default
    if (av.starting_source === AGENT_STARTING_VALUE_DEFAULT_SOURCE) {
      const totalMarket = getCadTotalMarketValue(report)
      if (totalMarket !== null) {
        av.starting_value = totalMarket
        $scope.recalcAgentOpinionOfValue(report)
      }
    }
    $scope.saveAgentValuation(report)
  }

  $scope.canAcceptAgentManualInput = function () {
    const m = $scope.agentManualInput
    return !!(m && m.report && String(m.reason || '').trim() && m.value !== null && m.value !== undefined && Number.isFinite(Number(m.value)))
  }

  $scope.acceptAgentManualInput = function () {
    if (!$scope.canAcceptAgentManualInput()) return
    const m = $scope.agentManualInput
    const av = $scope.getAgentValuation(m.report)
    av.starting_source = AGENT_STARTING_VALUE_MANUAL_SOURCE
    av._committed_source = AGENT_STARTING_VALUE_MANUAL_SOURCE
    av.starting_value = Math.round(Number(m.value))
    av.manual_reason = String(m.reason).trim()
    $scope.recalcAgentOpinionOfValue(m.report)
    $scope.saveAgentValuation(m.report)
    _agentManualInputAccepted = true
    let modal = getAgentManualInputModal()
    if (modal) modal.hide()
  }

  $scope.cancelAgentManualInput = function () {
    let modal = getAgentManualInputModal()
    if (modal) modal.hide()
  }

  $scope.isAgentReduceBySelected = function (report, option) {
    return $scope.getAgentValuation(report).reduce_by.indexOf(option) > -1
  }

  // Keeps the selection in the same order as agentReduceByOptions
  // Which evidence file types back each "Reduce Dollar Value By" option
  const AGENT_REDUCE_BY_EVIDENCE_MATCHERS = {
    'Repair Estimates': function (key) { return key === 'ESTIMATE_NEEDED_REPAIR' },
    'Repair Invoices': function (key) { return key === 'INVOICE_REPAIRS_COMPLETED' },
    'Photos': function (key) { return isPhotoContentTypeKey(key) },
    'Insurance Claim': function (key) { return key === 'INSURANCE_CLAIM_DAMAGE' }
  }

  // The property's evidence of that type, skipping files marked Do Not Use on Report
  function getAgentReduceByEvidenceFiles(report, option) {
    const matches = AGENT_REDUCE_BY_EVIDENCE_MATCHERS[option]
    if (!matches || !report || !Array.isArray(report.evidence_files)) return []
    return report.evidence_files.filter(function (file) {
      return file && shouldIncludeInRepairReduction(file) && matches(String(file.content_type_key || '').trim().toUpperCase())
    })
  }

  $scope.getAgentReduceByEvidenceCount = function (report, option) {
    return getAgentReduceByEvidenceFiles(report, option).length
  }

  // Total of the files' amounts, or null for types with no amount field (Photos)
  $scope.getAgentReduceByEvidenceSum = function (report, option) {
    if (option === 'Photos') return null
    return getAgentReduceByEvidenceFiles(report, option).reduce(function (sum, file) {
      const amountField = REPAIR_REDUCTION_AMOUNT_FIELDS[String(file.content_type_key || '').trim().toUpperCase()]
      return amountField ? sum + toMoneyNumber((file.meta_json || {})[amountField]) : sum
    }, 0)
  }

  // An option with no evidence can't be picked; one already picked stays enabled so it can still be unticked
  $scope.isAgentReduceByOptionDisabled = function (report, option) {
    return $scope.getAgentReduceByEvidenceCount(report, option) === 0 && !$scope.isAgentReduceBySelected(report, option)
  }

  $scope.toggleAgentReduceBy = function (report, option) {
    if ($scope.isAgentReduceByOptionDisabled(report, option)) return
    const av = $scope.getAgentValuation(report)
    const selected = av.reduce_by.indexOf(option) > -1
      ? av.reduce_by.filter(function (o) { return o !== option })
      : av.reduce_by.concat(option)
    av.reduce_by = $scope.agentReduceByOptions.filter(function (o) { return selected.indexOf(o) > -1 })
    $scope.saveAgentValuation(report)
  }

  $scope.getAgentReduceByLabel = function (report) {
    const selected = $scope.getAgentValuation(report).reduce_by
    return selected.length ? selected.join(', ') : 'Select items...'
  }

  // Agent Opinion of Value = Agent Starting Market Value less Reduce Dollar Value By (whole dollars, never below 0)
  $scope.recalcAgentOpinionOfValue = function (report) {
    const av = report.agentValuation
    if (!av) return
    const start = Number(av.starting_value)
    av.opinion_value = (av.starting_value === null || av.starting_value === undefined || !Number.isFinite(start))
      ? null
      : Math.max(0, start - (Number(av.reduce_value) || 0))
  }

  // Saving: the whole panel is one row in z_evidence_portal_3_agent_opinon_of_value (server saveAgentOpinionOfValue).
  // It saves when the dropdowns change, the Manual Input modal is accepted, or a dollar field loses focus.
  function toWholeDollarsOrNull(value) {
    if (value === null || value === undefined || value === '') return null
    const n = Number(value)
    return Number.isFinite(n) ? Math.round(n) : null
  }

  function getAgentValuationSnapshot(av) {
    return JSON.stringify([
      av.starting_source || null,
      toWholeDollarsOrNull(av.starting_value),
      av.starting_source === AGENT_STARTING_VALUE_MANUAL_SOURCE ? (av.manual_reason || null) : null,
      av.reduce_by || [],
      toWholeDollarsOrNull(av.reduce_value)
    ])
  }

  function applyAgentValuationSavedMeta(av, data) {
    av._savedBy = data && data.agent_opv_crm_user_name ? String(data.agent_opv_crm_user_name) : null
    av._savedAt = data && data.agent_opv_updated_at ? $scope.portalDate(data.agent_opv_updated_at) : null
  }

  // Loads the saved panel values from the property details; with no saved row the CAD Notified Value default stays
  function applySavedAgentValuation(report, data) {
    if (!report || !data) return
    const av = $scope.getAgentValuation(report)
    const hasSavedStart = !!data.agent_opv_starting_source || data.agent_opv_starting_value != null
    if (hasSavedStart) {
      av.starting_source = data.agent_opv_starting_source || null
      av._committed_source = av.starting_source
      av.starting_value = data.agent_opv_starting_value != null ? Number(data.agent_opv_starting_value) : null
      av.manual_reason = data.agent_opv_starting_manual_reason || null
      av._defaulted = true
    }
    const savedReduceBy = Array.isArray(data.agent_opv_reduce_by) ? data.agent_opv_reduce_by : []
    av.reduce_by = $scope.agentReduceByOptions.filter(function (o) { return savedReduceBy.indexOf(o) > -1 })
    av.reduce_value = data.agent_opv_reduce_value != null ? Number(data.agent_opv_reduce_value) : null
    $scope.recalcAgentOpinionOfValue(report)
    av._savedSnapshot = getAgentValuationSnapshot(av)
    av._saveError = null
    applyAgentValuationSavedMeta(av, data)
  }

  $scope.saveAgentValuation = function (report) {
    const av = report && report.agentValuation
    // Until the saved values have loaded, a save would overwrite them with the defaults
    if (!av || !report.propertyDetailsLoaded) return

    const snapshot = getAgentValuationSnapshot(av)
    if (snapshot === av._savedSnapshot) return
    if (av._saving) {
      av._savePending = true
      return
    }

    av._saving = true
    av._saveError = null
    $http.post('/review/saveAgentOpinionOfValue', {
      crm_user_id: parseInt($scope.crm_user_id, 10),
      tax_year: parseInt($scope.tax_year, 10),
      user_id: report.user_id,
      prop_id: report.prop_id,
      cad_code: report.cad_code,
      cad_account: report.cad_account,
      starting_source: av.starting_source || null,
      starting_value: toWholeDollarsOrNull(av.starting_value),
      starting_manual_reason: av.starting_source === AGENT_STARTING_VALUE_MANUAL_SOURCE ? (av.manual_reason || null) : null,
      reduce_by: av.reduce_by || [],
      reduce_value: toWholeDollarsOrNull(av.reduce_value),
      agent_opv: toWholeDollarsOrNull(av.opinion_value)
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        av._savedSnapshot = snapshot
        applyAgentValuationSavedMeta(av, resp.data.data)
      } else {
        av._saveError = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save the agent valuation.'
      }
    }, function () {
      av._saveError = 'Unable to save the agent valuation.'
    }).finally(function () {
      av._saving = false
      // A change made while the last save was in flight
      if (av._savePending) {
        av._savePending = false
        $scope.saveAgentValuation(report)
      }
      safeApply($scope)
    })
  }

  $scope.tempReason = ''
  $scope.currentReportForReason = null

  var reasonModal = null
  const REVIEW_PORTAL_CHANGE_STORAGE_KEY = 'ep.review.portal.change'
  const REVIEW_PORTAL_CHANGE_BROADCAST = 'ep-review-portal-change'
  const PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY = 'ep.portal.open.edit.intent'
  const PORTAL_RETURN_REFRESH_DELAY_MS = 350
  const PORTAL_RETURN_MIN_AGE_MS = 800
  let clientPortalRefreshState = null
  let clientPortalRefreshTimer = null
  let clientPortalRefreshPromise = null
  let clientPortalBroadcast = null
  let onPortalFocus = null
  let onPortalStorage = null
  let onPortalVisibilityChange = null
  let hasLoggedStartupReviewObject = false
  let reportsLoadRequestId = 0
  let searchScopeAllCountiesActive = false

  // Review page Message Center state (reuses the Evidence Portal Message Center UI/CSS)
  $scope.portalMessages = []
  $scope.activeProp = null
  $scope.messageCenter = {
    view: 'list',
    selected: null,
    loading: false,
    error: null,
    expandedBodies: {},
    threadHasScrollbar: false,
    threadStickyReplyVisible: false
  }

  // Reviewer compose modal state (New Message / Reply)
  $scope.reviewCompose = {
    mode: null, // 'new' | 'reply'
    subject: '',
    needs_response: false,
    sending: false,
    error: null,
    cannedLoading: false,
    cannedError: null
  }

  $scope.responseManager = {
    items: [],
    loading: false,
    saving: false,
    deleting: false,
    error: null,
    form: {
      id: null,
      description: '',
      subject: ''
    }
  }

  // Cached CRM user record (from /review/checkCrmUser)
  $scope.crmUser = null

  $scope.trustHtml = function (html) {
    return $sce.trustAsHtml(html || '')
  }

  // Reference-only types (CMA / Zillow Info) are for the agents: never on the report, nothing to review
  function isReferenceOnlyFile(file) {
    const cfg = (file && allowedFileTypesConfig) ? allowedFileTypesConfig[String(file.content_type_key || '').toUpperCase()] : null
    return !!(cfg && cfg.referenceOnly)
  }
  $scope.isReferenceOnlyFile = isReferenceOnlyFile

  function getEvidenceUsageStatus(file) {
    try {
      if (!file) return 'pending'
      if (isReferenceOnlyFile(file)) return 'reference'
      if (Number(file.active) !== 1) return 'do_not_use_on_report'
      if (file.reviewed_by_id) return 'use_on_report'
      return 'pending'
    } catch (e) {
      return 'pending'
    }
  }

  const PHOTO_CONTENT_TYPE_KEYS = {
    PHOTO: true,
    PHOTOS_PDF: true,
    PHOTOS_DOCX: true
  }

  const REPAIR_REDUCTION_AMOUNT_FIELDS = {
    ESTIMATE_NEEDED_REPAIR: 'estimate_amount',
    INVOICE_REPAIRS_COMPLETED: 'invoice_amount',
    INSURANCE_CLAIM_DAMAGE: 'ins_claim_amount'
  }

  function isPhotoContentTypeKey(contentTypeKey) {
    try {
      const normalized = String(contentTypeKey || '').trim().toUpperCase()
      return !!PHOTO_CONTENT_TYPE_KEYS[normalized]
    } catch (e) {
      return false
    }
  }

  function shouldIncludeInRepairReduction(file) {
    try {
      const usageStatus = getEvidenceUsageStatus(file)
      return usageStatus === 'pending' || usageStatus === 'use_on_report'
    } catch (e) {
      return false
    }
  }

  function computeDerivedRevisedConditionTotal(report) {
    try {
      if (!report || !Array.isArray(report.evidence_files)) return 0

      return report.evidence_files.reduce(function (sum, file) {
        if (!file || !shouldIncludeInRepairReduction(file)) return sum

        const contentTypeKey = String(file.content_type_key || '').trim().toUpperCase()
        const amountField = REPAIR_REDUCTION_AMOUNT_FIELDS[contentTypeKey]
        if (!amountField) return sum

        const meta = file.meta_json || {}
        return sum + toMoneyNumber(meta[amountField])
      }, 0)
    } catch (e) {
      return 0
    }
  }

  function syncComputedRevisedConditionValue(report) {
    try {
      if (!report) return

      const derivedTotal = computeDerivedRevisedConditionTotal(report)
      applyRevisedConditionValue(report, derivedTotal, false)

      report.conditionOverrideSavedConditionValue = normalizeRevisedConditionValue(derivedTotal)
      if (report.conditionOverrideSavedConditionValue === '') report.conditionOverrideSavedConditionValue = '0'
    } catch (e) { }
  }

  function syncEvidenceUsageState(file) {
    try {
      if (!file) return 'pending'

      file.active = file.active === 1 ? 1 : 0
      file.reviewed_by_id = file.reviewed_by_id ? Number(file.reviewed_by_id) : null
      file.reviewed_by_name = file.reviewed_by_name ? String(file.reviewed_by_name) : null
      file.reviewed_by_initials = file.reviewed_by_initials ? String(file.reviewed_by_initials).trim().toUpperCase() : null
      file.usage_status = getEvidenceUsageStatus(file)

      return file.usage_status
    } catch (e) {
      if (file) file.usage_status = 'pending'
      return 'pending'
    }
  }

  function restoreEvidenceUsageState(file, snapshot) {
    if (!file || !snapshot) return
    file.active = snapshot.active
    file.reviewed_by_id = snapshot.reviewed_by_id
    file.reviewed_by_name = snapshot.reviewed_by_name
    file.reviewed_by_initials = snapshot.reviewed_by_initials
    file.reviewed_on = snapshot.reviewed_on
    file.updated_at = snapshot.updated_at
    file.usage_status = snapshot.usage_status
  }

  function getReportIdentity(report) {
    try {
      if (!report) return null

      const propId = report.prop_id != null ? String(report.prop_id) : ''
      const userId = report.user_id != null ? String(report.user_id) : ''
      const taxYear = report.tax_year != null ? String(report.tax_year) : ($scope.tax_year != null ? String($scope.tax_year) : '')

      if (!propId || !userId) return null
      return {
        prop_id: propId,
        user_id: userId,
        tax_year: taxYear
      }
    } catch (e) {
      return null
    }
  }

  function reportMatchesIdentity(report, identity) {
    try {
      const reportIdentity = getReportIdentity(report)
      if (!reportIdentity || !identity) return false
      if (reportIdentity.prop_id !== String(identity.prop_id || '')) return false
      if (reportIdentity.user_id !== String(identity.user_id || '')) return false

      const reportTaxYear = String(reportIdentity.tax_year || '')
      const identityTaxYear = String(identity.tax_year || '')
      if (reportTaxYear && identityTaxYear && reportTaxYear !== identityTaxYear) return false

      return true
    } catch (e) {
      return false
    }
  }

  function findReportByIdentity(identity) {
    try {
      if (!identity || !Array.isArray($scope.reports)) return null
      return $scope.reports.find(function (report) {
        return reportMatchesIdentity(report, identity)
      }) || null
    } catch (e) {
      return null
    }
  }

  // Previews load lazily as they scroll into view (see epLazyPreview directive).
  function expandEvidenceFiles(report) {
    try {
      if (!report || !Array.isArray(report.evidence_files)) return
      report.evidence_files.forEach(function (file) {
        if (!file) return
        file.expanded = true
        file._previewReady = false
      })
    } catch (e) { }
  }

  function applyEvidenceRefreshToken(report, refreshToken) {
    try {
      if (!report || !Array.isArray(report.evidence_files)) return
      const token = refreshToken || Date.now()
      report.evidence_files.forEach(function (file) {
        if (!file) return
        file._previewVersion = token
      })

      if ($scope.currentEvidence && Array.isArray(report.evidence_files)) {
        const currentIdentity = $scope.currentEvidence && $scope.currentEvidence.id != null
          ? String($scope.currentEvidence.id)
          : ''
        if (currentIdentity) {
          const updatedCurrent = report.evidence_files.find(function (file) {
            return file && file.id != null && String(file.id) === currentIdentity
          })
          if (updatedCurrent) $scope.currentEvidence = updatedCurrent
        }
      }
    } catch (e) { }
  }

  function appendCacheBust(url, token) {
    try {
      const base = String(url || '')
      if (!base) return base

      const hashIndex = base.indexOf('#')
      const rawUrl = hashIndex >= 0 ? base.substring(0, hashIndex) : base
      const hash = hashIndex >= 0 ? base.substring(hashIndex) : ''
      const separator = rawUrl.indexOf('?') >= 0 ? '&' : '?'

      return rawUrl + separator + 'epv=' + encodeURIComponent(String(token || '0')) + hash
    } catch (e) {
      return url
    }
  }

  $scope.getEvidenceAssetUrl = function (file) {
    try {
      if (!file) return ''
      const src = String(file.gcs_url || '')
      if (!src) return ''
      if (!file._previewVersion) return src
      return appendCacheBust(src, file._previewVersion)
    } catch (e) {
      return file && file.gcs_url ? String(file.gcs_url) : ''
    }
  }

  function rememberClientPortalReport(report) {
    const identity = getReportIdentity(report)
    if (!identity) return

    clientPortalRefreshState = {
      identity: identity,
      openedAt: Date.now(),
      changedAt: 0,
      lastRefreshAt: 0,
      awaitingReturn: true,
      dirty: false,
      refreshing: false
    }
  }

  function capturePortalRefreshContext(report) {
    const identity = getReportIdentity(report)
    const messageCenterReport = ($scope.messageCenter && $scope.messageCenter._activeReport) ? $scope.messageCenter._activeReport : null
    const activeProp = $scope.activeProp || null

    return {
      identity: identity,
      wasExpanded: !!(report && report.expanded),
      hadMessagesLoaded: !!(report && report.messagesLoaded),
      hadPropertyDetailsLoaded: !!(report && report.propertyDetailsLoaded),
      hadMessageCenterOpen: reportMatchesIdentity(messageCenterReport, identity),
      hadActiveProp: reportMatchesIdentity(activeProp, identity),
      hadAgentNotesTab: !!(report && report.expanded && report.infoExpanded && report.infoTab === 'notes' && $scope.agentNotes && $scope.agentNotes.report === report),
      hadOwnerNotesTab: !!(report && report.expanded && report.infoExpanded && report.infoTab === 'owner'),
      selectedMessageId: ($scope.messageCenter && $scope.messageCenter.selected && $scope.messageCenter.selected.message_id)
        ? Number($scope.messageCenter.selected.message_id)
        : null
    }
  }

  function clearClientPortalRefreshTimer() {
    try {
      if (!clientPortalRefreshTimer) return
      $window.clearTimeout(clientPortalRefreshTimer)
      clientPortalRefreshTimer = null
    } catch (e) {
      clientPortalRefreshTimer = null
    }
  }

  function isDocumentHidden() {
    try {
      if (typeof document === 'undefined') return false
      return !!document.hidden
    } catch (e) {
      return false
    }
  }

  function shouldRefreshFromPortalReturn() {
    try {
      if (!clientPortalRefreshState || !clientPortalRefreshState.identity) return false
      if (clientPortalRefreshPromise) return false

      const state = clientPortalRefreshState
      const latestRelevantAt = Math.max(Number(state.changedAt) || 0, Number(state.openedAt) || 0)
      if (!state.awaitingReturn && !state.dirty) return false
      if ((Date.now() - latestRelevantAt) < PORTAL_RETURN_MIN_AGE_MS) return false
      if ((Number(state.lastRefreshAt) || 0) >= latestRelevantAt) return false

      return true
    } catch (e) {
      return false
    }
  }

  function syncMessageCenterSelection(report, selectedMessageId) {
    try {
      if (!report) return
      $scope.portalMessages = Array.isArray(report.messages) ? report.messages : []
      $scope.activeProp = report
      if ($scope.messageCenter) {
        $scope.messageCenter._activeReport = report
        $scope.messageCenter.loading = false
        $scope.messageCenter.error = null
        if (selectedMessageId && Array.isArray($scope.portalMessages)) {
          const updated = $scope.portalMessages.find(function (message) {
            return message && Number(message.message_id) === Number(selectedMessageId)
          })
          if (updated) $scope.messageCenter.selected = updated
        }
      }
      safeApply($scope)
      scheduleReviewMessageCenterThreadScrollToTop()
    } catch (e) { }
  }

  function refreshReportFromPortalReturn(reportOrIdentity, options) {
    const identity = getReportIdentity(reportOrIdentity) || reportOrIdentity
    if (!identity || !identity.prop_id || !identity.user_id) return Promise.resolve(null)
    if (clientPortalRefreshPromise) return clientPortalRefreshPromise

    const report = findReportByIdentity(identity) || null
    const context = capturePortalRefreshContext(report)
    // The reload re-renders the row, so capture any unsaved note before its editor goes away
    if (context.hadAgentNotesTab) hideAgentNotesEditor()

    if (clientPortalRefreshState && reportMatchesIdentity(clientPortalRefreshState.identity, identity)) {
      clientPortalRefreshState.refreshing = true
    }

    clientPortalRefreshPromise = loadReports().then(function () {
      const refreshedReport = findReportByIdentity(identity)
      if (!refreshedReport) {
        safeApply($scope)
        return null
      }

      applyEvidenceRefreshToken(refreshedReport, Date.now())

      if (context.wasExpanded) {
        $scope.reports.forEach(function (item) {
          if (item) item.expanded = false
        })
        refreshedReport.expanded = true
        expandEvidenceFiles(refreshedReport)
        if (context.hadAgentNotesTab) {
          // Keep the tab open on the refreshed report without discarding the unsaved drafts
          refreshedReport.infoTab = 'notes'
          $scope.agentNotes.report = refreshedReport
          initAgentNotesEditor(getAgentNotesDraftForVisibility($scope.agentNotes.selectedVisibility))
        }
        if (context.hadOwnerNotesTab) {
          refreshedReport.infoTab = 'owner'
          refreshedReport.infoExpanded = true
        }
      }

      if (context.hadActiveProp) $scope.activeProp = refreshedReport
      if (context.hadMessageCenterOpen && $scope.messageCenter) {
        $scope.messageCenter._activeReport = refreshedReport
      }

      const followUpTasks = []
      if (context.wasExpanded || context.hadPropertyDetailsLoaded) {
        followUpTasks.push(ensureReportPropertyDetails(refreshedReport, true))
      }
      if (context.wasExpanded || context.hadMessagesLoaded || context.hadMessageCenterOpen) {
        followUpTasks.push(ensureReportMessages(refreshedReport, true).then(function () {
          if (context.hadMessageCenterOpen) syncMessageCenterSelection(refreshedReport, context.selectedMessageId)
          return refreshedReport.messages
        }))
      }

      safeApply($scope)
      return Promise.all(followUpTasks).then(function () {
        safeApply($scope)
        return refreshedReport
      })
    }).finally(function () {
      if (clientPortalRefreshState && reportMatchesIdentity(clientPortalRefreshState.identity, identity)) {
        clientPortalRefreshState.awaitingReturn = false
        clientPortalRefreshState.dirty = false
        clientPortalRefreshState.refreshing = false
        clientPortalRefreshState.lastRefreshAt = Date.now()
      }
      clientPortalRefreshPromise = null
      clearClientPortalRefreshTimer()
      safeApply($scope)
    })

    return clientPortalRefreshPromise
  }

  function schedulePortalReturnRefresh() {
    if (!shouldRefreshFromPortalReturn()) return

    clearClientPortalRefreshTimer()
    clientPortalRefreshTimer = $window.setTimeout(function () {
      clearClientPortalRefreshTimer()
      if (!shouldRefreshFromPortalReturn()) return
      refreshReportFromPortalReturn(clientPortalRefreshState.identity)
    }, PORTAL_RETURN_REFRESH_DELAY_MS)
  }

  function normalizePortalChangePayload(rawPayload) {
    try {
      const payload = (typeof rawPayload === 'string') ? JSON.parse(rawPayload) : rawPayload
      if (!payload || payload.prop_id == null || payload.user_id == null) return null
      return {
        prop_id: String(payload.prop_id),
        user_id: String(payload.user_id),
        tax_year: payload.tax_year != null ? String(payload.tax_year) : '',
        action: payload.action ? String(payload.action) : '',
        emitted_at: payload.emitted_at ? Number(payload.emitted_at) : Date.now()
      }
    } catch (e) {
      return null
    }
  }

  function handlePortalChangePayload(rawPayload) {
    const payload = normalizePortalChangePayload(rawPayload)
    if (!payload) return

    const report = findReportByIdentity(payload)
    if (!report && !(clientPortalRefreshState && reportMatchesIdentity(clientPortalRefreshState.identity, payload))) return

    if (!clientPortalRefreshState || !reportMatchesIdentity(clientPortalRefreshState.identity, payload)) {
      clientPortalRefreshState = {
        identity: {
          prop_id: String(payload.prop_id),
          user_id: String(payload.user_id),
          tax_year: String(payload.tax_year || '')
        },
        openedAt: Date.now(),
        changedAt: 0,
        lastRefreshAt: 0,
        awaitingReturn: false,
        dirty: false,
        refreshing: false
      }
    }

    clientPortalRefreshState.changedAt = Date.now()
    clientPortalRefreshState.dirty = true

    if (!isDocumentHidden()) schedulePortalReturnRefresh()
  }

  function bindPortalRefreshListeners() {
    if (!onPortalFocus) {
      onPortalFocus = function () {
        schedulePortalReturnRefresh()
      }
    }

    if (!onPortalStorage) {
      onPortalStorage = function (event) {
        try {
          if (!event || event.key !== REVIEW_PORTAL_CHANGE_STORAGE_KEY || !event.newValue) return
          handlePortalChangePayload(event.newValue)
        } catch (e2) { }
      }
    }

    if (!onPortalVisibilityChange) {
      onPortalVisibilityChange = function () {
        if (!isDocumentHidden()) schedulePortalReturnRefresh()
      }
    }

    try {
      $window.addEventListener('focus', onPortalFocus)
    } catch (e) { }

    try {
      $window.addEventListener('storage', onPortalStorage)
    } catch (e) { }

    try {
      if (typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', onPortalVisibilityChange)
      }
    } catch (e) { }

    try {
      if (!clientPortalBroadcast && $window && typeof $window.BroadcastChannel === 'function') {
        clientPortalBroadcast = new $window.BroadcastChannel(REVIEW_PORTAL_CHANGE_BROADCAST)
        clientPortalBroadcast.onmessage = function (event) {
          try {
            if (!event) return
            handlePortalChangePayload(event.data)
          } catch (e2) { }
        }
      }
    } catch (e) { }

    $scope.$on('$destroy', function () {
      try { $window.removeEventListener('focus', onPortalFocus) } catch (e) { }
      try { $window.removeEventListener('storage', onPortalStorage) } catch (e) { }
      try {
        if (typeof document !== 'undefined') {
          document.removeEventListener('visibilitychange', onPortalVisibilityChange)
        }
      } catch (e) { }
      clearClientPortalRefreshTimer()
      try {
        if (clientPortalBroadcast && typeof clientPortalBroadcast.close === 'function') clientPortalBroadcast.close()
      } catch (e) { }
      clientPortalBroadcast = null
    })
  }

  $scope.getSliderLabelStyle = function (report) {
    var pDetails = report && report.propertyDetails
    if (!pDetails || !pDetails.input || pDetails.input.type !== 'slider') return { display: 'none' }

    var min = Number(pDetails.input.min)
    var max = Number(pDetails.input.max)
    var val = Number(pDetails.input_value)

    if (isNaN(min) || isNaN(max) || isNaN(val)) return { display: 'none' }
    if (max === min) return { left: '0%', transform: 'translateX(0)' }

    var percent = (val - min) / (max - min)
    var offset = 8 - (16 * percent)

    return {
      left: 'calc(' + (percent * 100) + '% + ' + offset + 'px)',
      transform: 'translateX(-50%)'
    }
  }

  $scope.getSliderLabelText = function (report) {
    try {
      var pDetails = report && report.propertyDetails
      if (!pDetails || !pDetails.input || pDetails.input.type !== 'slider') return ''

      var rawValue = Number(pDetails.input_value)
      if (!isFinite(rawValue)) return ''

      var inputName = pDetails.input.name ? String(pDetails.input.name).toLowerCase() : ''
      var inputLabel = pDetails.input.label ? String(pDetails.input.label).toLowerCase() : ''
      var header = pDetails.custom_field_header ? String(pDetails.custom_field_header).toLowerCase() : ''
      var isEffectiveYearBuilt = inputName.indexOf('effective_year_built') !== -1
        || inputLabel.indexOf('effective year built') !== -1
        || header.indexOf('effective year built') !== -1

      if (isEffectiveYearBuilt) {
        var sliderYear = Math.round(rawValue)
        var baseYear = Number(pDetails.custom_field_value)
        if (!isFinite(baseYear)) baseYear = Number(pDetails.year_built)
        if (!isFinite(baseYear)) return String(sliderYear)

        baseYear = Math.round(baseYear)
        var yearDiff = sliderYear - baseYear
        var diffLabel = (yearDiff >= 0 ? '+' : '') + String(yearDiff)
        var suffix = Math.abs(yearDiff) === 1 ? 'year' : 'years'

        return sliderYear + ' / ' + diffLabel + ' ' + suffix
      }

      return rawValue + ' / ' + (rawValue * 100).toFixed(0) + '%'
    } catch (e) {
      return ''
    }
  }

  function messageCenterIsNarrow() {
    try {
      if (!$window || typeof $window.matchMedia !== 'function') return false
      return $window.matchMedia('(max-width: 991.98px)').matches
    } catch (e) {
      return false
    }
  }
  $scope.messageCenterIsNarrow = messageCenterIsNarrow

  function messageCenterBodyKey(item, kind) {
    try {
      if (!item) return null
      let id = item.message_id || item.id
      id = id != null ? String(id) : ''
      if (!id) return null
      return String(kind || 'item') + ':' + id
    } catch (e) {
      return null
    }
  }

  function stripHtmlToText(html) {
    try {
      let s = String(html || '')
      s = s.replace(/<[^>]*>/g, ' ')
      s = s.replace(/&nbsp;/gi, ' ')
      s = s.replace(/&amp;/gi, '&')
      s = s.replace(/&lt;/gi, '<')
      s = s.replace(/&gt;/gi, '>')
      s = s.replace(/&quot;/gi, '"')
      s = s.replace(/&#39;/gi, "'")
      s = s.replace(/\s+/g, ' ').trim()
      return s
    } catch (e) {
      return ''
    }
  }

  function messageCenterLooksLong(html) {
    try {
      let raw = String(html || '')
      if (!raw) return false
      let breaks = (raw.match(/<br\s*\/?\s*>|<\s*\/\s*p\s*>/gi) || []).length
      if (breaks >= 2) return true
      let text = stripHtmlToText(raw)
      return text.length > 160
    } catch (e) {
      return false
    }
  }

  $scope.messageCenterIsBodyExpanded = function (item, kind) {
    try {
      let key = messageCenterBodyKey(item, kind)
      if (!key) return false
      let map = ($scope.messageCenter && $scope.messageCenter.expandedBodies) ? $scope.messageCenter.expandedBodies : {}
      return !!map[key]
    } catch (e) {
      return false
    }
  }

  $scope.messageCenterShouldShowBodyToggle = function (item) {
    try {
      if (!item) return false
      return messageCenterLooksLong(item.message_text)
    } catch (e) {
      return false
    }
  }

  $scope.messageCenterToggleBodyExpanded = function (item, kind) {
    try {
      let key = messageCenterBodyKey(item, kind)
      if (!key) return
      if (!$scope.messageCenter.expandedBodies) $scope.messageCenter.expandedBodies = {}
      let next = !$scope.messageCenter.expandedBodies[key]
      $scope.messageCenter.expandedBodies[key] = next
      safeApply($scope)
    } catch (e) { }
  }

  $scope.portalDate = function (value) {
    try {
      if (!value) return null
      if (value instanceof Date) return value
      if (typeof value === 'number') {
        let d = new Date(value)
        return isNaN(d.getTime()) ? null : d
      }
      if (typeof value !== 'string') return null

      let s = String(value).trim()
      if (!s) return null

      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
        let normalized = s.replace(' ', 'T')
        normalized = normalized.replace(/\.\d+$/, '')
        let d = new Date(normalized)
        return isNaN(d.getTime()) ? null : d
      }

      let d = new Date(s)
      return isNaN(d.getTime()) ? null : d
    } catch (e) {
      return null
    }
  }

  function getCurrentAgentId() {
    try {
      if ($scope.crmUser && $scope.crmUser.id) return Number($scope.crmUser.id)
      if ($scope.crm_user_id) return Number($scope.crm_user_id)
      return null
    } catch (e) {
      return null
    }
  }

  function isAgentNotePublic(note) {
    return !!(note && note.show_on_report === 1)
  }

  function getAgentNoteVisibilityValue(note) {
    return isAgentNotePublic(note) ? 'public' : 'private'
  }

  function getAgentNoteVisibilityLabel(note) {
    return isAgentNotePublic(note) ? 'Public - Show on Report' : 'Private - Internal Note'
  }

  function normalizeAgentNoteVisibility(visibility) {
    return visibility === 'public' ? 'public' : 'private'
  }

  function getAgentNoteSlotLabel(visibility) {
    return normalizeAgentNoteVisibility(visibility) === 'public' ? 'Public Note' : 'Private Note'
  }

  function normalizeAgentNotesListFilter(filterValue) {
    const value = String(filterValue || '').trim().toLowerCase()
    if (value === 'public') return 'public'
    if (value === 'private') return 'private'
    return 'all'
  }

  function getAgentNoteEntryKey(note) {
    if (!note) return null
    if (note.id) return 'id:' + Number(note.id)
    if (note.agent_id) return 'agent:' + Number(note.agent_id) + ':visibility:' + getAgentNoteVisibilityValue(note)
    return null
  }

  function normalizeAgentNoteEntry(note) {
    try {
      if (!note || typeof note !== 'object') return null
      return {
        id: note.id ? Number(note.id) : null,
        agent_id: note.agent_id ? Number(note.agent_id) : null,
        agent_name: note.agent_name ? String(note.agent_name) : null,
        notes: (typeof note.notes === 'undefined' || note.notes === null) ? '' : String(note.notes),
        show_on_report: (note.show_on_report === 1 || note.show_on_report === '1' || note.show_on_report === true || note.show_on_report === 'true') ? 1 : 0,
        use_on_cover_page: (note.use_on_cover_page === 1 || note.use_on_cover_page === '1' || note.use_on_cover_page === true || note.use_on_cover_page === 'true') ? 1 : 0,
        updated_at: note.updated_at ? $scope.portalDate(note.updated_at) : null,
        visibility: getAgentNoteVisibilityValue(note)
      }
    } catch (e) {
      return null
    }
  }

  function sortAgentNotesDescending(notes) {
    return notes.sort(function (a, b) {
      const aTime = (a && a.updated_at instanceof Date && !isNaN(a.updated_at.getTime())) ? a.updated_at.getTime() : 0
      const bTime = (b && b.updated_at instanceof Date && !isNaN(b.updated_at.getTime())) ? b.updated_at.getTime() : 0
      return bTime - aTime
    })
  }

  function normalizeAgentNotesCollection(notes, report) {
    let source = notes
    if (typeof source === 'string') {
      try { source = JSON.parse(source) } catch (e) { source = [] }
    }
    if (!Array.isArray(source)) source = []

    const normalized = []
    const seen = {}

    source.forEach(function (note) {
      const item = normalizeAgentNoteEntry(note)
      if (!item) return
      const key = getAgentNoteEntryKey(item)
      if (key && seen[key]) return
      if (key) seen[key] = true
      normalized.push(item)
    })

    if (report) {
      const fallback = normalizeAgentNoteEntry({
        id: report.agent_note_id,
        agent_id: getCurrentAgentId(),
        agent_name: report.agent_note_agent_name,
        notes: report.agent_notes,
        show_on_report: report.agent_note_show_on_report,
        use_on_cover_page: report.agent_note_use_on_cover_page,
        updated_at: report.agent_note_updated_at
      })

      if (fallback && (fallback.id || fallback.agent_id || fallback.agent_name || isMeaningfulHtml(fallback.notes))) {
        const fallbackKey = getAgentNoteEntryKey(fallback)
        if (!fallbackKey || !seen[fallbackKey]) normalized.push(fallback)
      }
    }

    return sortAgentNotesDescending(normalized)
  }

  function getDisplayAgentNotes(report) {
    if (!report) return []
    const notes = Array.isArray(report.agent_notes_all) ? report.agent_notes_all : []
    return notes.filter(function (note) {
      return isMeaningfulHtml(note && note.notes)
    })
  }

  function getFilteredDisplayAgentNotes(report, filterValue) {
    const notes = getDisplayAgentNotes(report)
    const filter = normalizeAgentNotesListFilter(filterValue)
    if (filter === 'public') {
      return notes.filter(function (note) { return isAgentNotePublic(note) })
    }
    if (filter === 'private') {
      return notes.filter(function (note) { return !isAgentNotePublic(note) })
    }
    return notes
  }

  function getAgentNotesFilterCount(report, filterValue) {
    return getFilteredDisplayAgentNotes(report, filterValue).length
  }

  function getCurrentAgentNotes(report) {
    const currentAgentId = getCurrentAgentId()
    if (!currentAgentId) return []
    return getDisplayAgentNotes(report).filter(function (note) {
      return note && note.agent_id && Number(note.agent_id) === Number(currentAgentId)
    })
  }

  function syncLegacyCurrentAgentNoteFields(report) {
    if (!report) return

    const notes = sortAgentNotesDescending(getCurrentAgentNotes(report).slice())
    const currentNote = notes.length ? notes[0] : null

    report.agent_note_id = currentNote && currentNote.id ? Number(currentNote.id) : null
    report.agent_notes = currentNote && typeof currentNote.notes !== 'undefined' ? String(currentNote.notes) : ''
    report.agent_note_show_on_report = currentNote && currentNote.show_on_report === 1 ? 1 : 0
    report.agent_note_use_on_cover_page = currentNote && currentNote.use_on_cover_page === 1 ? 1 : 0
    report.agent_note_updated_at = currentNote && currentNote.updated_at ? currentNote.updated_at : null
    report.agent_note_agent_name = currentNote && currentNote.agent_name ? String(currentNote.agent_name) : null
  }

  function upsertAgentNoteInCollection(report, note) {
    if (!report) return null

    const nextNote = normalizeAgentNoteEntry(note)
    if (!nextNote) return null

    let notes = Array.isArray(report.agent_notes_all) ? report.agent_notes_all.slice() : []
    notes = notes.filter(function (item) {
      if (!item) return false
      return !(nextNote.id && item.id && Number(item.id) === Number(nextNote.id))
    })

    if (isMeaningfulHtml(nextNote.notes)) notes.push(nextNote)

    report.agent_notes_all = normalizeAgentNotesCollection(notes, null)
    syncLegacyCurrentAgentNoteFields(report)
    return nextNote
  }

  function removeAgentNoteFromCollection(report, noteId) {
    if (!report) return
    const noteIdNum = Number(noteId)
    let notes = Array.isArray(report.agent_notes_all) ? report.agent_notes_all.slice() : []
    notes = notes.filter(function (item) {
      if (!item) return false
      if (!noteIdNum || !item.id) return true
      return Number(item.id) !== noteIdNum
    })
    report.agent_notes_all = normalizeAgentNotesCollection(notes, null)
    syncLegacyCurrentAgentNoteFields(report)
  }

  $scope.getDisplayAgentNotes = function (report) {
    return getDisplayAgentNotes(report)
  }

  // The Private / Public tabs in the Agent Notes panel list only the notes for the selected visibility
  $scope.getFilteredDisplayAgentNotes = function (report) {
    return getFilteredDisplayAgentNotes(report, normalizeAgentNoteVisibility($scope.agentNotes && $scope.agentNotes.selectedVisibility))
  }

  $scope.getAgentNotesFilterCount = function (report, filterValue) {
    return getAgentNotesFilterCount(report, filterValue)
  }

  $scope.isCurrentAgentNote = function (note) {
    try {
      const currentAgentId = getCurrentAgentId()
      if (!currentAgentId || !note || !note.agent_id) return false
      return Number(note.agent_id) === Number(currentAgentId)
    } catch (e) {
      return false
    }
  }

  $scope.messageCenterThreadSortValue = function (m) {
    try {
      if (!m) return 0
      return $scope.portalDate(m.latest_activity || m.updated_at || m.created_at) || 0
    } catch (e) {
      return 0
    }
  }

  // Right column of the Message Center: every agent message in a thread is its own email, so the thread is shown as
  // groups - the original email's group first, then each later agent email (newest first) - with the client replies
  // indented under the email they answer. A client reply belongs to the latest agent email sent before it.
  // Cached on the thread so ng-repeat gets the same objects each digest; rebuilt when its replies change.
  $scope.getMessageCenterThreadGroups = function (thread) {
    try {
      if (!thread) return []
      const replies = Array.isArray(thread.replies) ? thread.replies : []
      const cacheKey = replies.map(function (r) { return (r && r.message_id) + ':' + (r && r.sender_type) + ':' + (r && r.created_at) }).join('|')
      if (thread._threadGroups && thread._threadGroupsKey === cacheKey) return thread._threadGroups

      const byOldest = replies.filter(Boolean).slice().sort(function (a, b) {
        return $scope.messageCenterReplySortValue(a) - $scope.messageCenterReplySortValue(b)
      })

      const rootGroup = { key: 'root', email: null, emailList: [], replies: [] }
      const emailGroups = []
      let current = rootGroup
      byOldest.forEach(function (r) {
        if (normalizeSenderType(r.sender_type) === 'employee') {
          current = { key: 'email-' + (r.message_id || emailGroups.length), email: r, emailList: [r], replies: [] }
          emailGroups.push(current)
        } else {
          current.replies.push(r)
        }
      })

      const newestFirst = function (a, b) { return $scope.messageCenterReplySortValue(b) - $scope.messageCenterReplySortValue(a) }
      rootGroup.replies.sort(newestFirst)
      emailGroups.forEach(function (g) { g.replies.sort(newestFirst) })
      emailGroups.sort(function (a, b) { return newestFirst(a.email, b.email) })

      thread._threadGroupsKey = cacheKey
      thread._threadGroups = [rootGroup].concat(emailGroups)
      return thread._threadGroups
    } catch (e) {
      return []
    }
  }

  $scope.messageCenterReplySortValue = function (r) {
    try {
      if (!r) return 0
      return $scope.portalDate(r.created_at) || 0
    } catch (e) {
      return 0
    }
  }

  $scope.messageCenterRelativeAgeLabel = function (value) {
    try {
      let d = $scope.portalDate(value)
      if (!d) return ''
      let ms = Date.now() - d.getTime()
      if (!isFinite(ms)) return ''
      if (ms < 0) ms = 0

      let minutes = Math.floor(ms / (60 * 1000))
      let hours = Math.floor(ms / (60 * 60 * 1000))
      let days = Math.floor(ms / (24 * 60 * 60 * 1000))

      function plural(n, unit) {
        return n === 1 ? unit : unit + 's'
      }

      if (ms < (60 * 60 * 1000)) {
        let m = Math.max(1, minutes)
        return m + ' ' + plural(m, 'minute') + ' ago'
      }
      if (ms < (24 * 60 * 60 * 1000)) {
        let h = Math.max(1, hours)
        return h + ' ' + plural(h, 'hour') + ' ago'
      }
      if (ms < (48 * 60 * 60 * 1000)) {
        let dd = Math.max(1, days)
        return dd + ' ' + plural(dd, 'day') + ' ago'
      }
      if (ms < (96 * 60 * 60 * 1000)) {
        let hh = Math.max(1, hours)
        return hh + ' ' + plural(hh, 'hour') + ' ago'
      }

      let dd = Math.max(1, days)
      return dd + ' ' + plural(dd, 'day') + ' ago'
    } catch (e) {
      return ''
    }
  }

  function normalizeSenderType(senderType) {
    try {
      return String(senderType || '').trim().toLowerCase()
    } catch (e) {
      return ''
    }
  }

  function hasPortalMessageUnreadFlag(obj) {
    try {
      if (!obj) return false
      if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 0
      if (typeof obj.read !== 'undefined') return Number(obj.read) === 0
      if (typeof obj.read_at !== 'undefined') return !obj.read_at
      return false
    } catch (e) {
      return false
    }
  }

  function hasPortalMessageReadFlag(obj) {
    try {
      if (!obj) return false
      if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 1
      if (typeof obj.read !== 'undefined') return Number(obj.read) === 1
      if (typeof obj.read_at !== 'undefined') return !!obj.read_at
      return false
    } catch (e) {
      return false
    }
  }

  function getPortalMessageReminderSentAt(item) {
    try {
      if (!item) return null
      return $scope.portalDate(item.needs_response_sent_at || item.created_at || item.updated_at)
    } catch (e) {
      return null
    }
  }

  function isPortalMessageAwaitingResponse(item, threadRoot) {
    try {
      if (!item) return false
      if (normalizeSenderType(item.sender_type) !== 'employee') return false
      if (toInt(item.needs_response) !== 1) return false

      const sentAt = getPortalMessageReminderSentAt(item)
      if (!sentAt) return false

      const root = threadRoot || item
      const laterClientReplyExists = (Array.isArray(root && root.replies) ? root.replies : []).some(function (reply) {
        if (!reply) return false
        if (normalizeSenderType(reply.sender_type) !== 'client') return false
        const replyDate = $scope.portalDate(reply.created_at || reply.updated_at)
        return !!(replyDate && replyDate.getTime() > sentAt.getTime())
      })

      return !laterClientReplyExists
    } catch (e) {
      return false
    }
  }

  function isPortalMessageResponseOverdue(item, threadRoot) {
    try {
      if (!isPortalMessageAwaitingResponse(item, threadRoot)) return false
      const sentAt = getPortalMessageReminderSentAt(item)
      if (!sentAt) return false
      return (Date.now() - sentAt.getTime()) >= (3 * 24 * 60 * 60 * 1000)
    } catch (e) {
      return false
    }
  }

  function getPortalThreadLatestMessage(thread) {
    try {
      if (!thread) return null
      const items = [thread].concat(Array.isArray(thread.replies) ? thread.replies : [])
      let latestItem = null
      let latestTime = 0

      items.forEach(function (item) {
        if (!item) return
        const itemDate = $scope.portalDate(item.created_at || item.updated_at)
        const itemTime = (itemDate && !isNaN(itemDate.getTime())) ? itemDate.getTime() : 0
        if (!latestItem || itemTime >= latestTime) {
          latestItem = item
          latestTime = itemTime
        }
      })

      return latestItem
    } catch (e) {
      return null
    }
  }

  function getPortalThreadOverdueCount(thread) {
    try {
      if (!thread) return 0
      const latestItem = getPortalThreadLatestMessage(thread)
      if (latestItem && normalizeSenderType(latestItem.sender_type) === 'client') return 0
      let count = isPortalMessageResponseOverdue(thread, thread) ? 1 : 0
      count += (Array.isArray(thread.replies) ? thread.replies : []).reduce(function (sum, reply) {
        return sum + (isPortalMessageResponseOverdue(reply, thread) ? 1 : 0)
      }, 0)
      return count
    } catch (e) {
      return 0
    }
  }

  function getPortalThreadAwaitingResponseCount(thread) {
    try {
      if (!thread) return 0
      const latestItem = getPortalThreadLatestMessage(thread)
      if (latestItem && normalizeSenderType(latestItem.sender_type) === 'client') return 0
      let count = isPortalMessageAwaitingResponse(thread, thread) ? 1 : 0
      count += (Array.isArray(thread.replies) ? thread.replies : []).reduce(function (sum, reply) {
        return sum + (isPortalMessageAwaitingResponse(reply, thread) ? 1 : 0)
      }, 0)
      return count
    } catch (e) {
      return 0
    }
  }

  $scope.isPortalMessageResponseOverdue = function (item, threadRoot) {
    return isPortalMessageResponseOverdue(item, threadRoot)
  }

  // An agent message whose email the client has opened counts as read, even if they never opened it in the portal
  function isMessageEmailOpened(item) {
    try {
      const events = $scope.getMessageEmailEvents(item)
      return !!(events && Array.isArray(events.opens) && events.opens.length)
    } catch (e) {
      return false
    }
  }

  $scope.hasPortalMessageUnreadFlag = function (item) {
    return hasPortalMessageUnreadFlag(item) && !isMessageEmailOpened(item)
  }

  $scope.hasPortalMessageReadFlag = function (item) {
    return hasPortalMessageReadFlag(item) || isMessageEmailOpened(item)
  }

  $scope.getPortalThreadOverdueCount = function (thread) {
    return getPortalThreadOverdueCount(thread)
  }

  $scope.getPortalThreadAwaitingResponseCount = function (thread) {
    return getPortalThreadAwaitingResponseCount(thread)
  }


  $scope.portalSenderTypeLabel = function (senderType) {
    let t = normalizeSenderType(senderType)
    if (t === 'employee') return 'Agent'
    if (t === 'client') return 'Property Owner'
    return senderType
  }

  $scope.portalSenderLabel = function (obj) {
    try {
      if (!obj) return 'Unknown'
      if (obj.sender_name) return obj.sender_name
      if (obj.sender_type) return $scope.portalSenderTypeLabel(obj.sender_type)
      return 'Unknown'
    } catch (e) {
      return 'Unknown'
    }
  }

  $scope.getReviewedTooltip = function (report) {
    try {
      if (!report || !report.reviewed_by_id) return ''
      const name = report.reviewed_by_name ? String(report.reviewed_by_name) : 'Unknown'
      const d = $scope.portalDate(report.reviewed_on)
      let dateLine = ''
      if (d) {
        const month = d.getMonth() + 1
        const day = d.getDate()
        const year = d.getFullYear()
        let hours = d.getHours()
        const ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        if (hours === 0) hours = 12
        const minutes = String(d.getMinutes()).padStart(2, '0')
        dateLine = month + '-' + day + '-' + year + ' @ ' + hours + ':' + minutes + ' ' + ampm
      }
      return (
        '<div class="text-start">' +
        '<div class="fw-bold">This report was reviewed by:</div>' +
        '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
        '<div>' + name + '</div>' +
        (dateLine ? '<div>' + dateLine + '</div>' : '') +
        '</div>'
      )
    } catch (e) {
      return ''
    }
  }

  function getReviewerDisplayInitials(initials, name) {
    try {
      const explicitInitials = initials ? String(initials).trim().toUpperCase() : ''
      if (explicitInitials) return explicitInitials

      const text = name ? String(name).trim() : ''
      if (!text) return ''

      const parts = text.split(/\s+/).filter(Boolean)
      if (parts.length >= 2) {
        const first = parts[0].replace(/[^A-Za-z0-9]/g, '')
        const last = parts[parts.length - 1].replace(/[^A-Za-z0-9]/g, '')
        return (first.slice(0, 1) + last.slice(0, 2)).toUpperCase()
      }

      return text.replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase()
    } catch (e) {
      return ''
    }
  }

  function formatShortReviewDate(value) {
    try {
      const d = $scope.portalDate(value)
      if (!d) return ''
      const month = d.getMonth() + 1
      const day = d.getDate()
      const year = String(d.getFullYear()).slice(-2)
      return month + '/' + day + '/' + year
    } catch (e) {
      return ''
    }
  }

  $scope.getReviewStatusDisplay = function (report) {
    try {
      const baseLabel = report && report.review_status_label ? String(report.review_status_label) : 'Not Reviewed'
      if (!report || report.reviewed_toggle !== 1) return baseLabel

      const parts = [baseLabel]
      const initials = getReviewerDisplayInitials(report.reviewed_by_initials, report.reviewed_by_name)
      const shortDate = formatShortReviewDate(report.reviewed_on)

      if (initials) parts.push(initials)
      if (shortDate) parts.push(shortDate)

      return parts.join(' - ')
    } catch (e) {
      return 'Not Reviewed'
    }
  }

  function recomputeReportReviewedToggle(report) {
    try {
      if (!report || !Array.isArray(report.evidence_files) || report.evidence_files.length === 0) {
        report.reviewed_toggle = 0
        report.reviewed_item_count = 0
        report.total_item_count = 0
        report.use_on_report_item_count = 0
        report.use_on_report_photo_count = 0
        report.use_on_report_document_count = 0
        report.report_ready = 0
        report.review_status_label = 'Not Reviewed'
        report.review_progress_label = '0 of 0 items reviewed'
        report.report_status_label = 'No Report'
        syncComputedRevisedConditionValue(report)
        return
      }

      const totalItems = report.evidence_files.length
      const reviewedCount = report.evidence_files.reduce(function (sum, f) {
        return sum + (getEvidenceUsageStatus(f) !== 'pending' ? 1 : 0)
      }, 0)
      const useOnReportCount = report.evidence_files.reduce(function (sum, f) {
        return sum + (getEvidenceUsageStatus(f) === 'use_on_report' ? 1 : 0)
      }, 0)
      const useOnReportPhotoCount = report.evidence_files.reduce(function (sum, f) {
        if (getEvidenceUsageStatus(f) !== 'use_on_report') return sum
        return sum + (isPhotoContentTypeKey(f && f.content_type_key) ? 1 : 0)
      }, 0)
      const useOnReportDocumentCount = report.evidence_files.reduce(function (sum, f) {
        if (getEvidenceUsageStatus(f) !== 'use_on_report') return sum
        return sum + (isPhotoContentTypeKey(f && f.content_type_key) ? 0 : 1)
      }, 0)
      const allReviewed = totalItems > 0 && reviewedCount === totalItems
      const lastReviewedFile = allReviewed ? report.evidence_files.reduce(function (latest, f) {
        if (!f || !f.reviewed_by_id) return latest
        const currentReviewedOn = f.reviewed_on ? $scope.portalDate(f.reviewed_on) : null
        if (!latest) {
          return {
            reviewed_by_id: f.reviewed_by_id,
            reviewed_by_name: f.reviewed_by_name || '',
            reviewed_by_initials: f.reviewed_by_initials || '',
            reviewed_on: currentReviewedOn || f.reviewed_on || null
          }
        }
        const latestReviewedOn = latest.reviewed_on ? $scope.portalDate(latest.reviewed_on) : null
        if (currentReviewedOn && (!latestReviewedOn || currentReviewedOn > latestReviewedOn)) {
          return {
            reviewed_by_id: f.reviewed_by_id,
            reviewed_by_name: f.reviewed_by_name || '',
            reviewed_by_initials: f.reviewed_by_initials || '',
            reviewed_on: currentReviewedOn
          }
        }
        return latest
      }, null) : null

      report.reviewed_toggle = allReviewed ? 1 : 0
      report.reviewed_by_id = lastReviewedFile ? lastReviewedFile.reviewed_by_id : null
      report.reviewed_by_name = lastReviewedFile ? lastReviewedFile.reviewed_by_name : ''
      report.reviewed_by_initials = lastReviewedFile ? lastReviewedFile.reviewed_by_initials : ''
      report.reviewed_on = lastReviewedFile ? lastReviewedFile.reviewed_on : null
      report.reviewed_item_count = reviewedCount
      report.total_item_count = totalItems
      report.use_on_report_item_count = useOnReportCount
      report.use_on_report_photo_count = useOnReportPhotoCount
      report.use_on_report_document_count = useOnReportDocumentCount
      report.report_ready = (allReviewed && useOnReportCount > 0) ? 1 : 0
      report.review_status_label = allReviewed ? 'Reviewed' : 'Not Reviewed'
      report.review_progress_label = reviewedCount + ' of ' + totalItems + ' items reviewed'
      report.report_status_label = report.report_ready === 1
        ? ('Report: ' + useOnReportCount + ' of ' + totalItems)
        : 'No Report'
      syncComputedRevisedConditionValue(report)
    } catch (e) {
      report.reviewed_toggle = 0
      report.reviewed_item_count = 0
      report.total_item_count = 0
      report.use_on_report_item_count = 0
      report.use_on_report_photo_count = 0
      report.use_on_report_document_count = 0
      report.report_ready = 0
      report.review_status_label = 'Not Reviewed'
      report.review_progress_label = '0 of 0 items reviewed'
      report.report_status_label = 'No Report'
      syncComputedRevisedConditionValue(report)
    }
  }

  // Review context: unread = unread messages from the client.
  $scope.isPortalMessageUnread = function (obj) {
    try {
      if (!obj) return false
      if (String(obj.sender_type || '').toLowerCase() !== 'client') return false
      if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 0
      if (typeof obj.read !== 'undefined') return Number(obj.read) === 0
      if (typeof obj.read_at !== 'undefined') return !obj.read_at
      return false
    } catch (e) {
      return false
    }
  }

  let _reviewMessageCenterModal = null
  let _reviewMessageCenterModalBound = false
  let _reviewMessageCenterThreadScrollBound = false
  let _reviewMessageCenterThreadOnScroll = null
  let _reviewMessageCenterThreadScrollEl = null

  let _reviewComposeModal = null
  let _reviewComposeModalBound = false
  let _reviewComposeEditorInitToken = 0

  let _responseManagerModal = null
  let _responseManagerModalBound = false
  let _responseManagerEditorInitToken = 0
  let _responseDeleteConfirmModal = null
  let _responseDeleteConfirmModalBound = false

  let _agentNoteDeleteConfirmModal = null
  let _agentNoteDeleteConfirmModalBound = false
  let _agentNotesEditorInitToken = 0

  let _reviewNestedEvidenceDropdownBound = false

  function bindReviewNestedEvidenceDropdownZIndexFix() {
    try {
      if (_reviewNestedEvidenceDropdownBound) return
      _reviewNestedEvidenceDropdownBound = true
      if (!$window || !$window.document) return

      let doc = $window.document

      function getNestedEvidenceHeaderThFromEvent(evt) {
        try {
          let el = evt && evt.target ? evt.target : null
          if (!el || !el.closest) return null
          if (!el.closest('.ep-review-nested-table-container')) return null
          return el.closest('th')
        } catch (e) {
          return null
        }
      }

      doc.addEventListener('shown.bs.dropdown', function (evt) {
        try {
          let th = getNestedEvidenceHeaderThFromEvent(evt)
          if (!th) return
          th.classList.add('ep-review-dropdown-open')
        } catch (e) { }
      })

      doc.addEventListener('hidden.bs.dropdown', function (evt) {
        try {
          let th = getNestedEvidenceHeaderThFromEvent(evt)
          if (!th) return
          th.classList.remove('ep-review-dropdown-open')
        } catch (e) { }
      })
    } catch (e) { }
  }

  // Bind once for the review reports page.
  bindReviewNestedEvidenceDropdownZIndexFix()

  function getReviewMessageCenterModal() {
    try {
      bindReviewNestedEvidenceDropdownZIndexFix()
      let el = document.getElementById('epReviewMessageCenterModal')
      if (!el) return null
      if (!_reviewMessageCenterModal && $window.bootstrap && $window.bootstrap.Modal) {
        _reviewMessageCenterModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_reviewMessageCenterModalBound) {
        _reviewMessageCenterModalBound = true
        el.addEventListener('shown.bs.modal', function () {
          try {
            bindReviewMessageCenterThreadScroll()
            scheduleReviewMessageCenterThreadScrollToTop()
          } catch (e) { }
        })
        el.addEventListener('hidden.bs.modal', function () {
          try { unbindReviewMessageCenterThreadScroll() } catch (e) { }
          $scope.messageCenter.view = 'list'
          $scope.messageCenter.selected = null
          $scope.messageCenter.loading = false
          $scope.messageCenter.error = null
          $scope.messageCenter.expandedBodies = {}
          $scope.messageCenter.threadHasScrollbar = false
          $scope.messageCenter.threadStickyReplyVisible = false
          safeApply($scope)
        })
      }
      return _reviewMessageCenterModal
    } catch (e) {
      return null
    }
  }

  function getReviewMessageCenterThreadScrollEl() {
    try {
      let modalEl = document.getElementById('epReviewMessageCenterModal')
      if (!modalEl) return null
      return modalEl.querySelector('.ep-msgcenter__gridCol--right')
    } catch (e) {
      return null
    }
  }

  function normalizeResponseManagerItem(item) {
    try {
      if (!item || typeof item !== 'object') return null
      return {
        id: item.id ? Number(item.id) : null,
        user_id: item.user_id ? Number(item.user_id) : null,
        description: String(item.description || ''),
        subject: String(item.subject || ''),
        message: String(item.message || ''),
        createdAT: item.createdAT ? $scope.portalDate(item.createdAT) : null,
        updatedAT: item.updatedAT ? $scope.portalDate(item.updatedAT) : null
      }
    } catch (e) {
      return null
    }
  }

  function setResponseManagerForm(item) {
    const normalized = normalizeResponseManagerItem(item)
    $scope.responseManager.form.id = normalized && normalized.id ? normalized.id : null
    $scope.responseManager.form.description = normalized ? normalized.description : ''
    $scope.responseManager.form.subject = normalized ? normalized.subject : ''
    $scope.responseManager.error = null
    setResponseManagerEditorHtml(normalized ? normalized.message : '')
    safeApply($scope)
  }

  function getResponseManagerModal() {
    try {
      let el = document.getElementById('epResponseManagerModal')
      if (!el) return null
      if (!_responseManagerModal && $window.bootstrap && $window.bootstrap.Modal) {
        _responseManagerModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_responseManagerModalBound) {
        _responseManagerModalBound = true
        el.addEventListener('hidden.bs.modal', function () {
          try { destroyResponseManagerEditor() } catch (e) { }
          $scope.responseManager.loading = false
          $scope.responseManager.saving = false
          $scope.responseManager.deleting = false
          $scope.responseManager.error = null
          $scope.responseManager.form = {
            id: null,
            description: '',
            subject: ''
          }
          safeApply($scope)
        })
      }
      return _responseManagerModal
    } catch (e) {
      return null
    }
  }

  function getResponseDeleteConfirmModal() {
    try {
      let el = document.getElementById('epResponseDeleteConfirmModal')
      if (!el) return null
      if (!_responseDeleteConfirmModal && $window.bootstrap && $window.bootstrap.Modal) {
        _responseDeleteConfirmModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_responseDeleteConfirmModalBound) {
        _responseDeleteConfirmModalBound = true
        el.addEventListener('hidden.bs.modal', function () {
          if ($scope.responseManager && !$scope.responseManager.deleting) {
            $scope.responseManager.deleteCandidate = null
            safeApply($scope)
          }
        })
      }
      return _responseDeleteConfirmModal
    } catch (e) {
      return null
    }
  }

  function destroyResponseManagerEditor() {
    try {
      if (!$window || !$window.$) return
      let $ = $window.$
      let el = $('#epResponseManagerEditor')
      if (!el || !el.length) return
      if (el.data('summernote')) el.summernote('destroy')
    } catch (e) { }
  }

  function initResponseManagerEditor(existingHtml) {
    let token = ++_responseManagerEditorInitToken
    $window.setTimeout(function () {
      if (token !== _responseManagerEditorInitToken) return
      try {
        if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') {
          $scope.responseManager.error = 'Summernote is not available.'
          safeApply($scope)
          return
        }
        destroyResponseManagerEditor()
        let $ = $window.$
        $('#epResponseManagerEditor').summernote({
          height: messageCenterIsNarrow() ? 220 : 320,
          placeholder: 'Type your canned response message...',
          toolbar: [
            ['misc', ['undo', 'redo']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['insert', ['link', 'hr']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']]
          ]
        })
        $('#epResponseManagerEditor').summernote('code', String(existingHtml || ''))
      } catch (e) {
        $scope.responseManager.error = 'Unable to initialize the editor.'
        safeApply($scope)
      }
    }, 0)
  }

  function setResponseManagerEditorHtml(html) {
    try {
      if ($window && $window.$ && $window.$.fn && typeof $window.$.fn.summernote === 'function') {
        let el = $window.$('#epResponseManagerEditor')
        if (el && el.length && el.data('summernote')) {
          el.summernote('code', String(html || ''))
          return
        }
      }
    } catch (e) { }
    initResponseManagerEditor(html || '')
  }

  function getResponseManagerHtmlOrEmpty() {
    try {
      if ($window && $window.$ && $window.$.fn && typeof $window.$.fn.summernote === 'function') {
        return String($window.$('#epResponseManagerEditor').summernote('code') || '')
      }
    } catch (e) { }
    return ''
  }

  function loadResponseManagerItems(preferredId) {
    $scope.responseManager.loading = true
    $scope.responseManager.error = null
    safeApply($scope)

    return $http.post('/review/getReviewResponses', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password
    }).then(function (resp) {
      $scope.responseManager.loading = false
      if (resp.data && resp.data.success) {
        $scope.responseManager.items = (Array.isArray(resp.data.data) ? resp.data.data : [])
          .map(normalizeResponseManagerItem)
          .filter(Boolean)

        let nextId = preferredId || $scope.responseManager.form.id
        let match = nextId
          ? $scope.responseManager.items.find(function (item) { return item && item.id === Number(nextId) })
          : null

        if (match) setResponseManagerForm(match)
        else if ($scope.responseManager.items.length) setResponseManagerForm($scope.responseManager.items[0])
        else setResponseManagerForm(null)

        safeApply($scope)
        return $scope.responseManager.items
      }

      $scope.responseManager.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to load canned responses.'
      safeApply($scope)
      return []
    }, function () {
      $scope.responseManager.loading = false
      $scope.responseManager.error = 'Unable to load canned responses.'
      safeApply($scope)
      return []
    })
  }

  function bindReviewMessageCenterThreadScroll() {
    try {
      let rightCol = getReviewMessageCenterThreadScrollEl()
      if (!rightCol) return
      if (_reviewMessageCenterThreadScrollBound && _reviewMessageCenterThreadScrollEl && _reviewMessageCenterThreadScrollEl !== rightCol) {
        try { _reviewMessageCenterThreadScrollEl.removeEventListener('scroll', _reviewMessageCenterThreadOnScroll) } catch (e) { }
        _reviewMessageCenterThreadScrollBound = false
        _reviewMessageCenterThreadOnScroll = null
        _reviewMessageCenterThreadScrollEl = null
      }
      if (_reviewMessageCenterThreadScrollBound) return
      _reviewMessageCenterThreadScrollBound = true
      _reviewMessageCenterThreadScrollEl = rightCol
      _reviewMessageCenterThreadOnScroll = function () {
        // Keep parity with the main Message Center state fields.
        try {
          let scrollable = (rightCol.scrollHeight - rightCol.clientHeight) > 2
          $scope.messageCenter.threadHasScrollbar = scrollable
          $scope.messageCenter.threadStickyReplyVisible = false
          safeApply($scope)
        } catch (e) { }
      }
      try { rightCol.addEventListener('scroll', _reviewMessageCenterThreadOnScroll, { passive: true }) } catch (e) {
        try { rightCol.addEventListener('scroll', _reviewMessageCenterThreadOnScroll) } catch (e2) { }
      }
    } catch (e) { }
  }

  function unbindReviewMessageCenterThreadScroll() {
    try {
      if (!_reviewMessageCenterThreadScrollBound) return
      _reviewMessageCenterThreadScrollBound = false
      if (_reviewMessageCenterThreadScrollEl && _reviewMessageCenterThreadOnScroll) {
        try { _reviewMessageCenterThreadScrollEl.removeEventListener('scroll', _reviewMessageCenterThreadOnScroll) } catch (e) { }
      }
      _reviewMessageCenterThreadOnScroll = null
      _reviewMessageCenterThreadScrollEl = null
    } catch (e) { }
  }

  function scheduleReviewMessageCenterThreadScrollToTop() {
    try {
      $window.setTimeout(function () {
        try {
          let modalEl = document.getElementById('epReviewMessageCenterModal')
          if (!modalEl) return
          let rightCol = modalEl.querySelector('.ep-msgcenter__gridCol--right')
          if (!rightCol) return
          let scrollable = (rightCol.scrollHeight - rightCol.clientHeight) > 2
          $scope.messageCenter.threadHasScrollbar = scrollable
          $scope.messageCenter.threadStickyReplyVisible = false
          safeApply($scope)
          if (!scrollable) return
          // Replies are newest first, so the top shows the original message and the latest reply
          rightCol.scrollTop = 0
        } catch (e) { }
      }, 0)
    } catch (e) { }
  }

  function getReviewComposeModal() {
    try {
      bindReviewNestedEvidenceDropdownZIndexFix()
      let el = document.getElementById('epReviewMessageComposeModal')
      if (!el) return null
      if (!_reviewComposeModal && $window.bootstrap && $window.bootstrap.Modal) {
        _reviewComposeModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_reviewComposeModalBound) {
        _reviewComposeModalBound = true
        el.addEventListener('hidden.bs.modal', function () {
          try { destroyReviewComposeEditor() } catch (e) { console.log('e :>> ', e); }
          $scope.reviewCompose.mode = null
          $scope.reviewCompose.subject = ''
          $scope.reviewCompose.needs_response = false
          $scope.reviewCompose.sending = false
          $scope.reviewCompose.error = null
          $scope.reviewCompose.cannedLoading = false
          $scope.reviewCompose.cannedError = null
          $scope.reviewCompose._activeReport = null
          $scope.reviewCompose._parentMessageId = null
          safeApply($scope)
        })
      }
      return _reviewComposeModal
    } catch (e) {
      return null
    }
  }

  function getAgentNoteDeleteConfirmModal() {
    try {
      let el = document.getElementById('epAgentNoteDeleteConfirmModal')
      if (!el) return null
      if (!_agentNoteDeleteConfirmModal && $window.bootstrap && $window.bootstrap.Modal) {
        _agentNoteDeleteConfirmModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      if (!_agentNoteDeleteConfirmModalBound) {
        _agentNoteDeleteConfirmModalBound = true
        el.addEventListener('hidden.bs.modal', function () {
          if ($scope.agentNotes && !$scope.agentNotes.deleting) {
            $scope.agentNotes.deleteCandidate = null
            safeApply($scope)
          }
        })
      }
      return _agentNoteDeleteConfirmModal
    } catch (e) {
      return null
    }
  }

  function destroyAgentNotesEditor() {
    try {
      if (!$window || !$window.$) return
      let $ = $window.$
      let el = $('#epReviewAgentNotesEditor')
      if (!el || !el.length) return
      if (el.data('summernote')) el.summernote('destroy')
    } catch (e) { }
  }

  function initAgentNotesEditor(existingHtml) {
    let token = ++_agentNotesEditorInitToken
    $window.setTimeout(function () {
      if (token !== _agentNotesEditorInitToken) return
      try {
        if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') {
          $scope.agentNotes.error = 'Summernote is not available.'
          safeApply($scope)
          return
        }
        destroyAgentNotesEditor()
        let $ = $window.$
        $('#epReviewAgentNotesEditor').summernote({
          height: messageCenterIsNarrow() ? 200 : 260,
          placeholder: 'Type agent notes…',
          toolbar: [
            ['style', ['bold', 'italic', 'underline']],
            ['para', ['ul', 'ol']],
            ['view', ['codeview']]
          ],
          callbacks: {
            onChange: syncAgentNotesDraftFromEditor,
            onBlur: syncAgentNotesDraftFromEditor,
            onKeyup: syncAgentNotesDraftFromEditor,
            onPaste: syncAgentNotesDraftFromEditor
          }
        })
        $('#epReviewAgentNotesEditor').summernote('code', String(existingHtml || ''))
        syncAgentNotesDraftFromEditor()
      } catch (e) {
        $scope.agentNotes.error = 'Unable to initialize the editor.'
        safeApply($scope)
      }
    }, 0)
  }

  function resetAgentNotesState() {
    if (!$scope.agentNotes) $scope.agentNotes = {}
    $scope.agentNotes.report = null
    $scope.agentNotes.selectedVisibility = 'private'
    $scope.agentNotes.saving = false
    $scope.agentNotes.moving = false
    $scope.agentNotes.deleting = false
    $scope.agentNotes.deleteCandidate = null
    $scope.agentNotes.error = null
    $scope.agentNotes.drafts = {
      private: '',
      public: ''
    }
    $scope.agentNotes.editingIds = {
      private: null,
      public: null
    }
  }

  function getAgentNotesEditingId(visibility) {
    const key = normalizeAgentNoteVisibility(visibility)
    if (!$scope.agentNotes || !$scope.agentNotes.editingIds) return null
    return $scope.agentNotes.editingIds[key] || null
  }

  function setAgentNotesEditingId(visibility, noteId) {
    const key = normalizeAgentNoteVisibility(visibility)
    if (!$scope.agentNotes) return
    if (!$scope.agentNotes.editingIds) $scope.agentNotes.editingIds = { private: null, public: null }
    $scope.agentNotes.editingIds[key] = noteId ? Number(noteId) : null
  }

  // The note loaded in the editor for that tab, or null when writing a new note
  function getEditingAgentNote(report, visibility) {
    const noteId = getAgentNotesEditingId(visibility)
    if (!noteId) return null
    return getDisplayAgentNotes(report).find(function (note) {
      return note && note.id && Number(note.id) === noteId
    }) || null
  }

  function agentNoteComparableText(html) {
    return String(html || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
  }

  function isAgentNoteDraftDirty(visibility) {
    const report = $scope.agentNotes && $scope.agentNotes.report
    const original = (getEditingAgentNote(report, visibility) || {}).notes || ''
    return agentNoteComparableText(getAgentNotesDraftForVisibility(visibility)) !== agentNoteComparableText(original)
  }

  // Errors and notices go in a modal (#epMessageModal) - never a browser showMessageModal()
  $scope.messageModal = { title: '', message: '' }
  let _messageModal = null

  function showMessageModal(message, title) {
    $scope.messageModal = { title: title || 'Something went wrong', message: String(message || '') }
    safeApply($scope)
    try {
      const el = document.getElementById('epMessageModal')
      if (!el || !$window.bootstrap || !$window.bootstrap.Modal) return
      if (!_messageModal) _messageModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      _messageModal.show()
    } catch (e) {
      console.error('Unable to show message', message, e)
    }
  }

  // Switching the editor to another note (or a new one) asks before throwing away unsaved typing
  function confirmDiscardAgentNoteDraft(visibility) {
    syncAgentNotesDraftFromEditor()
    if (!isAgentNoteDraftDirty(visibility)) return true
    return $window.confirm('Discard your unsaved changes to this note?')
  }

  function loadAgentNoteIntoEditor(visibility, note) {
    setAgentNotesEditingId(visibility, note && note.id)
    setAgentNotesDraftForVisibility(visibility, note ? note.notes : '')
    $scope.agentNotes.error = null
    if ($scope.agentNotes.selectedVisibility === normalizeAgentNoteVisibility(visibility)) {
      initAgentNotesEditor(getAgentNotesDraftForVisibility(visibility))
    }
  }

  function getAgentNotesDraftForVisibility(visibility) {
    const key = normalizeAgentNoteVisibility(visibility)
    if (!$scope.agentNotes || !$scope.agentNotes.drafts) return ''
    return typeof $scope.agentNotes.drafts[key] === 'string' ? $scope.agentNotes.drafts[key] : ''
  }

  function setAgentNotesDraftForVisibility(visibility, html) {
    const key = normalizeAgentNoteVisibility(visibility)
    if (!$scope.agentNotes) return
    if (!$scope.agentNotes.drafts) $scope.agentNotes.drafts = { private: '', public: '' }
    $scope.agentNotes.drafts[key] = String(html || '')
  }

  // The editor only exists while the Agent Notes tab is showing; never overwrite a draft from a missing editor
  function isAgentNotesEditorReady() {
    try {
      if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') return false
      let el = $window.$('#epReviewAgentNotesEditor')
      return !!(el.length && el.data('summernote'))
    } catch (e) {
      return false
    }
  }

  function syncAgentNotesDraftFromEditor() {
    try {
      if (!$scope.agentNotes || !$scope.agentNotes.selectedVisibility) return
      if (!isAgentNotesEditorReady()) return
      setAgentNotesDraftForVisibility($scope.agentNotes.selectedVisibility, getAgentNotesHtmlOrEmpty())
    } catch (e) { }
  }

  function setActiveAgentNotesVisibility(visibility, options) {
    const nextVisibility = normalizeAgentNoteVisibility(visibility)
    const opts = options || {}
    if (!$scope.agentNotes) return
    if (!opts.skipCapture) syncAgentNotesDraftFromEditor()
    $scope.agentNotes.selectedVisibility = nextVisibility
    $scope.agentNotes.error = null
    safeApply($scope)
    initAgentNotesEditor(getAgentNotesDraftForVisibility(nextVisibility))
  }

  function getAgentNotesHtmlOrEmpty() {
    try {
      if (isAgentNotesEditorReady()) {
        return String($window.$('#epReviewAgentNotesEditor').summernote('code') || '')
      }
    } catch (e) { }
    return ''
  }

  function destroyReviewComposeEditor() {
    try {
      if (!$window || !$window.$) return
      let $ = $window.$
      let el = $('#epReviewMessageComposeEditor')
      if (!el || !el.length) return
      if (el.data('summernote')) el.summernote('destroy')
    } catch (e) { }
  }

  function initReviewComposeEditor(placeholderText) {
    let token = ++_reviewComposeEditorInitToken
    $window.setTimeout(function () {
      if (token !== _reviewComposeEditorInitToken) return
      try {
        if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') {
          $scope.reviewCompose.error = 'Summernote is not available.'
          safeApply($scope)
          return
        }
        destroyReviewComposeEditor()
        let $ = $window.$
        $('#epReviewMessageComposeEditor').summernote({
          height: messageCenterIsNarrow() ? 180 : 240,
          placeholder: placeholderText || 'Type your message…',
          toolbar: [
            ['misc', ['undo', 'redo']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['insert', ['link', 'hr']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']]
          ],
          callbacks: {
            onKeyup: function () {
              saveReviewComposeEditorRange()
              updateReviewComposeDraftState()
            },
            onChange: function () {
              saveReviewComposeEditorRange()
              updateReviewComposeDraftState()
            },
            onPaste: function () {
              saveReviewComposeEditorRange()
              updateReviewComposeDraftState()
            },
            onBlur: function () {
              saveReviewComposeEditorRange()
              updateReviewComposeDraftState()
            },
            onFocus: saveReviewComposeEditorRange
          }
        })
        $('#epReviewMessageComposeEditor').summernote('code', '')
        saveReviewComposeEditorRange()
        updateReviewComposeDraftState()
      } catch (e) {
        $scope.reviewCompose.error = 'Unable to initialize the editor.'
        safeApply($scope)
      }
    }, 0)
  }

  function getReviewComposeHtmlOrEmpty() {
    try {
      if ($window && $window.$ && $window.$.fn && typeof $window.$.fn.summernote === 'function') {
        return String($window.$('#epReviewMessageComposeEditor').summernote('code') || '')
      }
    } catch (e) { }
    return ''
  }

  function saveReviewComposeEditorRange() {
    try {
      if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') return
      let el = $window.$('#epReviewMessageComposeEditor')
      if (!el || !el.length || !el.data('summernote')) return
      el.summernote('saveRange')
    } catch (e) { }
  }

  function decodeHtmlEntities(text) {
    try {
      let txt = document.createElement('textarea')
      txt.innerHTML = String(text || '')
      return txt.value || ''
    } catch (e) {
      return String(text || '')
    }
  }

  function getReviewComposePreviewLines(html) {
    try {
      let s = String(html || '')
      if (!s) return []
      s = s.replace(/<br\s*\/?\s*>/gi, '\n')
      s = s.replace(/<\/p>/gi, '\n')
      s = s.replace(/<\/div>/gi, '\n')
      s = s.replace(/<li[^>]*>/gi, '• ')
      s = s.replace(/<\/li>/gi, '\n')
      s = s.replace(/<[^>]*>/g, '')
      s = decodeHtmlEntities(s)
      return s
        .split(/\r?\n+/)
        .map(function (line) { return String(line || '').replace(/\s+/g, ' ').trim() })
        .filter(Boolean)
        .slice(0, 3)
    } catch (e) {
      return []
    }
  }

  function fetchResponseManagerItems() {
    return $http.post('/review/getReviewResponses', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password
    }).then(function (resp) {
      if (!(resp.data && resp.data.success)) {
        throw new Error((resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to load canned responses.')
      }

      $scope.responseManager.items = (Array.isArray(resp.data.data) ? resp.data.data : [])
        .map(normalizeResponseManagerItem)
        .filter(Boolean)

      return $scope.responseManager.items
    }, function () {
      throw new Error('Unable to load canned responses.')
    })
  }

  function loadReviewComposeCannedResponses() {
    $scope.reviewCompose.cannedLoading = true
    $scope.reviewCompose.cannedError = null
    safeApply($scope)

    return fetchResponseManagerItems().then(function (items) {
      $scope.reviewCompose.cannedLoading = false
      $scope.reviewCompose.cannedError = null
      safeApply($scope)
      return items
    }, function (err) {
      $scope.reviewCompose.cannedLoading = false
      $scope.reviewCompose.cannedError = err && err.message ? String(err.message) : 'Unable to load canned responses.'
      safeApply($scope)
      return []
    })
  }

  function insertReviewComposeHtml(html) {
    try {
      const snippet = String(html || '')
      if (!snippet) return
      if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') return

      let el = $window.$('#epReviewMessageComposeEditor')
      if (!el || !el.length || !el.data('summernote')) return

      let currentHtml = String(el.summernote('code') || '').trim()
      if (!currentHtml || currentHtml === '<p><br></p>') {
        el.summernote('code', snippet)
        saveReviewComposeEditorRange()
        updateReviewComposeDraftState()
        return
      }

      try { el.summernote('focus') } catch (e) { }
      try { el.summernote('restoreRange') } catch (e) { }
      try {
        el.summernote('pasteHTML', snippet)
      } catch (e) {
        el.summernote('code', currentHtml + snippet)
      }
      saveReviewComposeEditorRange()
      updateReviewComposeDraftState()
    } catch (e) { }
  }

  $scope.getReviewComposeCannedPreviewLines = function (item) {
    const lines = getReviewComposePreviewLines(item && item.message)
    return lines.length ? lines : ['(No message preview)']
  }

  $scope.applyReviewComposeCannedResponse = function (item) {
    try {
      if (!item) return
      if (!($scope.reviewCompose && $scope.reviewCompose.mode === 'reply')) {
        $scope.reviewCompose.subject = String(item.subject || '')
      }
      insertReviewComposeHtml(String(item.message || ''))
      $scope.reviewCompose.cannedError = null
      safeApply($scope)
    } catch (e) { }
  }

  $scope.startNewResponse = function () {
    setResponseManagerForm(null)
  }

  $scope.selectResponseItem = function (item) {
    if (!item) return
    setResponseManagerForm(item)
  }

  $scope.openResponseManager = function () {
    try {
      let modal = getResponseManagerModal()
      if (modal) modal.show()
      initResponseManagerEditor('')
      loadResponseManagerItems()
    } catch (e) {
      $scope.responseManager.error = 'Unable to open canned response manager.'
      safeApply($scope)
    }
  }

  $scope.closeResponseManager = function () {
    let modal = getResponseManagerModal()
    if (modal) modal.hide()
  }

  $scope.refreshResponseManager = function () {
    loadResponseManagerItems($scope.responseManager.form.id)
  }

  $scope.isResponseManagerReady = function () {
    try {
      if (!$scope.responseManager || $scope.responseManager.loading || $scope.responseManager.saving || $scope.responseManager.deleting) return false
      const description = String($scope.responseManager.form.description || '').trim()
      const subject = String($scope.responseManager.form.subject || '').trim()
      const html = String(getResponseManagerHtmlOrEmpty() || '').trim()
      return !!description && !!subject && isMeaningfulHtml(html)
    } catch (e) {
      return false
    }
  }

  $scope.saveResponseItem = function () {
    try {
      const description = String($scope.responseManager.form.description || '').trim()
      const subject = String($scope.responseManager.form.subject || '').trim()
      const message = getResponseManagerHtmlOrEmpty()

      $scope.responseManager.saving = true
      $scope.responseManager.error = null
      safeApply($scope)

      $http.post('/review/saveReviewResponse', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        response_id: $scope.responseManager.form.id,
        description: description,
        subject: subject,
        message: message
      }).then(function (resp) {
        $scope.responseManager.saving = false
        if (resp.data && resp.data.success && resp.data.data) {
          const saved = normalizeResponseManagerItem(resp.data.data)
          if (saved) {
            loadResponseManagerItems(saved.id)
            return
          }
        }

        $scope.responseManager.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save canned response.'
        safeApply($scope)
      }, function () {
        $scope.responseManager.saving = false
        $scope.responseManager.error = 'Unable to save canned response.'
        safeApply($scope)
      })
    } catch (e) {
      $scope.responseManager.saving = false
      $scope.responseManager.error = 'Unable to save canned response.'
      safeApply($scope)
    }
  }

  $scope.openDeleteResponseConfirm = function () {
    try {
      const responseId = $scope.responseManager && $scope.responseManager.form ? Number($scope.responseManager.form.id) : null
      if (!responseId) return

      $scope.responseManager.deleteCandidate = {
        id: responseId,
        description: String($scope.responseManager.form.description || ''),
        subject: String($scope.responseManager.form.subject || ''),
        message: String(getResponseManagerHtmlOrEmpty() || '')
      }
      $scope.responseManager.error = null
      safeApply($scope)

      let modal = getResponseDeleteConfirmModal()
      if (modal) modal.show()
    } catch (e) {
      $scope.responseManager.error = 'Unable to open delete confirmation.'
      safeApply($scope)
    }
  }

  $scope.cancelDeleteResponseItem = function () {
    let modal = getResponseDeleteConfirmModal()
    if (modal) modal.hide()
  }

  $scope.deleteResponseItem = function () {
    try {
      const responseId = $scope.responseManager && $scope.responseManager.deleteCandidate ? Number($scope.responseManager.deleteCandidate.id) : null
      if (!responseId) return

      $scope.responseManager.deleting = true
      $scope.responseManager.error = null
      safeApply($scope)

      $http.post('/review/deleteReviewResponse', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        response_id: responseId
      }).then(function (resp) {
        $scope.responseManager.deleting = false
        if (resp.data && resp.data.success) {
          try {
            let modal = getResponseDeleteConfirmModal()
            if (modal) modal.hide()
          } catch (e) { }
          $scope.responseManager.deleteCandidate = null
          loadResponseManagerItems(null)
          return
        }

        $scope.responseManager.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to delete canned response.'
        safeApply($scope)
      }, function () {
        $scope.responseManager.deleting = false
        $scope.responseManager.error = 'Unable to delete canned response.'
        safeApply($scope)
      })
    } catch (e) {
      $scope.responseManager.deleting = false
      $scope.responseManager.error = 'Unable to delete canned response.'
      safeApply($scope)
    }
  }

  function updateReviewComposeDraftState() {
    try {
      if (!$scope.reviewCompose) return
      let html = getReviewComposeHtmlOrEmpty().trim()
      if (!html || html === '<p><br></p>') {
        $scope.reviewCompose._messageLen = 0
      } else {
        const text = stripHtmlToText(html)
        $scope.reviewCompose._messageLen = text ? text.length : 0
      }
      safeApply($scope)
    } catch (e) { }
  }

  $scope.isReviewComposeReady = function () {
    try {
      if (!$scope.reviewCompose || $scope.reviewCompose.sending) return false
      const mode = String($scope.reviewCompose.mode || '')
      const subj = String($scope.reviewCompose.subject || '').trim()

      let msgLen = Number($scope.reviewCompose._messageLen)
      if (!Number.isFinite(msgLen)) {
        let html = getReviewComposeHtmlOrEmpty().trim()
        if (!html || html === '<p><br></p>') return false
        const plainText = stripHtmlToText(html)
        msgLen = plainText ? plainText.length : 0
      }
      if (msgLen < 3) return false

      if (mode === 'new' && subj.length < 3) return false

      return true
    } catch (e) {
      return false
    }
  }

  $scope.messageCenterBackToList = function () {
    $scope.messageCenter.view = 'list'
    $scope.messageCenter.threadHasScrollbar = false
    $scope.messageCenter.threadStickyReplyVisible = false
    safeApply($scope)
  }

  // Thread list items contain the email Opens dropdown, so clicks/keys inside the email pills don't select the thread
  $scope.onMessageThreadListActivate = function (m, $event) {
    try {
      const target = $event && $event.target
      if (target && typeof target.closest === 'function' && target.closest('.ep-msgcenter__email')) return
      if ($event && $event.type === 'keydown') {
        if ($event.key !== 'Enter' && $event.key !== ' ') return
        $event.preventDefault()
      }
    } catch (e) { }
    $scope.selectMessageThread(m)
  }

  $scope.selectMessageThread = function (m) {
    if (!m) return
    $scope.messageCenter.selected = m
    $scope.messageCenter.expandedBodies = {}
    $scope.messageCenter.threadHasScrollbar = false
    $scope.messageCenter.threadStickyReplyVisible = false
    if (messageCenterIsNarrow()) $scope.messageCenter.view = 'thread'
    safeApply($scope)
    scheduleReviewMessageCenterThreadScrollToTop()
  }

  $scope.openReviewComposeNewMessage = function () {
    try {
      const report = ($scope.messageCenter && $scope.messageCenter._activeReport) ? $scope.messageCenter._activeReport : null
      if (!report) return

      $scope.reviewCompose.mode = 'new'
      $scope.reviewCompose.subject = ''
      $scope.reviewCompose.needs_response = false
      $scope.reviewCompose.sending = false
      $scope.reviewCompose.error = null
      $scope.reviewCompose.cannedError = null
      $scope.reviewCompose._activeReport = report
      $scope.reviewCompose._parentMessageId = null
      safeApply($scope)

      let modal = getReviewComposeModal()
      if (modal) modal.show()
      loadReviewComposeCannedResponses()
      $window.setTimeout(function () {
        initReviewComposeEditor('Type your message…')
      }, 350)
    } catch (e) { }
  }

  $scope.openReviewComposeReply = function () {
    try {
      const report = ($scope.messageCenter && $scope.messageCenter._activeReport) ? $scope.messageCenter._activeReport : null
      const thread = ($scope.messageCenter && $scope.messageCenter.selected) ? $scope.messageCenter.selected : null
      if (!report || !thread || !thread.message_id) return

      $scope.reviewCompose.mode = 'reply'
      $scope.reviewCompose.subject = String(thread.subject || '(No subject)')
      $scope.reviewCompose.needs_response = false
      $scope.reviewCompose.sending = false
      $scope.reviewCompose.error = null
      $scope.reviewCompose.cannedError = null
      $scope.reviewCompose._activeReport = report
      $scope.reviewCompose._parentMessageId = thread.message_id
      safeApply($scope)

      let modal = getReviewComposeModal()
      if (modal) modal.show()
      loadReviewComposeCannedResponses()
      $window.setTimeout(function () {
        initReviewComposeEditor('Type your reply…')
      }, 350)
    } catch (e) { }
  }

  $scope.cancelReviewCompose = function () {
    try {
      $scope.reviewCompose.sending = false
      $scope.reviewCompose.error = null
      destroyReviewComposeEditor()
      let modal = getReviewComposeModal()
      if (modal) modal.hide()
      safeApply($scope)
    } catch (e) { }
  }

  $scope.sendReviewCompose = function () {
    try {
      const mode = String($scope.reviewCompose.mode || '')
      const report = ($scope.reviewCompose && $scope.reviewCompose._activeReport) ? $scope.reviewCompose._activeReport : (($scope.messageCenter && $scope.messageCenter._activeReport) ? $scope.messageCenter._activeReport : null)
      if (!report) return

      const isReply = mode === 'reply'
      const parentId = isReply ? ($scope.reviewCompose._parentMessageId || null) : null
      const subj = isReply ? '' : String($scope.reviewCompose.subject || '').trim()
      const needsResponse = $scope.reviewCompose.needs_response ? 1 : 0

      let html = getReviewComposeHtmlOrEmpty().trim()
      if (!html || html === '<p><br></p>') {
        $scope.reviewCompose.error = isReply ? 'Please enter a reply.' : 'Please enter a message.'
        safeApply($scope)
        return
      }
      if (!isReply && (!subj || subj.length < 3)) {
        $scope.reviewCompose.error = 'Please enter a subject.'
        safeApply($scope)
        return
      }

      const plainText = stripHtmlToText(html)
      if (!plainText || plainText.length < 3) {
        $scope.reviewCompose.error = isReply ? 'Please enter a reply.' : 'Please enter a message.'
        safeApply($scope)
        return
      }

      $scope.reviewCompose.sending = true
      $scope.reviewCompose.error = null
      safeApply($scope)

      $http.post('/review/saveReviewMessage', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        tax_year: $scope.tax_year,
        prop_id: report.prop_id,
        user_id: report.user_id,
        parent_message_id: parentId,
        subject: subj,
        message_text: html,
        needs_response: needsResponse
      }).then(function (resp) {
        if (!(resp.data && resp.data.success)) {
          $scope.reviewCompose.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to send message.'
          safeApply($scope)
          return
        }

        const createdId = (resp.data && resp.data.data) ? resp.data.data.message_id : null

        destroyReviewComposeEditor()
        let modal = getReviewComposeModal()
        if (modal) modal.hide()

        // Refresh messages and keep the message center up to date
        ensureReportMessages(report, true).then(function () {
          $scope.portalMessages = (report && Array.isArray(report.messages)) ? report.messages : []
          syncMessageCounts(report)
          syncMessageLastDates(report)

          // Select the newly-created thread when sending a new message
          try {
            if (!isReply && createdId && Array.isArray($scope.portalMessages)) {
              let thread = $scope.portalMessages.find(function (m) {
                return m && Number(m.message_id) === Number(createdId)
              })
              if (thread) $scope.messageCenter.selected = thread
            }
            if (isReply && parentId && Array.isArray($scope.portalMessages)) {
              let thread = $scope.portalMessages.find(function (m) {
                return m && Number(m.message_id) === Number(parentId)
              })
              if (thread) {
                $scope.messageCenter.selected = thread
                if (messageCenterIsNarrow()) $scope.messageCenter.view = 'thread'
              }
            }
          } catch (e) { }

          safeApply($scope)
          scheduleReviewMessageCenterThreadScrollToTop()
        })
      }, function () {
        $scope.reviewCompose.error = 'Unable to send message.'
        safeApply($scope)
      }).finally(function () {
        $scope.reviewCompose.sending = false
        safeApply($scope)
      })
    } catch (e) {
      $scope.reviewCompose.sending = false
      $scope.reviewCompose.error = 'Unable to send message.'
      safeApply($scope)
    }
  }

  $scope.markReviewMessageRead = function (msg, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!msg || !msg.message_id) return
      if (msg._markingRead) return
      if (!$scope.isPortalMessageUnread || !$scope.isPortalMessageUnread(msg)) return

      const report = ($scope.messageCenter && $scope.messageCenter._activeReport) ? $scope.messageCenter._activeReport : null
      const propId = (report && report.prop_id) ? report.prop_id : (($scope.activeProp && $scope.activeProp.prop_id) ? $scope.activeProp.prop_id : null)
      if (!propId) return

      msg._markingRead = true
      safeApply($scope)

      $http.post('/review/markReviewMessageRead', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        tax_year: $scope.tax_year,
        prop_id: propId,
        message_id: msg.message_id
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          msg.is_read = 1
          msg.read_at = new Date()
          msg.read_by_id = $scope.crm_user_id
          if (report) {
            syncMessageCounts(report)
            syncMessageLastDates(report)
          }
          safeApply($scope)
        } else {
          $scope.messageCenter.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to mark message as read.'
          safeApply($scope)
        }
      }, function () {
        $scope.messageCenter.error = 'Unable to mark message as read.'
        safeApply($scope)
      }).finally(function () {
        try { msg._markingRead = false } catch (e) { }
        safeApply($scope)
      })
    } catch (e) {
      try {
        msg._markingRead = false
        $scope.messageCenter.error = 'Unable to mark message as read.'
        safeApply($scope)
      } catch (e2) { }
    }
  }

  function toInt(value) {
    const n = Number(value)
    if (!Number.isFinite(n)) return 0
    return Math.max(0, Math.trunc(n))
  }

  function syncMessageCounts(report) {
    if (!report) return

    let threads = toInt(report.msg_thread_count)
    let replies = toInt(report.msg_reply_count)
    let unread = toInt(report.msg_unread_count)
    let overdue = toInt(report.msg_overdue_response_count)

    if (report.messagesLoaded && Array.isArray(report.messages)) {
      try {
        threads = report.messages.length
        replies = report.messages.reduce(function (sum, m) {
          const arr = Array.isArray(m.replies) ? m.replies : []
          return sum + arr.length
        }, 0)
        unread = report.messages.reduce(function (sum, m) {
          // Unread for reviewer = unread client messages/replies
          const rootUnread = (toInt(m.is_read) === 0 && String(m.sender_type || '').toLowerCase() === 'client') ? 1 : 0
          const replyUnread = (Array.isArray(m.replies) ? m.replies : []).reduce(function (innerSum, r) {
            return innerSum + ((toInt(r.is_read) === 0 && String(r.sender_type || '').toLowerCase() === 'client') ? 1 : 0)
          }, 0)
          return sum + rootUnread + replyUnread
        }, 0)
        overdue = report.messages.reduce(function (sum, m) {
          return sum + getPortalThreadOverdueCount(m)
        }, 0)
      } catch (e) {
        console.log('syncMessageCounts error :>> ', e);
      }
    }

    report._msgThreads = toInt(threads)
    report._msgReplies = toInt(replies)
    report._msgUnread = toInt(unread)
    report._msgOverdueResponse = toInt(overdue)
  }

  function syncMessageLastDates(report) {
    try {
      if (!report || !Array.isArray(report.messages)) return

      let lastThreadAt = null
      let lastReplyAt = null
      let lastUnreadAt = null
      let lastOverdueAt = null

      report.messages.forEach(function (m) {
        if (!m) return

        // Threads
        if (m.parent_message_id == null) {
          let d = $scope.portalDate(m.created_at)
          if (d && (!lastThreadAt || d > lastThreadAt)) lastThreadAt = d
        }

        // Unread root message (client only)
        if (String(m.sender_type || '').toLowerCase() === 'client' && toInt(m.is_read) === 0) {
          let d = $scope.portalDate(m.created_at)
          if (d && (!lastUnreadAt || d > lastUnreadAt)) lastUnreadAt = d
        }

        if (isPortalMessageResponseOverdue(m, m)) {
          let overdueDate = getPortalMessageReminderSentAt(m)
          if (overdueDate && (!lastOverdueAt || overdueDate > lastOverdueAt)) lastOverdueAt = overdueDate
        }

        // Replies
        let replies = Array.isArray(m.replies) ? m.replies : []
        replies.forEach(function (r) {
          if (!r) return
          let d = $scope.portalDate(r.created_at)
          if (d && (!lastReplyAt || d > lastReplyAt)) lastReplyAt = d
          if (String(r.sender_type || '').toLowerCase() === 'client' && toInt(r.is_read) === 0) {
            if (d && (!lastUnreadAt || d > lastUnreadAt)) lastUnreadAt = d
          }
          if (isPortalMessageResponseOverdue(r, m)) {
            let overdueDate = getPortalMessageReminderSentAt(r)
            if (overdueDate && (!lastOverdueAt || overdueDate > lastOverdueAt)) lastOverdueAt = overdueDate
          }
        })
      })

      report.msg_last_thread_at = lastThreadAt
      report.msg_last_reply_at = lastReplyAt
      report.msg_last_unread_at = lastUnreadAt
      report.msg_last_overdue_response_at = lastOverdueAt
    } catch (e) { }
  }

  $scope.getMsgThreads = function (report) {
    return report ? toInt(report._msgThreads) : 0
  }
  $scope.getMsgReplies = function (report) {
    return report ? toInt(report._msgReplies) : 0
  }
  $scope.getMsgUnread = function (report) {
    return report ? toInt(report._msgUnread) : 0
  }
  $scope.getMsgOverdueResponse = function (report) {
    return report ? toInt(report._msgOverdueResponse) : 0
  }

  $scope.getMessagesButtonClass = function (report) {
    try {
      if ($scope.getMsgUnread(report) > 0) return 'btn-danger'
      if ($scope.getMsgOverdueResponse(report) > 0) return 'btn-outline-warning'
      return 'btn-outline-primary'
    } catch (e) {
      return 'btn-outline-primary'
    }
  }

  $scope.getMessagesTooltip = function (report) {
    try {
      const t = $scope.getMsgThreads(report)
      const r = $scope.getMsgReplies(report)
      const u = $scope.getMsgUnread(report)
      const o = $scope.getMsgOverdueResponse(report)

      function formatTooltipDate(value) {
        try {
          const d = $scope.portalDate(value)
          if (!d) return ''
          const month = d.getMonth() + 1
          const day = d.getDate()
          const year = d.getFullYear()

          let hours = d.getHours()
          const ampm = hours >= 12 ? 'PM' : 'AM'
          hours = hours % 12
          if (hours === 0) hours = 12
          const minutes = String(d.getMinutes()).padStart(2, '0')

          return month + '-' + day + '-' + year + ' @ ' + hours + ':' + minutes + ' ' + ampm
        } catch (e) {
          return ''
        }
      }

      const lastThreadAt = report ? formatTooltipDate(report.msg_last_thread_at) : ''
      const lastReplyAt = report ? formatTooltipDate(report.msg_last_reply_at) : ''
      const lastUnreadAt = report ? formatTooltipDate(report.msg_last_unread_at) : ''
      const lastOverdueAt = report ? formatTooltipDate(report.msg_last_overdue_response_at) : ''

      function valueWithDate(count, dateLabel) {
        try {
          const base = String(count)
          if (!dateLabel) return base
          return base + ' \u00b7 ' + String(dateLabel)
        } catch (e) {
          return String(count)
        }
      }

      return (
        '<div class="ep-review-messages-tooltip text-start">' +
        '<div class="fw-bold">Messages</div>' +
        '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
        '<div class="ep-review-messages-tooltip-row">' +
        '<span class="ep-review-messages-tooltip-label">Total Messages:</span>' +
        '<span class="ep-review-messages-tooltip-value">' + valueWithDate(t, lastThreadAt) + '</span>' +
        '</div>' +
        '<div class="ep-review-messages-tooltip-row">' +
        '<span class="ep-review-messages-tooltip-label">Total Replies:</span>' +
        '<span class="ep-review-messages-tooltip-value">' + valueWithDate(r, lastReplyAt) + '</span>' +
        '</div>' +
        '<div class="ep-review-messages-tooltip-row">' +
        '<span class="ep-review-messages-tooltip-label">Unread Messages:</span>' +
        '<span class="ep-review-messages-tooltip-value">' + valueWithDate(u, lastUnreadAt) + '</span>' +
        '</div>' +
        '<div class="ep-review-messages-tooltip-row">' +
        '<span class="ep-review-messages-tooltip-label">Need Response > 3 Days:</span>' +
        '<span class="ep-review-messages-tooltip-value">' + valueWithDate(o, lastOverdueAt) + '</span>' +
        '</div>' +
        '</div>'
      )
    } catch (e) {
      return ''
    }
  }

  $scope.getUseReportTooltip = function (report) {
    try {
      if (!report) return ''
      const isEnabled = report.use_report !== 0
      const user = report.crm_user_name || 'Unknown User'
      const when = report.use_report_changed_on ? $scope.portalDate(report.use_report_changed_on) : null
      let dateLine = ''
      if (when) {
        const month = when.getMonth() + 1
        const day = when.getDate()
        const year = when.getFullYear()
        let hours = when.getHours()
        const ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        if (hours === 0) hours = 12
        const minutes = String(when.getMinutes()).padStart(2, '0')
        dateLine = month + '-' + day + '-' + year + ' @ ' + hours + ':' + minutes + ' ' + ampm
      }
      const header = isEnabled ? 'This report is to be used' : 'This report is not to be used'
      const actor = isEnabled ? 'Enabled by: ' + user : 'Disabled by: ' + user
      const reasonLine = !isEnabled ? ('<br>Reason: ' + (report.reason || 'No reason provided')) : ''
      const dateHtml = dateLine ? ('<br>' + dateLine) : ''
      return '<b>' + header + '</b><br>' + actor + dateHtml + reasonLine
    } catch (e) {
      return ''
    }
  }

  function init() {
    bindPortalRefreshListeners()
    $http.post('/review/checkCrmUser', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        try { $scope.crmUser = resp.data.user || null } catch (e) { $scope.crmUser = null }
        loadCounties()
      } else {
        $window.location.href = 'https://propertytax.io/'
      }
    }, function (err) {
      console.error(err)
      $window.location.href = 'https://propertytax.io/'
    })
  }

  function refreshCounties(keepSelection) {
    const prevCad = keepSelection && $scope.selectedCounty ? $scope.selectedCounty.cad_code : null
    const prevName = keepSelection && $scope.selectedCounty ? String($scope.selectedCounty.county || '') : ''

    return $http.post('/review/getReviewCounties', {
      tax_year: $scope.tax_year
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        $scope.counties = Array.isArray(resp.data.data) ? resp.data.data.slice() : []
        const totalReports = $scope.counties.reduce(function (sum, c) {
          return sum + (Number(c && c.reports) || 0)
        }, 0)
        const totalUnreviewed = $scope.counties.reduce(function (sum, c) {
          return sum + (Number(c && c.unreviewed_count) || 0)
        }, 0)

        function formatCount(value) {
          const num = Number(value) || 0
          return num.toLocaleString('en-US')
        }

        const maxCounty = Math.max(
          $scope.counties.reduce(function (max, c) {
            const val = String((c && c.county) || '')
            return Math.max(max, val.length)
          }, String('ALL COUNTIES').length),
          'County'.length
        )

        const maxReports = Math.max(
          $scope.counties.reduce(function (max, c) {
            const val = formatCount(c && c.reports)
            return Math.max(max, val.length)
          }, formatCount(totalReports).length),
          'Props'.length
        )
        const maxUnreviewed = Math.max(
          $scope.counties.reduce(function (max, c) {
            const val = formatCount(c && c.unreviewed_count)
            return Math.max(max, val.length)
          }, formatCount(totalUnreviewed).length),
          'Review'.length
        )

        function padEndNbsp(value, width) {
          const raw = String(value || '').padEnd(width, ' ')
          return raw.replace(/ /g, '\u00a0')
        }

        function padStartNbsp(value, width) {
          const raw = String(value || '').padStart(width, ' ')
          return raw.replace(/ /g, '\u00a0')
        }

        function buildCountyLabel(c) {
          const county = padEndNbsp((c && c.county) ? String(c.county) : '', maxCounty)
          const reports = padStartNbsp(formatCount(c && c.reports), maxReports)
          const unreviewed = padStartNbsp(formatCount(c && c.unreviewed_count), maxUnreviewed)
          return `${county}\u00a0\u00a0${reports}\u00a0\u00a0${unreviewed}`
        }

        function buildCountyHeader() {
          const county = padEndNbsp('County', maxCounty)
          const reports = padStartNbsp('Props', maxReports)
          const unreviewed = padStartNbsp('Review', maxUnreviewed)
          return `${county}\u00a0\u00a0${reports}\u00a0\u00a0${unreviewed}`
        }

        $scope.counties.forEach(function (c) {
          if (!c) return
          c.display_label = buildCountyLabel(c)
        })
        $scope.counties.unshift({
          county: 'ALL COUNTIES',
          cad_code: null,
          reports: totalReports,
          unreviewed_count: totalUnreviewed
        })

        if ($scope.counties[0]) {
          $scope.counties[0].display_label = buildCountyLabel($scope.counties[0])
        }

        $scope.countyHeaderLabel = buildCountyHeader()

        if ($scope.counties.length > 0) {
          // Default to the first real county (index 1, since index 0 is "ALL COUNTIES").
          // Loading ALL COUNTIES by default is too slow. Fall back to index 0 only if
          // there are no real counties.
          const firstRealCounty = $scope.counties[1] || $scope.counties[0]
          if (keepSelection) {
            const match = $scope.counties.find(function (c) {
              if (!c) return false
              if (prevCad !== null && prevCad !== undefined) return String(c.cad_code || '') === String(prevCad || '')
              return String(c.county || '') === prevName
            })
            $scope.selectedCounty = match || firstRealCounty
          } else {
            $scope.selectedCounty = firstRealCounty
          }
        }
      }
    })
  }

  function loadCounties() {
    refreshCounties(false).then(function () {
      if ($scope.selectedCounty) {
        loadReports()
      }
    })
  }

  function loadReports() {
    if (!$scope.selectedCounty) {
      $scope.reportsLoading = false
      return Promise.resolve([])
    }

    const requestId = ++reportsLoadRequestId
    $scope.reportsLoading = true
    const hasSearchText = String($scope.searchText || '').trim().length > 0
    const requestCadCode = hasSearchText ? null : $scope.selectedCounty.cad_code
    searchScopeAllCountiesActive = hasSearchText

    return $http.post('/review/getReviewReports', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      tax_year: $scope.tax_year,
      cad_code: requestCadCode
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        $scope.reports = resp.data.data.map(function (r) {
          r.use_report = r.use_report === 1 ? 1 : 0
          r.follow_up_needed = r.follow_up_needed === 1 ? 1 : 0
          r.expanded = false
          r.infoExpanded = true
          r.messages = []
          r.messagesLoaded = false
          r.messagesLoading = false
          r.messagesError = null
          r.propertyDetails = null
          r.propertyDetailsLoaded = false
          r.propertyDetailsLoading = false
          r.propertyDetailsError = null
          r.conditionOverrideId = null
          r.conditionOverrideCrmUserId = null
          r.conditionOverrideCrmUserName = ''
          r.conditionOverrideUpdatedAt = null
          r.conditionOverrideSaving = false
          r.conditionOverrideRestoring = false
          r.conditionOverrideRestoreConfirm = false
          r.conditionOverrideSavedInputValue = null
          r.conditionOverrideSavedConditionValue = '0'
          r.revisedConditionValue = ''
          r.revisedConditionValueRaw = ''
          r.revisedConditionValueDraft = ''
          r.revisedConditionValueDirty = false

          r.reviewed_by_id = r.reviewed_by_id ? Number(r.reviewed_by_id) : null
          r.reviewed_by_name = r.reviewed_by_name ? String(r.reviewed_by_name) : null
          r.reviewed_by_initials = r.reviewed_by_initials ? String(r.reviewed_by_initials).trim().toUpperCase() : null
          r.reviewed_on = r.reviewed_on ? $scope.portalDate(r.reviewed_on) : null
          r.reviewed_toggle = r.reviewed_by_id ? 1 : 0
          r.use_report_changed_on = r.use_report_changed_on ? $scope.portalDate(r.use_report_changed_on) : null

          r.agent_note_id = r.agent_note_id ? Number(r.agent_note_id) : null
          r.agent_notes = (typeof r.agent_notes === 'undefined' || r.agent_notes === null) ? '' : String(r.agent_notes)
          r.agent_note_show_on_report = r.agent_note_show_on_report === 1 ? 1 : 0
          r.agent_note_use_on_cover_page = r.agent_note_use_on_cover_page === 1 ? 1 : 0
          r.agent_note_updated_at = r.agent_note_updated_at ? $scope.portalDate(r.agent_note_updated_at) : null
          r.agent_note_agent_name = r.agent_note_agent_name ? String(r.agent_note_agent_name) : null
          r.agent_notes_all = normalizeAgentNotesCollection(r.agent_notes_all, r)
          syncLegacyCurrentAgentNoteFields(r)

          syncMessageCounts(r)

          if (typeof r.evidence_files === 'string') {
            try { r.evidence_files = JSON.parse(r.evidence_files) } catch (e) { }
          }
          if (!Array.isArray(r.evidence_files)) r.evidence_files = []

          r.evidence_files.forEach(function (f) {
            f.expanded = false
            f.prop_id = r.prop_id
            f.user_id = r.user_id
            f.tax_year = $scope.tax_year
            if (typeof f.meta_json === 'string') {
              try { f.meta_json = JSON.parse(f.meta_json) } catch (e) { }
            }
            restoreAiVerification(f)

            if (f.detected_ext) {
              f.display_ext = f.detected_ext.replace('.', '').toUpperCase()
            } else {
              f.display_ext = ''
            }

            if (f.created_at && typeof f.created_at === 'string') {
              // Handle SQL format "YYYY-MM-DD HH:MM:SS" -> "YYYY-MM-DDTHH:MM:SS"
              f.created_at = new Date(f.created_at.replace(' ', 'T'))
            }
            if (f.updated_at && typeof f.updated_at === 'string') {
              f.updated_at = new Date(f.updated_at.replace(' ', 'T'))
            }
            if (f.reviewed_on && typeof f.reviewed_on === 'string') {
              f.reviewed_on = new Date(f.reviewed_on.replace(' ', 'T'))
            }
            f.reviewed_by_initials = f.reviewed_by_initials ? String(f.reviewed_by_initials).trim().toUpperCase() : null

            syncEvidenceUsageState(f)
          })

          recomputeReportReviewedToggle(r)

          // Collect unique types for filtering
          var typesSet = new Set()
          r.evidence_files.forEach(function (f) {
            if (f.content_type_key) typesSet.add(f.content_type_key)
          })
          r.uniqueTypes = Array.from(typesSet).sort().map(function (t) {
            return { name: t, selected: true }
          })

          // Sort evidence files by record ID only.
          r.evidence_files.sort(function (a, b) {
            var idA = Number(a && a.id)
            var idB = Number(b && b.id)
            if (!isFinite(idA)) idA = 0
            if (!isFinite(idB)) idB = 0
            return idA - idB
          })

          // Parse report_info
          if (typeof r.report_info === 'string') {
            try { r.report_info = JSON.parse(r.report_info) } catch (e) { }
          }
          // console.log('REPORT INFO:', r)
          return r
        })
        if (!hasLoggedStartupReviewObject) {
          hasLoggedStartupReviewObject = true
          console.log('Review startup loaded object:', $scope.reports[0] || null)
        }
        rebuildReviewerFilterOptions()
        $scope.applyFilter()
      }
    }).finally(function () {
      if (requestId === reportsLoadRequestId) {
        $scope.reportsLoading = false
      }
    })
  }

  $scope.agentNotes = {
    report: null,
    selectedVisibility: 'private',
    saving: false,
    moving: false,
    deleting: false,
    drafts: {
      private: '',
      public: ''
    },
    editingIds: {
      private: null,
      public: null
    },
    error: null
  }

  $scope.getAgentNoteVisibilityLabel = function (note) {
    return getAgentNoteVisibilityLabel(note)
  }

  $scope.getAgentNoteSlotLabel = function (visibility) {
    return getAgentNoteSlotLabel(visibility)
  }

  $scope.getEditingAgentNote = function () {
    const agentNotes = $scope.agentNotes
    return agentNotes ? getEditingAgentNote(agentNotes.report, agentNotes.selectedVisibility) : null
  }

  $scope.isEditingAgentNote = function (note) {
    return !!(note && note.id && Number(note.id) === getAgentNotesEditingId(getAgentNoteVisibilityValue(note)))
  }

  // Any reviewer can edit, move or delete any saved note; edits keep the original author
  $scope.canEditAgentNote = function (note) {
    return !!(note && note.id)
  }

  $scope.editAgentNote = function (note) {
    if ($scope.isAgentNotesBusy() || !$scope.canEditAgentNote(note) || $scope.isEditingAgentNote(note)) return
    const visibility = getAgentNoteVisibilityValue(note)
    if (!confirmDiscardAgentNoteDraft(visibility)) return
    loadAgentNoteIntoEditor(visibility, note)
  }

  // Stop editing without saving: unsaved changes are dropped and the editor goes back to a blank new note
  $scope.cancelAgentNoteEdit = function () {
    if ($scope.isAgentNotesBusy() || !$scope.agentNotes) return
    loadAgentNoteIntoEditor($scope.agentNotes.selectedVisibility, null)
  }

  $scope.newAgentNote = function () {
    if ($scope.isAgentNotesBusy() || !$scope.agentNotes) return
    const visibility = $scope.agentNotes.selectedVisibility
    if (!confirmDiscardAgentNoteDraft(visibility)) return
    loadAgentNoteIntoEditor(visibility, null)
  }

  $scope.isAgentNotesBusy = function () {
    return !!($scope.agentNotes && ($scope.agentNotes.saving || $scope.agentNotes.moving || $scope.agentNotes.deleting))
  }

  $scope.openDeleteAgentNoteConfirm = function (note) {
    try {
      if (!$scope.agentNotes || !$scope.agentNotes.report) return
      if (!$scope.canEditAgentNote(note)) return
      const slotVisibility = getAgentNoteVisibilityValue(note)

      $scope.agentNotes.deleteCandidate = {
        id: Number(note.id),
        visibility: slotVisibility,
        label: slotVisibility === 'public' ? 'Public Note' : 'Private Note',
        notes: String(note.notes || ''),
        updated_at: note.updated_at || null
      }
      $scope.agentNotes.error = null
      safeApply($scope)

      let modal = getAgentNoteDeleteConfirmModal()
      if (modal) modal.show()
    } catch (e) {
      $scope.agentNotes.error = 'Unable to open delete confirmation.'
      safeApply($scope)
    }
  }

  $scope.cancelDeleteAgentNote = function () {
    let modal = getAgentNoteDeleteConfirmModal()
    if (modal) modal.hide()
  }

  $scope.isSelectedAgentNoteVisibility = function (visibility) {
    const targetVisibility = normalizeAgentNoteVisibility(visibility)
    return !!($scope.agentNotes && $scope.agentNotes.selectedVisibility === targetVisibility)
  }

  $scope.selectAgentNoteVisibility = function (visibility) {
    if ($scope.isAgentNotesBusy()) return
    if ($scope.isSelectedAgentNoteVisibility(visibility)) return
    setActiveAgentNotesVisibility(visibility)
  }

  // Agent Notes live in the "Agent Notes" tab of the expanded property's left panel. Only one property is expanded
  // at a time, so the tab reuses the single agentNotes state and the #epReviewAgentNotesEditor Summernote instance.
  function showAgentNotesTab(report) {
    if (!report) return
    if ($scope.agentNotes.report !== report) {
      report.agent_notes_all = normalizeAgentNotesCollection(report.agent_notes_all, report)
      syncLegacyCurrentAgentNoteFields(report)

      destroyAgentNotesEditor()
      resetAgentNotesState()
      $scope.agentNotes.report = report
    }
    // Runs after the digest renders the tab's editor element
    initAgentNotesEditor(getAgentNotesDraftForVisibility($scope.agentNotes.selectedVisibility))
  }

  // Keep the draft, then tear the editor down before Angular removes its element
  function hideAgentNotesEditor() {
    syncAgentNotesDraftFromEditor()
    destroyAgentNotesEditor()
  }

  $scope.getInfoPanelTab = function (report) {
    const tab = report && report.infoTab
    return (tab === 'notes' || tab === 'owner') ? tab : 'info'
  }

  $scope.setInfoPanelTab = function (report, tab, $event) {
    try {
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
    } catch (e) { }
    if (!report) return

    const next = (tab === 'notes' || tab === 'owner') ? tab : 'info'
    if (next === $scope.getInfoPanelTab(report) && report.infoExpanded) return

    if (next !== 'notes') hideAgentNotesEditor()
    report.infoTab = next
    report.infoExpanded = true
    if (next === 'notes') showAgentNotesTab(report)
  }

  $scope.toggleInfoPanel = function (report, $event) {
    try {
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
    } catch (e) { }
    if (!report) return

    report.infoExpanded = !report.infoExpanded
    if ($scope.getInfoPanelTab(report) !== 'notes') return
    if (report.infoExpanded) showAgentNotesTab(report)
    else hideAgentNotesEditor()
  }

  function isMeaningfulHtml(html) {
    try {
      const str = String(html || '').trim()
      if (!str) return false
      if (str === '<p><br></p>') return false
      // Remove tags and &nbsp; to detect content.
      const textOnly = str
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim()
      return textOnly.length > 0
    } catch (e) {
      return false
    }
  }

  // The property owner's Condition Notes (written in the client portal), from getReviewReports
  $scope.hasOwnerConditionNotes = function (report) {
    return !!(report && report.owner_condition_notes && report.owner_condition_notes.notes_html)
  }

  $scope.setOwnerConditionNotesOnReport = function (report, show) {
    const notes = report && report.owner_condition_notes
    if (!notes || report._ownerNotesSaving) return
    const previous = notes.show_on_report
    notes.show_on_report = show ? 1 : 0
    report._ownerNotesSaving = true
    report._ownerNotesError = null
    $http.post('/review/setConditionNotesOnReport', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      tax_year: $scope.tax_year,
      prop_id: report.prop_id,
      user_id: report.user_id,
      show_on_report: show ? 1 : 0
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        report.owner_condition_notes = resp.data.data
      } else {
        notes.show_on_report = previous
        report._ownerNotesError = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      notes.show_on_report = previous
      report._ownerNotesError = 'Unable to save.'
    }).finally(function () {
      report._ownerNotesSaving = false
      safeApply($scope)
    })
  }

  $scope.hasAgentNotes = function (report) {
    if (!report) return false
    return getDisplayAgentNotes(report).length > 0
  }

  function saveAgentNotesImpl() {
    try {
      if (!$scope.agentNotes || !$scope.agentNotes.report) return Promise.resolve(null)

      const report = $scope.agentNotes.report
      const selectedVisibility = normalizeAgentNoteVisibility($scope.agentNotes.selectedVisibility)
      const showOnReport = selectedVisibility === 'public' ? 1 : 0
      const currentNote = getEditingAgentNote(report, selectedVisibility)

      syncAgentNotesDraftFromEditor()
      const html = getAgentNotesDraftForVisibility(selectedVisibility)
      if (!isMeaningfulHtml(html)) {
        $scope.agentNotes.error = 'Please enter note content before saving.'
        safeApply($scope)
        return Promise.reject(new Error('Please enter note content before saving.'))
      }

      $scope.agentNotes.saving = true
      $scope.agentNotes.error = null
      safeApply($scope)

      return $http.post('/review/saveReportNote', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        tax_year: $scope.tax_year,
        prop_id: report.prop_id,
        user_id: report.user_id,
        note_id: currentNote && currentNote.id ? Number(currentNote.id) : null,
        notes: html,
        show_on_report: showOnReport,
        use_on_cover_page: 0
      }).then(function (resp) {
        if (!(resp.data && resp.data.success)) {
          throw new Error((resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save agent notes.')
        }

        const savedNote = upsertAgentNoteInCollection(report, (resp.data && resp.data.note) ? resp.data.note : {
          id: resp.data && resp.data.note_id ? Number(resp.data.note_id) : null,
          agent_id: getCurrentAgentId(),
          agent_name: resp.data && resp.data.agent_name ? String(resp.data.agent_name) : null,
          notes: html,
          show_on_report: showOnReport,
          use_on_cover_page: 0,
          updated_at: resp.data && resp.data.updated_at ? resp.data.updated_at : new Date()
        })

        // Keep the saved note open so further edits update it rather than adding another note
        setAgentNotesEditingId(selectedVisibility, savedNote && savedNote.id)
        setAgentNotesDraftForVisibility(selectedVisibility, savedNote && savedNote.notes ? savedNote.notes : html)
        $scope.agentNotes.saving = false
        safeApply($scope)

        return savedNote
      }, function (err) {
        throw (err instanceof Error ? err : new Error('Unable to save agent notes.'))
      }).catch(function (err) {
        $scope.agentNotes.saving = false
        $scope.agentNotes.error = err && err.message ? String(err.message) : 'Unable to save agent notes.'
        safeApply($scope)
        return Promise.reject(err)
      })
    } catch (e) {
      $scope.agentNotes.saving = false
      $scope.agentNotes.error = 'Unable to save agent notes.'
      safeApply($scope)
      return Promise.reject(e)
    }
  }

  $scope.saveAgentNotes = function () {
    saveAgentNotesImpl()
  }

  $scope.moveEditingAgentNote = function () {
    try {
      if (!$scope.agentNotes || !$scope.agentNotes.report || $scope.isAgentNotesBusy()) return

      const report = $scope.agentNotes.report
      const sourceKey = normalizeAgentNoteVisibility($scope.agentNotes.selectedVisibility)
      const targetKey = sourceKey === 'public' ? 'private' : 'public'
      const sourceNote = getEditingAgentNote(report, sourceKey)
      if (!sourceNote || !sourceNote.id) return

      const performMove = function () {
        $scope.agentNotes.moving = true
        $scope.agentNotes.error = null
        safeApply($scope)

        return $http.post('/review/moveReportNoteVisibility', {
          crm_user_id: $scope.crm_user_id,
          crm_user_password: $scope.crm_user_password,
          note_id: sourceNote.id,
          show_on_report: targetKey === 'public' ? 1 : 0
        }).then(function (resp) {
          if (!(resp.data && resp.data.success)) {
            throw new Error((resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to change note visibility.')
          }

          const movedNote = upsertAgentNoteInCollection(report, (resp.data && resp.data.note) ? resp.data.note : {
            id: sourceNote.id,
            agent_id: sourceNote.agent_id,
            agent_name: sourceNote.agent_name,
            notes: sourceNote.notes,
            show_on_report: targetKey === 'public' ? 1 : 0,
            use_on_cover_page: sourceNote.use_on_cover_page,
            updated_at: resp.data && resp.data.updated_at ? resp.data.updated_at : new Date()
          })

          setAgentNotesEditingId(sourceKey, null)
          setAgentNotesDraftForVisibility(sourceKey, '')
          // Open the moved note on its new tab, unless that tab has unsaved typing of its own
          if (!isAgentNoteDraftDirty(targetKey)) {
            setAgentNotesEditingId(targetKey, movedNote && movedNote.id)
            setAgentNotesDraftForVisibility(targetKey, movedNote && movedNote.notes ? movedNote.notes : '')
          }
          $scope.agentNotes.moving = false
          setActiveAgentNotesVisibility(targetKey, { skipCapture: true })
          return movedNote
        }, function (err) {
          throw (err instanceof Error ? err : new Error('Unable to change note visibility.'))
        }).catch(function (err) {
          $scope.agentNotes.moving = false
          $scope.agentNotes.error = err && err.message ? String(err.message) : 'Unable to change note visibility.'
          safeApply($scope)
          return Promise.reject(err)
        })
      }

      syncAgentNotesDraftFromEditor()
      if (isAgentNoteDraftDirty(sourceKey) && isMeaningfulHtml(getAgentNotesDraftForVisibility(sourceKey))) {
        saveAgentNotesImpl().then(function () {
          performMove()
        })
        return
      }

      performMove()
    } catch (e) {
      $scope.agentNotes.error = 'Unable to change note visibility.'
      safeApply($scope)
    }
  }

  $scope.deleteAgentNote = function () {
    try {
      if (!$scope.agentNotes || !$scope.agentNotes.report) return
      const report = $scope.agentNotes.report
      const candidate = $scope.agentNotes.deleteCandidate || null
      const slotVisibility = candidate ? normalizeAgentNoteVisibility(candidate.visibility) : null
      const noteId = candidate && candidate.id ? Number(candidate.id) : null
      if (!slotVisibility || !noteId) return

      $scope.agentNotes.deleting = true
      $scope.agentNotes.error = null
      safeApply($scope)

      $http.post('/review/deleteReportNote', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        note_id: noteId
      }).then(function (resp) {
        if (!(resp.data && resp.data.success)) {
          throw new Error((resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to delete note.')
        }

        removeAgentNoteFromCollection(report, noteId)
        $scope.agentNotes.deleting = false
        $scope.agentNotes.deleteCandidate = null
        try {
          let modal = getAgentNoteDeleteConfirmModal()
          if (modal) modal.hide()
        } catch (e) { }
        if (getAgentNotesEditingId(slotVisibility) === noteId) {
          loadAgentNoteIntoEditor(slotVisibility, null)
        }
        safeApply($scope)
      }, function (err) {
        throw (err instanceof Error ? err : new Error('Unable to delete note.'))
      }).catch(function (err) {
        $scope.agentNotes.deleting = false
        $scope.agentNotes.error = err && err.message ? String(err.message) : 'Unable to delete note.'
        safeApply($scope)
      })
    } catch (e) {
      $scope.agentNotes.deleting = false
      $scope.agentNotes.error = 'Unable to delete note.'
      safeApply($scope)
    }
  }

  $scope.toggleReviewed = function (report) {
    try {
      if (!report) return

      const prevToggle = report.reviewed_toggle ? 1 : 0
      const prevById = report.reviewed_by_id || null
      const prevByName = report.reviewed_by_name || ''
      const prevByInitials = report.reviewed_by_initials || ''
      const prevOn = report.reviewed_on || null

      const next = report.reviewed_toggle ? 1 : 0
      try {
        if (Array.isArray(report.evidence_files)) {
          report.evidence_files.forEach(function (f) {
            if (!f) return
            if (next === 1) {
              f.reviewed_by_id = f.reviewed_by_id ? f.reviewed_by_id : Number($scope.crm_user_id)
              const crmName = ($scope.crmUser && ($scope.crmUser.first_name || $scope.crmUser.last_name))
                ? [($scope.crmUser.first_name || ''), ($scope.crmUser.last_name || '')].filter(Boolean).join(' ').trim()
                : ''
              f.reviewed_by_name = f.reviewed_by_name ? f.reviewed_by_name : crmName
              f.reviewed_by_initials = f.reviewed_by_initials ? f.reviewed_by_initials : ($scope.crmUser && $scope.crmUser.initials ? String($scope.crmUser.initials).trim().toUpperCase() : '')
              f.reviewed_on = f.reviewed_on ? f.reviewed_on : new Date()
            } else {
              f.reviewed_by_id = null
              f.reviewed_by_name = ''
              f.reviewed_by_initials = ''
              f.reviewed_on = null
            }
          })
        }
      } catch (e) { }

      recomputeReportReviewedToggle(report)

      report._reviewedUpdating = true
      safeApply($scope)

      $http.post('/review/updateReportReviewed', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        tax_year: $scope.tax_year,
        prop_id: report.prop_id,
        user_id: report.user_id,
        reviewed: next
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          try {
            if (Array.isArray(report.evidence_files)) {
              report.evidence_files.forEach(function (f) {
                if (!f) return
                if (next === 1) {
                  f.reviewed_by_id = resp.data.reviewed_by_id ? Number(resp.data.reviewed_by_id) : f.reviewed_by_id
                  f.reviewed_by_name = resp.data.reviewed_by_name ? String(resp.data.reviewed_by_name) : f.reviewed_by_name
                  f.reviewed_by_initials = resp.data.reviewed_by_initials ? String(resp.data.reviewed_by_initials).trim().toUpperCase() : f.reviewed_by_initials
                  f.reviewed_on = resp.data.reviewed_on ? $scope.portalDate(resp.data.reviewed_on) : f.reviewed_on
                } else {
                  f.reviewed_by_id = null
                  f.reviewed_by_name = ''
                  f.reviewed_by_initials = ''
                  f.reviewed_on = null
                }
              })
            }
          } catch (e) { }
          recomputeReportReviewedToggle(report)
          safeApply($scope)
          try { refreshCounties(true) } catch (e) { }
        } else {
          report.reviewed_toggle = prevToggle
          report.reviewed_by_id = prevById
          report.reviewed_by_name = prevByName
          report.reviewed_by_initials = prevByInitials
          report.reviewed_on = prevOn
          try {
            if (Array.isArray(report.evidence_files)) {
              report.evidence_files.forEach(function (f) {
                if (!f) return
                f.reviewed_by_id = prevById
                f.reviewed_by_name = prevByName
                f.reviewed_by_initials = prevByInitials
                f.reviewed_on = prevOn
              })
            }
          } catch (e) { }
          recomputeReportReviewedToggle(report)
          showMessageModal('Error updating reviewed status: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        report.reviewed_toggle = prevToggle
        report.reviewed_by_id = prevById
        report.reviewed_by_name = prevByName
        report.reviewed_by_initials = prevByInitials
        report.reviewed_on = prevOn
        try {
          if (Array.isArray(report.evidence_files)) {
            report.evidence_files.forEach(function (f) {
              if (!f) return
              f.reviewed_by_id = prevById
              f.reviewed_by_name = prevByName
              f.reviewed_by_initials = prevByInitials
              f.reviewed_on = prevOn
            })
          }
        } catch (e) { }
        recomputeReportReviewedToggle(report)
        showMessageModal('Error updating reviewed status')
        safeApply($scope)
      }).finally(function () {
        report._reviewedUpdating = false
        safeApply($scope)
      })
    } catch (e) {
      report.reviewed_toggle = report.reviewed_by_id ? 1 : 0
      report._reviewedUpdating = false
      safeApply($scope)
    }
  }

  function normalizeLoadedMessages(messages) {
    function normalizeReminderFields(item) {
      if (!item || typeof item !== 'object') return item
      item.needs_response = (item.needs_response === 1 || item.needs_response === '1' || item.needs_response === true || item.needs_response === 'true') ? 1 : 0
      return item
    }

    // Ensure replies is always an array (mysql JSON may arrive as string)
    try {
      if (!Array.isArray(messages)) return []
      return messages.map(function (m) {
        if (!m) return m
        if (typeof m.replies === 'string') {
          try { m.replies = JSON.parse(m.replies) } catch (e) { m.replies = [] }
        }
        if (!Array.isArray(m.replies)) m.replies = []
        m.replies = m.replies.map(normalizeReminderFields)
        normalizeReminderFields(m)
        return m
      })
    } catch (e) {
      return Array.isArray(messages) ? messages : []
    }
  }

  function ensureReportMessages(report, force) {
    try {
      if (!report) return Promise.resolve([])
      if (!force && report.messagesLoaded && Array.isArray(report.messages)) {
        return Promise.resolve(report.messages)
      }
      if (report.messagesLoading && report._messagesPromise) {
        return report._messagesPromise
      }

      report.messagesLoading = true
      report.messagesError = null
      safeApply($scope)

      report._messagesPromise = $http.post('/review/getReviewReportMessages', {
        tax_year: $scope.tax_year,
        prop_id: report.prop_id,
        user_id: report.user_id
      }).then(function (resp) {
        report.messagesLoading = false
        if (resp.data && resp.data.success) {
          report.messages = normalizeLoadedMessages(Array.isArray(resp.data.data) ? resp.data.data : [])
          report.messagesLoaded = true
          syncMessageCounts(report)
          syncMessageLastDates(report)
          safeApply($scope)
          return report.messages
        } else {
          report.messagesError = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to load messages.'
          safeApply($scope)
          return []
        }
      }, function () {
        report.messagesLoading = false
        report.messagesError = 'Unable to load messages.'
        safeApply($scope)
        return []
      }).finally(function () {
        try { report._messagesPromise = null } catch (e) { }
      })

      return report._messagesPromise
    } catch (e) {
      try {
        report.messagesLoading = false
        report.messagesError = 'Unable to load messages.'
        safeApply($scope)
      } catch (e2) { }
      return Promise.resolve([])
    }
  }

  // SendGrid delivered / open events for the emails sent with each message; loaded after the messages so the
  // Message Center opens without waiting on the (slower) webhook table
  function ensureReportMessageEmailEvents(report, force) {
    try {
      if (!report) return Promise.resolve({})
      if (!force && report.messageEmailEventsLoaded) return Promise.resolve(report.messageEmailEvents || {})
      if (report._messageEmailEventsPromise) return report._messageEmailEventsPromise

      report._messageEmailEventsPromise = $http.post('/review/getReviewMessageEmailEvents', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        tax_year: $scope.tax_year,
        user_id: report.user_id
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          report.messageEmailEvents = resp.data.data || {}
          report.messageEmailEventsLoaded = true
        }
        safeApply($scope)
        return report.messageEmailEvents || {}
      }, function () {
        return report.messageEmailEvents || {}
      }).finally(function () {
        report._messageEmailEventsPromise = null
      })

      return report._messageEmailEventsPromise
    } catch (e) {
      return Promise.resolve({})
    }
  }

  // Shared objects (not new literals) so the directive's one-way binding sees a stable value between digests
  const MESSAGE_EMAIL_EVENTS_LOADING = { state: 'loading' }
  const MESSAGE_EMAIL_EVENTS_NONE = { state: 'none' }

  // Agent messages are emailed to the client; client replies are not, so they get null (nothing shown)
  $scope.getMessageEmailEvents = function (message) {
    try {
      const report = $scope.messageCenter && $scope.messageCenter._activeReport
      if (!message || !message.message_id || !report) return null
      if (normalizeSenderType(message.sender_type) !== 'employee') return null
      if (!report.messageEmailEventsLoaded) return MESSAGE_EMAIL_EVENTS_LOADING
      return (report.messageEmailEvents || {})[String(message.message_id)] || MESSAGE_EMAIL_EVENTS_NONE
    } catch (e) {
      return null
    }
  }

  function ensureReportPropertyDetails(report, force) {
    try {
      if (!report) return Promise.resolve(null)
      if (!force && report.propertyDetailsLoaded) {
        return Promise.resolve(report.propertyDetails || null)
      }
      if (report.propertyDetailsLoading && report._propertyDetailsPromise) {
        return report._propertyDetailsPromise
      }

      report.propertyDetailsLoading = true
      report.propertyDetailsError = null
      safeApply($scope)

      report._propertyDetailsPromise = $http.post('/review/getReviewReportPropertyDetails', {
        crm_user_id: parseInt($scope.crm_user_id, 10),
        tax_year: parseInt($scope.tax_year, 10),
        user_id: report.user_id,
        prop_id: report.prop_id,
        cad_code: report.cad_code,
        cad_account: report.cad_account
      }).then(function (resp) {
        report.propertyDetailsLoading = false
        if (resp.data && resp.data.success) {
          report.propertyDetails = resp.data.data || null
          if (report.propertyDetails && report.propertyDetails.input) {
            const rawValue = report.propertyDetails.custom_field_value
            const type = report.propertyDetails.input.type

            if (type === 'slider' || type === 'number') {
              let num = Number(rawValue)
              report.propertyDetails.input_value = (rawValue != null && rawValue !== '' && !isNaN(num)) ? num : null
            } else {
              const normalizedValue = (rawValue != null) ? String(rawValue).trim() : rawValue
              report.propertyDetails.input_value = normalizedValue

              if (type === 'select' && Array.isArray(report.propertyDetails.input.options)) {
                report.propertyDetails.input.options = report.propertyDetails.input.options.filter(function (opt) {
                  if (!opt) return false
                  const v = opt.value
                  if (v === null || v === undefined) return false
                  if (typeof v === 'string' && v.trim() === '') return false
                  return true
                })

                report.propertyDetails.input.options.forEach(function (opt) {
                  opt.value = String(opt.value).trim()
                })

                const optionValues = report.propertyDetails.input.options.map(function (opt) {
                  return opt.value
                })

                const normalizedStr = (normalizedValue != null) ? String(normalizedValue).trim() : null
                if (normalizedStr == null || optionValues.indexOf(normalizedStr) === -1) {
                  const labelMatch = report.propertyDetails.input.options.find(function (opt) {
                    const label = (opt && opt.label != null) ? String(opt.label).trim() : ''
                    return normalizedStr != null && label !== '' && label.toLowerCase() === normalizedStr.toLowerCase()
                  })

                  if (labelMatch) {
                    report.propertyDetails.input_value = labelMatch.value
                  } else {
                    report.propertyDetails.input_value = optionValues.length ? optionValues[0] : null
                  }
                }
              }
            }
          }
          applyConditionOverrideToReport(report, report.propertyDetails, true)
          report.propertyDetailsLoaded = true
          applySavedAgentValuation(report, report.propertyDetails)
          safeApply($scope)
          console.log('Loaded property details:', report.propertyDetails)
          return report.propertyDetails
        } else {
          report.propertyDetailsError = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to load property details.'
          safeApply($scope)
          return null
        }
      }, function () {
        report.propertyDetailsLoading = false
        report.propertyDetailsError = 'Unable to load property details.'
        safeApply($scope)
        return null
      }).finally(function () {
        try { report._propertyDetailsPromise = null } catch (e) { }
      })

      return report._propertyDetailsPromise
    } catch (e) {
      try {
        report.propertyDetailsLoading = false
        report.propertyDetailsError = 'Unable to load property details.'
        safeApply($scope)
      } catch (e2) { }
      return Promise.resolve(null)
    }
  }

  function applyConditionOverrideInputValue(report, savedValue) {
    try {
      let pDetails = report && report.propertyDetails ? report.propertyDetails : null
      if (!pDetails || !pDetails.input || savedValue === null || typeof savedValue === 'undefined') return

      let type = pDetails.input.type
      if (type === 'slider' || type === 'number') {
        let num = Number(savedValue)
        if (!isNaN(num)) pDetails.input_value = num
        return
      }

      let normalizedValue = String(savedValue).trim()
      if (type === 'select' && Array.isArray(pDetails.input.options)) {
        let optionValues = pDetails.input.options.map(function (opt) {
          return opt && opt.value != null ? String(opt.value).trim() : null
        }).filter(Boolean)

        if (optionValues.indexOf(normalizedValue) !== -1) {
          pDetails.input_value = normalizedValue
          return
        }

        let labelMatch = pDetails.input.options.find(function (opt) {
          let label = opt && opt.label != null ? String(opt.label).trim() : ''
          return label && label.toLowerCase() === normalizedValue.toLowerCase()
        })
        if (labelMatch && labelMatch.value != null) {
          pDetails.input_value = String(labelMatch.value).trim()
        }
      }
    } catch (e) { }
  }

  function applyConditionOverrideToReport(report, data, applySavedValues) {
    try {
      if (!report || !data) return

      var savedInputValue = data.condition_override_value != null ? data.condition_override_value : data.value
      var savedConditionValue = data.condition_override_condition_value != null ? data.condition_override_condition_value : data.condition_value

      report.conditionOverrideId = data.condition_override_id != null
        ? Number(data.condition_override_id)
        : (data.id != null ? Number(data.id) : null)

      report.conditionOverrideCrmUserId = data.condition_override_crm_user_id != null
        ? Number(data.condition_override_crm_user_id)
        : (data.crm_user_id != null ? Number(data.crm_user_id) : null)

      report.conditionOverrideCrmUserName = data.condition_override_crm_user_name
        ? String(data.condition_override_crm_user_name).trim()
        : (data.crm_user_name ? String(data.crm_user_name).trim() : '')

      report.conditionOverrideUpdatedAt = data.condition_override_updated_at
        ? $scope.portalDate(data.condition_override_updated_at)
        : (data.updatedAT ? $scope.portalDate(data.updatedAT) : (data.createdAT ? $scope.portalDate(data.createdAT) : null))

      if (report.propertyDetails) {
        report.propertyDetails.override_value = data.override_value != null ? Number(data.override_value) : null
        report.propertyDetails.calculated_value = data.calculated_value != null ? Number(data.calculated_value) : null
      }

      report.conditionOverrideSavedInputValue = savedInputValue != null ? String(savedInputValue).trim() : null
      report.conditionOverrideSavedConditionValue = normalizeRevisedConditionValue(savedConditionValue)
      if (report.conditionOverrideSavedConditionValue === '') report.conditionOverrideSavedConditionValue = '0'

      if (applySavedValues) {
        applyConditionOverrideInputValue(report, savedInputValue)
      }

      syncComputedRevisedConditionValue(report)
    } catch (e) { }
  }

  function getConditionOverrideDefaultInputValue(report) {
    try {
      if (!report || !report.propertyDetails) return null
      if (report.propertyDetails.custom_field_value == null) return null
      return String(report.propertyDetails.custom_field_value).trim()
    } catch (e) {
      return null
    }
  }

  function normalizeConditionOverrideInputValue(report, value) {
    try {
      if (value == null) return ''

      var stringValue = String(value).trim()
      if (!report || !report.propertyDetails || !report.propertyDetails.input) return stringValue

      var type = report.propertyDetails.input.type
      if (type === 'slider') {
        var numericValue = Number(stringValue)
        return isFinite(numericValue) ? String(numericValue) : stringValue
      }

      return stringValue
    } catch (e) {
      return value == null ? '' : String(value).trim()
    }
  }

  function hasRevisedConditionChanges(report) {
    try {
      if (!report || !report.propertyDetails || !report.propertyDetails.input) return false
      if (report.conditionOverrideSaving || report.conditionOverrideRestoring) return false

      var currentValue = normalizeRevisedConditionValue(getRevisedConditionRawValue(report))
      if (currentValue === '') currentValue = '0'

      var savedValue = normalizeRevisedConditionValue(report.conditionOverrideSavedConditionValue)
      if (savedValue === '') savedValue = '0'

      return currentValue !== savedValue
    } catch (e) {
      return false
    }
  }

  function hasConditionOverrideChanges(report) {
    try {
      if (!report || !report.propertyDetails || !report.propertyDetails.input) return false
      if (report.conditionOverrideSaving || report.conditionOverrideRestoring) return false
      if (report.conditionOverrideId) return true

      var currentInputValue = normalizeConditionOverrideInputValue(report, report.propertyDetails.input_value)
      var defaultInputValue = normalizeConditionOverrideInputValue(report, getConditionOverrideDefaultInputValue(report))
      if (currentInputValue !== defaultInputValue) return true

      return hasRevisedConditionChanges(report)
    } catch (e) {
      return false
    }
  }

  function resetConditionOverrideToDefaults(report) {
    try {
      if (!report) return

      report.conditionOverrideId = null
      report.conditionOverrideCrmUserId = null
      report.conditionOverrideCrmUserName = ''
      report.conditionOverrideUpdatedAt = null
      report.conditionOverrideRestoreConfirm = false
      report.conditionOverrideSavedInputValue = getConditionOverrideDefaultInputValue(report)
      report.conditionOverrideSavedConditionValue = '0'

      if (report.propertyDetails) {
        applyConditionOverrideInputValue(report, report.propertyDetails.custom_field_value)
        report.propertyDetails.override_value = null
        report.propertyDetails.calculated_value = null
      }

      syncComputedRevisedConditionValue(report)
      report.propertyDetailsError = null
      safeApply($scope)
    } catch (e) { }
  }

  $scope.getConditionOverrideAuditUserLine = function (report) {
    try {
      if (!report || !report.conditionOverrideCrmUserId) return ''

      let name = String(report.conditionOverrideCrmUserName || '').trim()
      if (name) return name + ' (' + report.conditionOverrideCrmUserId + ')'
      return String(report.conditionOverrideCrmUserId)
    } catch (e) {
      return ''
    }
  }

  $scope.canRestoreConditionOverrideDefaults = function (report) {
    return hasConditionOverrideChanges(report)
  }

  $scope.getConditionValueAmount = function (report) {
    try {
      if (!report) return 0
      return toMoneyNumber(report.revisedConditionValue)
    } catch (e) {
      return 0
    }
  }

  $scope.getOpionionOfValueAmount = function (report) {
    try {
      if (!report || !report.propertyDetails) return 0

      var baseValue = report.propertyDetails.override_value != null
        ? toMoneyNumber(report.propertyDetails.override_value)
        : toMoneyNumber(report.propertyDetails.total_market)

      return baseValue - toMoneyNumber(report.revisedConditionValue)
    } catch (e) {
      return 0
    }
  }

  $scope.shouldShowNoRepairReductionMessage = function (report) {
    try {
      if (!report || !report.propertyDetails || !report.propertyDetails.custom_field_header) return false

      var conditionReductionAmount = toMoneyNumber(report.propertyDetails.calculated_value)
      var repairReductionAmount = toMoneyNumber(report.revisedConditionValue)

      return conditionReductionAmount === 0
        && repairReductionAmount === 0
        && !hasConditionOverrideChanges(report)
    } catch (e) {
      return false
    }
  }

  $scope.getConditionOverrideAuditDateLine = function (report) {
    try {
      if (!report) return ''

      let d = report.conditionOverrideUpdatedAt
      if (d instanceof Date && !isNaN(d.getTime())) {
        let month = d.getMonth() + 1
        let day = d.getDate()
        let year = d.getFullYear()
        let hours = d.getHours()
        let ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        if (hours === 0) hours = 12
        let minutes = String(d.getMinutes()).padStart(2, '0')
        return month + '/' + day + '/' + year + ' - ' + hours + ':' + minutes + ampm
      }

      return ''
    } catch (e) {
      return ''
    }
  }

  function buildConditionOverridePayload(report) {
    try {
      if (!report || !report.propertyDetails || !report.propertyDetails.input) return null

      var conditionValueRaw = getRevisedConditionRawValue(report)
      var conditionValue = conditionValueRaw === '' ? 0 : parseInt(conditionValueRaw, 10)
      var taxYear = parseInt($scope.tax_year, 10)
      var crmUserId = parseInt($scope.crm_user_id, 10)

      return {
        override_id: report.conditionOverrideId || null,
        crm_user_id: crmUserId,
        tax_year: taxYear,
        user_id: report.user_id,
        prop_id: report.prop_id,
        cad_code: report.cad_code,
        cad_account: report.cad_account,
        name: report.propertyDetails.input.name,
        value: report.propertyDetails.input_value,
        condition_value: conditionValue
      }
    } catch (e) {
      return null
    }
  }


  $scope.onCustomFieldChange = function (report) {
    var payload = buildConditionOverridePayload(report)
    if (!payload) return
    if (report.conditionOverrideSaving || report.conditionOverrideRestoring) return
    report.conditionOverrideRestoreConfirm = false

    console.log('Custom field changed:', {
      crm_user_id: payload.crm_user_id,
      tax_year: payload.tax_year,
      user_id: payload.user_id,
      prop_id: payload.prop_id,
      cad_code: payload.cad_code,
      cad_account: payload.cad_account,
      name: payload.name,
      value: report.propertyDetails,
      condition_value: payload.condition_value
    })

    report.conditionOverrideSaving = true

    $http.post('/review/getDesirabilityValues', payload).then(function (resp) {
      if (resp.data.data && resp.data.success) {
        applyConditionOverrideToReport(report, resp.data.data, false)
        safeApply($scope)
      }
    }).finally(function () {
      report.conditionOverrideSaving = false
      safeApply($scope)
    })
  }

  $scope.beginRestoreConditionOverrideDefaults = function (report, $event) {
    try {
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
    } catch (e) { }

    if (!report) return
    if (report.conditionOverrideSaving || report.conditionOverrideRestoring) return

    report.conditionOverrideRestoreConfirm = true
    safeApply($scope)
  }

  $scope.cancelRestoreConditionOverrideDefaults = function (report, $event) {
    try {
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
    } catch (e) { }

    if (!report) return
    if (report.conditionOverrideRestoring) return

    report.conditionOverrideRestoreConfirm = false
    safeApply($scope)
  }

  $scope.restoreConditionOverrideDefaults = function (report, $event) {
    try {
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
    } catch (e) { }

    if (!report) return
    if (report.conditionOverrideSaving || report.conditionOverrideRestoring) return

    report.conditionOverrideRestoreConfirm = false

    var payload = buildConditionOverridePayload(report) || {}

    if (!report.conditionOverrideId) {
      resetConditionOverrideToDefaults(report)
      return
    }

    payload.override_id = report.conditionOverrideId || null

    report.conditionOverrideRestoring = true

    $http.post('/review/deleteConditionOverride', payload).then(function (resp) {
      if (resp.data && resp.data.success) {
        resetConditionOverrideToDefaults(report)
        return
      }

      report.propertyDetailsError = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to restore default values.'
      safeApply($scope)
    }, function () {
      report.propertyDetailsError = 'Unable to restore default values.'
      safeApply($scope)
    }).finally(function () {
      report.conditionOverrideRestoring = false
      safeApply($scope)
    })
  }

  $scope.openReviewMessageCenter = function (report) {
    try {
      $scope.messageCenter.error = null
      $scope.messageCenter.loading = true
      $scope.messageCenter.view = 'list'
      $scope.messageCenter.selected = null
      $scope.messageCenter.expandedBodies = {}
      $scope.portalMessages = []
      $scope.activeProp = report || null
      $scope.messageCenter._activeReport = report || null
      safeApply($scope)

      ensureReportMessages(report, false).then(function () {
        $scope.portalMessages = (report && Array.isArray(report.messages)) ? report.messages : []
        $scope.messageCenter.loading = false
        safeApply($scope)

        let modal = getReviewMessageCenterModal()
        if (modal) modal.show()
      })
      // Always refetch: opens keep arriving after the email is sent
      ensureReportMessageEmailEvents(report, true)
    } catch (e) {
      $scope.messageCenter.loading = false
      $scope.messageCenter.error = 'Unable to open Message Center.'
      safeApply($scope)
    }
  }

  $scope.closeReviewMessageCenter = function () {
    let modal = getReviewMessageCenterModal()
    if (modal) modal.hide()
  }

  $scope.refreshReviewMessageCenter = function () {
    try {
      let report = $scope.messageCenter && $scope.messageCenter._activeReport ? $scope.messageCenter._activeReport : null
      if (!report) return

      let selectedId = null
      try { selectedId = ($scope.messageCenter.selected && $scope.messageCenter.selected.message_id) ? Number($scope.messageCenter.selected.message_id) : null } catch (e) { selectedId = null }

      $scope.messageCenter.error = null
      $scope.messageCenter.loading = true
      safeApply($scope)

      ensureReportMessageEmailEvents(report, true)
      ensureReportMessages(report, true).then(function () {
        $scope.portalMessages = (report && Array.isArray(report.messages)) ? report.messages : []
        $scope.messageCenter.loading = false
        // Restore selection.
        try {
          if (selectedId && Array.isArray($scope.portalMessages)) {
            let updated = $scope.portalMessages.find(m => m && Number(m.message_id) === selectedId)
            if (updated) $scope.messageCenter.selected = updated
          }
        } catch (e) { }

        safeApply($scope)
        scheduleReviewMessageCenterThreadScrollToTop()
      })
    } catch (e) {
      $scope.messageCenter.loading = false
      $scope.messageCenter.error = 'Unable to reload messages.'
      safeApply($scope)
    }
  }

  function resetReportListFilters() {
    $scope.reviewStatusFilter = 'all'
    $scope.reviewerFilter = 'all'
    $scope.filterType = 'all'
    $scope.itemsToReviewOnly = false
    $scope.showUnreadOnly = false
    $scope.showNeedsResponseOverdueOnly = false
    $scope.showNeedsFollowUpOnly = false
    $scope.showAiDiscrepancyOnly = false
  }

  $scope.onCountyChange = function () {
    resetReportListFilters()
    loadReports()
  }

  $scope.refreshReports = function () {
    loadReports()
  }

  // -- Sent Messages view (header button + envelope button by the search box) ----------------------------------
  // One row per message thread an agent emailed this tax year, across all counties: sent / delivered / opened /
  // replied. Rendered in batches like the report list; a tax year can have ~1,000 threads.
  const SENT_EMAILS_BATCH = 100

  // Status of a thread, most important first. Any open counts as opened (see isMessageEmailOpened).
  const SENT_EMAIL_STATUSES = {
    unread_reply: { label: 'Unread reply', rank: 0 },
    replied: { label: 'Replied', rank: 1 },
    failed: { label: 'Not delivered', rank: 2 },
    opened: { label: 'Opened, no reply', rank: 3 },
    not_opened: { label: 'Not opened', rank: 4 }
  }

  // divider: a rule above the option in the Status dropdown, grouping responded / not responded
  $scope.sentEmailStatusOptions = [
    { value: 'all', label: 'All statuses' },
    { value: 'replied_any', label: 'Responded', divider: true },
    { value: 'unread_reply', label: 'Unread replies' },
    { value: 'no_reply', label: 'No response', divider: true },
    { value: 'opened', label: 'Opened, no reply' },
    { value: 'not_opened', label: 'Not opened' },
    { value: 'failed', label: 'Not delivered' }
  ]

  $scope.sentEmails = {
    loading: false,
    error: null,
    items: [],
    county: 'all',
    status: 'all',
    search: '',
    sort: 'last_activity',
    sortDesc: true,
    limit: SENT_EMAILS_BATCH
  }
  $scope.sentEmailsCountyOptions = [{ value: 'all', label: 'All Counties' }]

  function sentEmailStatus(e) {
    if (e.unread_reply_count > 0) return 'unread_reply'
    if (e.reply_count > 0) return 'replied'
    if (e.failed_event && !(e.delivered_count > 0)) return 'failed'
    if (e.open_count > 0) return 'opened'
    return 'not_opened'
  }

  $scope.sentEmailStatusLabel = function (e) {
    return (SENT_EMAIL_STATUSES[e && e._status] || {}).label || ''
  }

  $scope.showMoreSentEmails = function () {
    $scope.sentEmails.limit += SENT_EMAILS_BATCH
  }

  $scope.resetSentEmailsLimit = function () {
    $scope.sentEmails.limit = SENT_EMAILS_BATCH
  }

  $scope.loadSentEmails = function () {
    $scope.sentEmails.loading = true
    $scope.sentEmails.error = null

    return $http.post('/review/getReviewSentEmails', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      tax_year: $scope.tax_year
    }).then(function (resp) {
      if (!(resp.data && resp.data.success)) {
        $scope.sentEmails.error = (resp.data && resp.data.error) || 'Unable to load sent messages.'
        return
      }

      const items = Array.isArray(resp.data.data) ? resp.data.data : []
      const counties = {}
      items.forEach(function (e) {
        e.emails_sent = Number(e.emails_sent) || 0
        e.reply_count = Number(e.reply_count) || 0
        e.unread_reply_count = Number(e.unread_reply_count) || 0
        e.delivered_count = Number(e.delivered_count) || 0
        e.open_count = Number(e.open_count) || 0
        e.machine_open_count = Number(e.machine_open_count) || 0
        e.first_sent_at = $scope.portalDate(e.first_sent_at)
        e.last_sent_at = $scope.portalDate(e.last_sent_at)
        e.last_reply_at = $scope.portalDate(e.last_reply_at)
        e.last_activity_at = $scope.portalDate(e.last_activity_at)
        // Opens are ISO timestamps from SendGrid (already UTC)
        e.first_opened_at = e.first_opened_at ? new Date(e.first_opened_at) : null
        e.last_opened_at = e.last_opened_at ? new Date(e.last_opened_at) : null
        e._status = sentEmailStatus(e)
        e._client = ((e.first_name || '') + ' ' + (e.last_name || '')).trim()
        e._search = [e._client, e.address, e.subject, e.last_sent_by, e.prop_id, e.user_id, e.cad_account, e.county]
          .join(' ').toLowerCase()
        if (e.cad_code != null) {
          const cad = String(e.cad_code)
          if (!counties[cad]) counties[cad] = { label: e.county || ('CAD ' + e.cad_code), count: 0 }
          counties[cad].count++
        }
      })
      $scope.sentEmails.items = items

      $scope.sentEmailsCountyOptions = [{ value: 'all', label: 'All Counties', count: items.length }].concat(
        Object.keys(counties).map(function (cad) {
          return { value: cad, label: counties[cad].label, count: counties[cad].count }
        }).sort(function (a, b) {
          return a.label.localeCompare(b.label)
        })
      )
      if (!$scope.sentEmailsCountyOptions.some(function (o) { return o.value === $scope.sentEmails.county })) {
        $scope.sentEmails.county = 'all'
      }
    }, function () {
      $scope.sentEmails.error = 'Unable to load sent messages.'
    }).finally(function () {
      $scope.sentEmails.loading = false
    })
  }

  function sentEmailMatchesStatus(e, status) {
    switch (status) {
      case 'replied_any': return e.reply_count > 0
      case 'no_reply': return !(e.reply_count > 0)
      case 'all': return true
      default: return e._status === status
    }
  }

  function sentEmailMatchesCountyAndSearch(e) {
    if ($scope.sentEmails.county !== 'all' && String(e.cad_code) !== $scope.sentEmails.county) return false
    const search = String($scope.sentEmails.search || '').trim().toLowerCase()
    if (search && e._search.indexOf(search) === -1) return false
    return true
  }

  $scope.sentEmailsFilter = function (e) {
    if (!e) return false
    return sentEmailMatchesCountyAndSearch(e) && sentEmailMatchesStatus(e, $scope.sentEmails.status)
  }

  // Totals for the summary bar: the county and search filters apply, the status filter doesn't (so the
  // numbers stay the same while you click between statuses)
  let _sentEmailsSummaryCache = null
  $scope.getSentEmailsSummary = function () {
    // Called several times per digest from the summary bar - recompute only when the inputs change
    const key = [$scope.sentEmails.county, $scope.sentEmails.search].join('|')
    if (_sentEmailsSummaryCache && _sentEmailsSummaryCache.items === $scope.sentEmails.items && _sentEmailsSummaryCache.key === key) {
      return _sentEmailsSummaryCache.summary
    }

    const summary = { threads: 0, opened: 0, replied: 0, unread: 0, openedNoReply: 0, notOpened: 0, failed: 0 }
    ;($scope.sentEmails.items || []).forEach(function (e) {
      if (!sentEmailMatchesCountyAndSearch(e)) return
      summary.threads++
      if (e.open_count > 0 || e.reply_count > 0) summary.opened++
      if (e.reply_count > 0) summary.replied++
      if (e.unread_reply_count > 0) summary.unread++
      if (e._status === 'opened') summary.openedNoReply++
      if (e._status === 'not_opened') summary.notOpened++
      if (e._status === 'failed') summary.failed++
    })
    summary.openedPct = summary.threads ? Math.round((summary.opened / summary.threads) * 100) : 0
    summary.repliedPct = summary.threads ? Math.round((summary.replied / summary.threads) * 100) : 0
    _sentEmailsSummaryCache = { items: $scope.sentEmails.items, key: key, summary: summary }
    return summary
  }

  $scope.setSentEmailsStatus = function (status) {
    $scope.sentEmails.status = status
    $scope.resetSentEmailsLimit()
  }

  $scope.setSentEmailsCounty = function (county) {
    $scope.sentEmails.county = county
    $scope.resetSentEmailsLimit()
  }

  $scope.getSentEmailsCountyLabel = function () {
    const option = ($scope.sentEmailsCountyOptions || []).find(function (o) { return o.value === $scope.sentEmails.county })
    return option ? option.label : 'All Counties'
  }

  $scope.getSentEmailsStatusLabel = function () {
    const option = $scope.sentEmailStatusOptions.find(function (o) { return o.value === $scope.sentEmails.status })
    return option ? option.label : 'All statuses'
  }

  // Count shown beside each option in the Status dropdown (county + search applied, like the summary bar)
  $scope.getSentEmailsStatusCount = function (status) {
    const s = $scope.getSentEmailsSummary()
    switch (status) {
      case 'all': return s.threads
      case 'replied_any': return s.replied
      case 'unread_reply': return s.unread
      case 'no_reply': return s.threads - s.replied
      case 'opened': return s.openedNoReply
      case 'not_opened': return s.notOpened
      case 'failed': return s.failed
      default: return ''
    }
  }

  const SENT_EMAIL_SORTS = {
    client: function (e) { return (e._client || '~').toLowerCase() },
    county: function (e) { return (e.county || '~').toLowerCase() },
    last_sent: function (e) { return e.last_sent_at ? e.last_sent_at.getTime() : 0 },
    first_opened: function (e) { return e.first_opened_at ? e.first_opened_at.getTime() : 0 },
    last_reply: function (e) { return e.last_reply_at ? e.last_reply_at.getTime() : 0 },
    status: function (e) { return (SENT_EMAIL_STATUSES[e._status] || {}).rank },
    last_activity: function (e) { return e.last_activity_at ? e.last_activity_at.getTime() : 0 }
  }

  $scope.sentEmailsSortValue = function (e) {
    return (SENT_EMAIL_SORTS[$scope.sentEmails.sort] || SENT_EMAIL_SORTS.last_activity)(e)
  }

  // Clicking a column header cycles ascending -> descending -> unsorted. Unsorted is the default order: most recent
  // activity first (last_activity, which has no column of its own).
  $scope.sortSentEmails = function (key) {
    if ($scope.sentEmails.sort !== key) {
      $scope.sentEmails.sort = key
      $scope.sentEmails.sortDesc = false
    } else if (!$scope.sentEmails.sortDesc) {
      $scope.sentEmails.sortDesc = true
    } else {
      $scope.sentEmails.sort = 'last_activity'
      $scope.sentEmails.sortDesc = true
    }
    $scope.resetSentEmailsLimit()
  }

  $scope.isSentEmailsSortedBy = function (key) {
    return $scope.sentEmails.sort === key
  }

  $scope.sentEmailsSortIcon = function (key) {
    if ($scope.sentEmails.sort !== key) return 'fa-sort'
    return $scope.sentEmails.sortDesc ? 'fa-sort-down' : 'fa-sort-up'
  }

  $scope.sentEmailsAriaSort = function (key) {
    if ($scope.sentEmails.sort !== key) return 'none'
    return $scope.sentEmails.sortDesc ? 'descending' : 'ascending'
  }

  let _sentEmailsModal = null
  function getSentEmailsModal() {
    try {
      const el = document.getElementById('epSentEmailsModal')
      if (!el) return null
      if (!_sentEmailsModal && $window.bootstrap && $window.bootstrap.Modal) {
        _sentEmailsModal = $window.bootstrap.Modal.getOrCreateInstance(el)
      }
      return _sentEmailsModal
    } catch (e) {
      return null
    }
  }

  $scope.openSentEmails = function () {
    const modal = getSentEmailsModal()
    if (modal) modal.show()
    $scope.resetSentEmailsLimit()
    $scope.loadSentEmails()
  }

  $scope.closeSentEmails = function () {
    const modal = getSentEmailsModal()
    if (modal) modal.hide()
  }

  function findLoadedReportByPropId(propId) {
    return ($scope.reports || []).find(function (r) {
      return r && String(r.prop_id) === String(propId)
    }) || null
  }

  // Scroll the report list so the row sits right under the sticky table header
  function scrollReportRowToTop(propId) {
    const container = $window.document.querySelector('.ep-review-table-container')
    const row = $window.document.getElementById('ep-report-row-' + propId)
    if (!container || !row) return

    const thead = container.querySelector('thead')
    const headerHeight = thead ? thead.offsetHeight : 0
    container.scrollTop += row.getBoundingClientRect().top - container.getBoundingClientRect().top - headerHeight
    container.scrollIntoView({ block: 'nearest' })
  }

  function revealReport(report) {
    const isShown = function () {
      return ($scope.filteredReports || []).filter($scope.searchFilter).indexOf(report) !== -1
    }

    if (!isShown()) {
      resetReportListFilters()
      $scope.applyFilter()
    }
    // A search narrows the list without reloading it; search for this property instead
    if (!isShown() && $scope.searchText) {
      $scope.searchText = String(report.prop_id)
    }

    if (!report.expanded) $scope.toggleReportExpanded(report)

    const index = ($scope.filteredReports || []).filter($scope.searchFilter).indexOf(report)
    $scope.reportRowLimit = Math.max($scope.reportRowLimit, index + 1)
    safeApply($scope)

    // Once for the render, and again after the expanded panel's content settles the row heights
    $window.setTimeout(function () { scrollReportRowToTop(report.prop_id) }, 50)
    $window.setTimeout(function () { scrollReportRowToTop(report.prop_id) }, 500)
  }

  $scope.goToSentEmailProperty = function (email) {
    if (!email) return
    $scope.closeSentEmails()

    if (findLoadedReportByPropId(email.prop_id)) {
      revealReport(findLoadedReportByPropId(email.prop_id))
      return
    }

    // Not in the loaded list: switch to the property's county and load it
    const county = ($scope.counties || []).find(function (c) {
      return c && c.cad_code != null && String(c.cad_code) === String(email.cad_code)
    })
    if (!county || $scope.searchText) {
      showMessageModal('This property is not in the report list.')
      return
    }

    $scope.selectedCounty = county
    resetReportListFilters()
    loadReports().then(function () {
      const report = findLoadedReportByPropId(email.prop_id)
      if (report) {
        revealReport(report)
      } else {
        showMessageModal('This property is not in the report list.')
      }
    })
  }

  $scope.refreshReportFromPortal = function (report, $event) {
    try {
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
    } catch (e) { }

    if (!report) return

    if (!clientPortalRefreshState || !reportMatchesIdentity(clientPortalRefreshState.identity, report)) {
      rememberClientPortalReport(report)
    }
    if (clientPortalRefreshState) {
      clientPortalRefreshState.changedAt = Date.now()
      clientPortalRefreshState.dirty = true
      clientPortalRefreshState.awaitingReturn = false
    }

    refreshReportFromPortalReturn(report)
  }

  $scope.isPortalRefreshPending = function (report) {
    try {
      if (!clientPortalRefreshState || !clientPortalRefreshState.refreshing) return false
      return reportMatchesIdentity(clientPortalRefreshState.identity, report)
    } catch (e) {
      return false
    }
  }

  function getSortableNumber(value) {
    const numberValue = Number(value)
    return isFinite(numberValue) ? numberValue : 0
  }

  function getReportLastUpdatedTime(report) {
    try {
      if (!report) return 0

      const candidateValues = [
        report.use_report_changed_on,
        report.agent_note_updated_at,
        report.reviewed_on,
        report.msg_last_thread_at,
        report.msg_last_reply_at,
        report.msg_last_unread_at,
        report.msg_last_overdue_response_at,
        report.conditionOverrideUpdatedAt,
        report.report_info && report.report_info.report_last_update
      ]

      if (Array.isArray(report.evidence_files)) {
        report.evidence_files.forEach(function (file) {
          if (file && file.updated_at) candidateValues.push(file.updated_at)
        })
      }

      return candidateValues.reduce(function (latest, value) {
        const parsed = $scope.portalDate(value)
        const time = parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed.getTime() : 0
        return time > latest ? time : latest
      }, 0)
    } catch (e) {
      return 0
    }
  }

  function applyReportSort(reports) {
    const sortKey = String($scope.sortOption || '')
    if (!sortKey) return reports

    return reports.slice().sort(function (left, right) {
      let leftValue = 0
      let rightValue = 0

      if (sortKey === 'photo_count') {
        leftValue = getSortableNumber(left && left.photo_count)
        rightValue = getSortableNumber(right && right.photo_count)
      } else if (sortKey === 'document_count') {
        leftValue = getSortableNumber(left && left.document_count)
        rightValue = getSortableNumber(right && right.document_count)
      } else if (sortKey === 'last_updated') {
        leftValue = getReportLastUpdatedTime(left)
        rightValue = getReportLastUpdatedTime(right)
      }

      if (rightValue !== leftValue) return rightValue - leftValue

      const leftPropId = left && left.prop_id != null ? String(left.prop_id) : ''
      const rightPropId = right && right.prop_id != null ? String(right.prop_id) : ''
      return leftPropId.localeCompare(rightPropId)
    })
  }

  function rebuildReviewerFilterOptions() {
    const options = [{ value: 'all', label: 'ALL Reviewers' }]
    const seenReviewerIds = new Set()

      ; ($scope.reports || []).forEach(function (report) {
        if (!report || report.reviewed_by_id == null || !report.reviewed_by_name) return

        const reviewerId = String(report.reviewed_by_id)
        if (seenReviewerIds.has(reviewerId)) return

        seenReviewerIds.add(reviewerId)
        options.push({
          value: reviewerId,
          label: String(report.reviewed_by_name)
        })
      })

    options.sort(function (left, right) {
      if (left.value === 'all') return -1
      if (right.value === 'all') return 1
      return String(left.label || '').localeCompare(String(right.label || ''))
    })

    $scope.reviewerFilterOptions = options
    if (!$scope.reviewerFilterOptions.some(function (option) { return option.value === $scope.reviewerFilter })) {
      $scope.reviewerFilter = 'all'
    }
  }

  // Render the report list in batches. With Chrome's accessibility mode on (enabled by many
  // desktop tools), a fully rendered 400+ row table blocks the browser's input thread for
  // seconds whenever the page changes, e.g. when a property is expanded.
  const REPORT_ROW_BATCH = 50
  $scope.reportRowLimit = REPORT_ROW_BATCH

  $scope.showMoreReports = function () {
    $scope.reportRowLimit += REPORT_ROW_BATCH
  }

  function getExpandedReportRowCount() {
    try {
      const matched = ($scope.filteredReports || []).filter($scope.searchFilter)
      const index = matched.findIndex(function (r) { return r && r.expanded })
      return index + 1
    } catch (e) {
      return 0
    }
  }

  // Start over at the first batch when the user changes what the list shows...
  $scope.$watchGroup([
    'selectedCounty', 'searchText', 'sortOption', 'filterType', 'reviewStatusFilter', 'reviewerFilter',
    'itemsToReviewOnly', 'showUnreadOnly', 'showNeedsResponseOverdueOnly', 'showNeedsFollowUpOnly', 'showAiDiscrepancyOnly'
  ], function () {
    $scope.reportRowLimit = Math.max(REPORT_ROW_BATCH, getExpandedReportRowCount())
  })

  // ...but on other list refreshes (usage toggles, portal refresh) only grow, keeping the
  // expanded report rendered.
  $scope.$watch('filteredReports', function () {
    $scope.reportRowLimit = Math.max($scope.reportRowLimit, getExpandedReportRowCount())
  })

  $scope.applyFilter = function () {
    let result = Array.isArray($scope.reports) ? $scope.reports.slice() : []

    if ($scope.filterType === 'use') {
      result = result.filter(r => r.report_ready === 1)
    } else if ($scope.filterType === 'not_use') {
      result = result.filter(r => r.report_ready !== 1)
    }

    if ($scope.reviewStatusFilter === 'reviewed') {
      result = result.filter(r => r.reviewed_toggle === 1)
    } else if ($scope.reviewStatusFilter === 'not_reviewed') {
      result = result.filter(r => r.reviewed_toggle !== 1)
    }

    if ($scope.reviewerFilter !== 'all') {
      result = result.filter(function (r) {
        return r && r.reviewed_by_id != null && String(r.reviewed_by_id) === String($scope.reviewerFilter)
      })
    }

    if ($scope.itemsToReviewOnly) {
      result = result.filter(r => r.reviewed_toggle !== 1)
    }

    if ($scope.showUnreadOnly) {
      result = result.filter(r => (r && r._msgUnread) ? Number(r._msgUnread) > 0 : false)
    }

    if ($scope.showNeedsResponseOverdueOnly) {
      result = result.filter(r => (r && r._msgOverdueResponse) ? Number(r._msgOverdueResponse) > 0 : false)
    }

    if ($scope.showNeedsFollowUpOnly) {
      result = result.filter(r => r && Number(r.follow_up_needed) === 1)
    }

    if ($scope.showAiDiscrepancyOnly) {
      result = result.filter(r => r && $scope.getAiDiscrepancyFiles(r).length > 0)
    }

    $scope.filteredReports = applyReportSort(result)

    try {
      var expanded = $scope.reports.filter(r => r && r.expanded)
      if (expanded.length > 1) {
        for (var i = 1; i < expanded.length; i++) {
          expanded[i].expanded = false
        }
      }
    } catch (e) { }
  }

  $scope.searchFilter = function (item) {
    if (!$scope.searchText) return true
    const text = $scope.searchText.toLowerCase()
    return (item.user_id && String(item.user_id).toLowerCase().includes(text)) ||
      (item.prop_id && String(item.prop_id).toLowerCase().includes(text)) ||
      (item.cad_account && String(item.cad_account).toLowerCase().includes(text)) ||
      (item.address && String(item.address).toLowerCase().includes(text))
  }

  $scope.clearSearch = function () {
    $scope.searchText = ''
  }

  $scope.$watch('searchText', function (newValue, oldValue) {
    const nextHasText = String(newValue || '').trim().length > 0
    const prevHasText = String(oldValue || '').trim().length > 0

    if (nextHasText === prevHasText) return
    if (!$scope.selectedCounty) return
    if (searchScopeAllCountiesActive === nextHasText && oldValue !== undefined) return

    loadReports()
  })

  $scope.toggleFiltersCollapsed = function () {
    $scope.filtersCollapsed = !$scope.filtersCollapsed
    // The mouse is still on the toggle, so don't let the hover peek reopen the bar until it leaves
    $scope.filtersPeekSuppressed = $scope.filtersCollapsed
  }

  $scope.onItemsToReviewOnlyChange = function () {
    try {
      $scope.applyFilter()
    } catch (e) { }
  }

  $scope.toggleReportExpanded = function (report) {
    try {
      if (!report) return

      var shouldExpand = !report.expanded
      hideAgentNotesEditor()
      $scope.reports.forEach(function (r) {
        r.expanded = false
      })
      report.expanded = shouldExpand

      if (shouldExpand) {
        ensureReportMessages(report, false)
        ensureReportPropertyDetails(report, false)

        expandEvidenceFiles(report)
        if (report.infoExpanded && $scope.getInfoPanelTab(report) === 'notes') showAgentNotesTab(report)
      }

      safeApply($scope)
    } catch (e) {
      console.error('Error toggling report expanded:', e)
    }
  }

  $scope.toggleUseReport = function (report) {
    if (report.use_report === 0) {
      $scope.currentReportForReason = report
      $scope.tempReason = ''
      if (!reasonModal) {
        reasonModal = new $window.bootstrap.Modal(document.getElementById('reasonModal'))
      }
      reasonModal.show()
    } else {
      updateUsage(report, 1, null)
    }
  }

  $scope.saveReason = function () {
    if (!$scope.currentReportForReason) return
    updateUsage($scope.currentReportForReason, 0, $scope.tempReason)
    if (reasonModal) reasonModal.hide()
  }

  $scope.cancelReason = function () {
    // Revert toggle if cancelled
    if ($scope.currentReportForReason) {
      $scope.currentReportForReason.use_report = 1
    }
    if (reasonModal) reasonModal.hide()
  }

  function updateUsage(report, use_report, reason) {
    $http.post('/review/updateReportUsage', {
      usage_id: report.usage_id,
      prop_id: report.prop_id,
      tax_year: $scope.tax_year,
      use_report: use_report,
      reason: reason,
      change_by_crm_user: $scope.crm_user_id
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        if (resp.data.usage_id) {
          report.usage_id = resp.data.usage_id
        }
        try {
          report.use_report = use_report === 1 ? 1 : 0
          report.reason = reason || null
          report.change_by_crm_user = $scope.crm_user_id
          const crmName = ($scope.crmUser && ($scope.crmUser.first_name || $scope.crmUser.last_name))
            ? [($scope.crmUser.first_name || ''), ($scope.crmUser.last_name || '')].filter(Boolean).join(' ').trim()
            : ''
          if (crmName) report.crm_user_name = crmName
          report.use_report_changed_on = new Date()
        } catch (e) { }
        $scope.applyFilter()
      } else {
        showMessageModal('Error updating usage: ' + (resp.data.error || 'Unknown error'))
        report.use_report = use_report === 1 ? 0 : 1
      }
    })
  }

  $scope.toggleReportFollowUp = function (report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!report || report._followUpUpdating) return

      var previousValue = report.follow_up_needed === 1 ? 1 : 0
      var nextValue = previousValue === 1 ? 0 : 1

      report._followUpUpdating = true
      safeApply($scope)

      $http.post('/review/updateReportFollowUp', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        usage_id: report.usage_id,
        prop_id: report.prop_id,
        tax_year: $scope.tax_year,
        follow_up_needed: nextValue,
        change_by_crm_user: $scope.crm_user_id
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          if (resp.data.usage_id) {
            report.usage_id = resp.data.usage_id
          }
          report.follow_up_needed = nextValue
        } else {
          report.follow_up_needed = previousValue
          showMessageModal('Error updating follow up flag: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
        }
      }, function () {
        report.follow_up_needed = previousValue
        showMessageModal('Error updating follow up flag')
      }).finally(function () {
        report._followUpUpdating = false
        safeApply($scope)
      })
    } catch (e) {
      try {
        report._followUpUpdating = false
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.toggleEvidenceActive = function (file) {
    $http.post('/review/updateEvidenceActive', {
      id: file.id,
      active: file.active
    }).then(function (resp) {
      if (!resp.data || !resp.data.success) {
        showMessageModal('Error updating active status')
        file.active = file.active === 1 ? 0 : 1
      }
    })
  }

  $scope.getEvidenceUseOnReportLabel = function (file) {
    if (isReferenceOnlyFile(file)) return 'Reference'
    return (file && Number(file.active) === 1) ? 'Yes' : 'No'
  }

  $scope.clearEvidenceReviewed = function (file, report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!file || !file.id) return
      if (file._clearingReviewed) return

      file._clearingReviewed = true
      safeApply($scope)

      $http.post('/review/clearEvidenceReviewed', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        id: file.id,
        tax_year: $scope.tax_year,
        prop_id: file.prop_id,
        user_id: file.user_id
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          file.reviewed_by_id = null
          file.reviewed_by_name = ''
          file.reviewed_by_initials = ''
          file.reviewed_on = null

          if (report) {
            recomputeReportReviewedToggle(report)
          }

          safeApply($scope)
        } else {
          showMessageModal('Error updating reviewed status: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        showMessageModal('Error updating reviewed status')
        safeApply($scope)
      }).finally(function () {
        file._clearingReviewed = false
        safeApply($scope)
      })
    } catch (e) {
      try {
        file._clearingReviewed = false
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.setEvidenceReviewed = function (file, report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!file || !file.id) return
      if (file._settingReviewed) return

      file._settingReviewed = true
      safeApply($scope)

      $http.post('/review/setEvidenceReviewed', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        id: file.id
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          file.reviewed_by_id = resp.data.reviewed_by_id ? Number(resp.data.reviewed_by_id) : Number($scope.crm_user_id)
          const crmName = ($scope.crmUser && ($scope.crmUser.first_name || $scope.crmUser.last_name))
            ? [($scope.crmUser.first_name || ''), ($scope.crmUser.last_name || '')].filter(Boolean).join(' ').trim()
            : ''
          file.reviewed_by_name = resp.data.reviewed_by_name ? String(resp.data.reviewed_by_name) : crmName
          file.reviewed_by_initials = resp.data.reviewed_by_initials ? String(resp.data.reviewed_by_initials).trim().toUpperCase() : ($scope.crmUser && $scope.crmUser.initials ? String($scope.crmUser.initials).trim().toUpperCase() : '')
          file.reviewed_on = resp.data.reviewed_on ? $scope.portalDate(resp.data.reviewed_on) : new Date()

          if (report) {
            recomputeReportReviewedToggle(report)
          }

          safeApply($scope)
        } else {
          showMessageModal('Error updating reviewed status: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        showMessageModal('Error updating reviewed status')
        safeApply($scope)
      }).finally(function () {
        file._settingReviewed = false
        safeApply($scope)
      })
    } catch (e) {
      try {
        file._settingReviewed = false
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.updateEvidenceUsageStatus = function (file, report) {
    try {
      if (!file || !file.id) return
      if (file._usageStatusUpdating) return

      const nextStatus = String(file.usage_status || getEvidenceUsageStatus(file) || 'pending')
      const previousState = {
        active: file.active,
        reviewed_by_id: file.reviewed_by_id,
        reviewed_by_name: file.reviewed_by_name,
        reviewed_by_initials: file.reviewed_by_initials,
        reviewed_on: file.reviewed_on,
        updated_at: file.updated_at,
        usage_status: getEvidenceUsageStatus(file)
      }

      file._usageStatusUpdating = true
      safeApply($scope)

      $http.post('/review/updateEvidenceUsageStatus', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        id: file.id,
        status: nextStatus
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          file.active = resp.data.active === 1 ? 1 : 0
          file.reviewed_by_id = resp.data.reviewed_by_id ? Number(resp.data.reviewed_by_id) : null
          file.reviewed_by_name = resp.data.reviewed_by_name ? String(resp.data.reviewed_by_name) : null
          file.reviewed_by_initials = resp.data.reviewed_by_initials ? String(resp.data.reviewed_by_initials).trim().toUpperCase() : null
          file.reviewed_on = resp.data.reviewed_on ? $scope.portalDate(resp.data.reviewed_on) : null
          file.updated_at = resp.data.updated_at ? $scope.portalDate(resp.data.updated_at) : file.updated_at
          file.usage_status = resp.data.status || nextStatus
          syncEvidenceUsageState(file)

          if (report) {
            recomputeReportReviewedToggle(report)
          }

          // The server drops the reason when a file leaves Do Not Use; set to Do Not Use, the optional reason
          // popover opens by its "No" (Cancel or a click elsewhere skips it)
          if (file.usage_status !== 'do_not_use_on_report') {
            file._usageNote = null
            if ($scope.usageNotePop.file === file) $scope.closeUsageNotePop()
          } else if (!file._usageNote) {
            $window.setTimeout(function () {
              const btn = document.getElementById('epUsageNoteBtn-' + file.id)
              if (btn && file.usage_status === 'do_not_use_on_report') $scope.$apply(function () { openUsageNotePop(file, btn) })
            }, 0)
          }

          safeApply($scope)
        } else {
          restoreEvidenceUsageState(file, previousState)
          if (report) {
            recomputeReportReviewedToggle(report)
          }
          showMessageModal('Error updating evidence usage status: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        restoreEvidenceUsageState(file, previousState)
        if (report) {
          recomputeReportReviewedToggle(report)
        }
        showMessageModal('Error updating evidence usage status')
        safeApply($scope)
      }).finally(function () {
        file._usageStatusUpdating = false
        safeApply($scope)
      })
    } catch (e) {
      try {
        file._usageStatusUpdating = false
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.markAllEvidenceDoNotUseOnReport = function (report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!report || report._bulkEvidenceUsageUpdating) return
      if (!Array.isArray(report.evidence_files) || report.evidence_files.length === 0) return

      const reportIdentity = getReportIdentity(report)
      if (!reportIdentity) {
        showMessageModal('Unable to identify the selected report for bulk evidence update.')
        return
      }

      const previousStates = report.evidence_files.map(function (file) {
        return {
          file: file,
          snapshot: {
            active: file.active,
            reviewed_by_id: file.reviewed_by_id,
            reviewed_by_name: file.reviewed_by_name,
            reviewed_by_initials: file.reviewed_by_initials,
            reviewed_on: file.reviewed_on,
            updated_at: file.updated_at,
            usage_status: getEvidenceUsageStatus(file)
          }
        }
      })

      report._bulkEvidenceUsageUpdating = true
      report.evidence_files.forEach(function (file) {
        if (!file) return
        file._usageStatusUpdating = true
      })
      safeApply($scope)

      $http.post('/review/markAllEvidenceDoNotUseOnReport', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        prop_id: reportIdentity.prop_id,
        user_id: reportIdentity.user_id,
        tax_year: reportIdentity.tax_year
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          report.evidence_files.forEach(function (file) {
            if (!file) return
            file.active = 0
            file.reviewed_by_id = resp.data.reviewed_by_id ? Number(resp.data.reviewed_by_id) : null
            file.reviewed_by_name = resp.data.reviewed_by_name ? String(resp.data.reviewed_by_name) : null
            file.reviewed_by_initials = resp.data.reviewed_by_initials ? String(resp.data.reviewed_by_initials).trim().toUpperCase() : null
            file.reviewed_on = resp.data.reviewed_on ? $scope.portalDate(resp.data.reviewed_on) : null
            file.updated_at = resp.data.updated_at ? $scope.portalDate(resp.data.updated_at) : file.updated_at
            file.usage_status = 'do_not_use_on_report'
            syncEvidenceUsageState(file)
          })

          recomputeReportReviewedToggle(report)
          safeApply($scope)
        } else {
          previousStates.forEach(function (entry) {
            restoreEvidenceUsageState(entry.file, entry.snapshot)
          })
          recomputeReportReviewedToggle(report)
          showMessageModal('Error updating all evidence usage statuses: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        previousStates.forEach(function (entry) {
          restoreEvidenceUsageState(entry.file, entry.snapshot)
        })
        recomputeReportReviewedToggle(report)
        showMessageModal('Error updating all evidence usage statuses')
        safeApply($scope)
      }).finally(function () {
        report._bulkEvidenceUsageUpdating = false
        report.evidence_files.forEach(function (file) {
          if (!file) return
          file._usageStatusUpdating = false
        })
        safeApply($scope)
      })
    } catch (e) {
      try {
        report._bulkEvidenceUsageUpdating = false
        if (report && Array.isArray(report.evidence_files)) {
          report.evidence_files.forEach(function (file) {
            if (!file) return
            file._usageStatusUpdating = false
          })
        }
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.markAllEvidenceUseOnReport = function (report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!report || report._bulkEvidenceUsageUpdating) return
      if (!Array.isArray(report.evidence_files) || report.evidence_files.length === 0) return

      const reportIdentity = getReportIdentity(report)
      if (!reportIdentity) {
        showMessageModal('Unable to identify the selected report for bulk evidence update.')
        return
      }

      const previousStates = report.evidence_files.map(function (file) {
        return {
          file: file,
          snapshot: {
            active: file.active,
            reviewed_by_id: file.reviewed_by_id,
            reviewed_by_name: file.reviewed_by_name,
            reviewed_by_initials: file.reviewed_by_initials,
            reviewed_on: file.reviewed_on,
            updated_at: file.updated_at,
            usage_status: getEvidenceUsageStatus(file)
          }
        }
      })

      report._bulkEvidenceUsageUpdating = true
      report.evidence_files.forEach(function (file) {
        if (!file) return
        file._usageStatusUpdating = true
      })
      safeApply($scope)

      $http.post('/review/markAllEvidenceUseOnReport', {
        crm_user_id: $scope.crm_user_id,
        crm_user_password: $scope.crm_user_password,
        prop_id: reportIdentity.prop_id,
        user_id: reportIdentity.user_id,
        tax_year: reportIdentity.tax_year
      }).then(function (resp) {
        if (resp.data && resp.data.success) {
          report.evidence_files.forEach(function (file) {
            if (!file) return
            file.active = 1
            file.reviewed_by_id = resp.data.reviewed_by_id ? Number(resp.data.reviewed_by_id) : null
            file.reviewed_by_name = resp.data.reviewed_by_name ? String(resp.data.reviewed_by_name) : null
            file.reviewed_by_initials = resp.data.reviewed_by_initials ? String(resp.data.reviewed_by_initials).trim().toUpperCase() : null
            file.reviewed_on = resp.data.reviewed_on ? $scope.portalDate(resp.data.reviewed_on) : null
            file.updated_at = resp.data.updated_at ? $scope.portalDate(resp.data.updated_at) : file.updated_at
            file.usage_status = 'use_on_report'
            syncEvidenceUsageState(file)
          })

          recomputeReportReviewedToggle(report)
          safeApply($scope)
        } else {
          previousStates.forEach(function (entry) {
            restoreEvidenceUsageState(entry.file, entry.snapshot)
          })
          recomputeReportReviewedToggle(report)
          showMessageModal('Error updating all evidence usage statuses: ' + ((resp.data && resp.data.error) ? resp.data.error : 'Unknown error'))
          safeApply($scope)
        }
      }, function () {
        previousStates.forEach(function (entry) {
          restoreEvidenceUsageState(entry.file, entry.snapshot)
        })
        recomputeReportReviewedToggle(report)
        showMessageModal('Error updating all evidence usage statuses')
        safeApply($scope)
      }).finally(function () {
        report._bulkEvidenceUsageUpdating = false
        report.evidence_files.forEach(function (file) {
          if (!file) return
          file._usageStatusUpdating = false
        })
        safeApply($scope)
      })
    } catch (e) {
      try {
        report._bulkEvidenceUsageUpdating = false
        if (report && Array.isArray(report.evidence_files)) {
          report.evidence_files.forEach(function (file) {
            if (!file) return
            file._usageStatusUpdating = false
          })
        }
        safeApply($scope)
      } catch (e2) { }
    }
  }

  $scope.viewReport = function (r) {
    const env = getEvidenceOrigin()
    const taxYear = r && r.tax_year != null ? String(r.tax_year) : ($scope.tax_year != null ? String($scope.tax_year) : '')
    const taxYearQuery = taxYear ? `?tax_year=${encodeURIComponent(taxYear)}` : ''

    if (env.isLocalhost) {
      // Local dev: server allows unauth preview without user_token.
      const url = `/report/${encodeURIComponent(String(r.prop_id))}/${encodeURIComponent(String(r.user_id))}/report${taxYearQuery}`
      $window.open(url, '_blank')
      return
    }

    const userToken = getReportToken(r)
    const url = `${env.evidenceOrigin}/report/${encodeURIComponent(String(r.prop_id))}/${encodeURIComponent(String(r.user_id))}/${encodeURIComponent(userToken)}/preview${taxYearQuery}`
    $window.open(url, '_blank')
  }

  function getEvidenceOrigin() {
    const hostname = ($window.location && $window.location.hostname) ? String($window.location.hostname).toLowerCase() : ''
    const isLocalhost = (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1')
    let evidenceOrigin = 'https://evidence.propertytax.io'

    if (isLocalhost) {
      evidenceOrigin = ($window.location && $window.location.origin)
        ? String($window.location.origin)
        : `${$window.location.protocol}//${$window.location.host}`
    } else if (
      hostname === 'evidence.texasptc.com'
      || hostname === 'texasptc.com'
      || hostname === 'evidence.texastpc.com'
      || hostname === 'texastpc.com'
    ) {
      evidenceOrigin = 'https://evidence.texasptc.com'
    } else if (hostname === 'evidence.propertytax.io' || hostname === 'propertytax.io') {
      evidenceOrigin = 'https://evidence.propertytax.io'
    }

    return {
      evidenceOrigin: evidenceOrigin,
      isLocalhost: isLocalhost
    }
  }

  function getReportToken(report) {
    return (report && (report.user_token || report.token)) ? String(report.user_token || report.token) : ''
  }

  function buildClientPortalUrl(report, file) {
    if (!report || !report.user_id || !report.prop_id) return ''

    const token = getReportToken(report)
    if (!token) return ''

    const env = getEvidenceOrigin()
    let url = `${env.evidenceOrigin}/${encodeURIComponent(String(report.user_id))}/${encodeURIComponent(token)}/${encodeURIComponent(String(report.prop_id))}`

    return url
  }

  function storeClientPortalEditIntent(report, file) {
    try {
      if (!$window || !$window.localStorage || !report || !file || file.id == null) return

      const targetUrl = buildClientPortalUrl(report, file)
      const targetOrigin = targetUrl ? (function () {
        try {
          return String(new URL(targetUrl).origin || '')
        } catch (e) {
          return ''
        }
      })() : ''

      const payload = {
        user_id: report.user_id != null ? String(report.user_id) : '',
        prop_id: report.prop_id != null ? String(report.prop_id) : '',
        file_id: String(file.id),
        gcs_path: file.gcs_path != null ? String(file.gcs_path) : '',
        original_name: file.original_name != null ? String(file.original_name) : '',
        size_bytes: file.size_bytes != null ? String(file.size_bytes) : '',
        target_origin: targetOrigin,
        target_url: targetUrl,
        emitted_at: Date.now()
      }

      if (!payload.user_id || !payload.prop_id || !payload.file_id) return
      $window.localStorage.setItem(PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY, JSON.stringify(payload))
    } catch (e) { }
  }

  $scope.canOpenClientPortal = function (r) {
    return !!buildClientPortalUrl(r)
  }

  $scope.openClientPortal = function (r, file, $event) {
    if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()

    const url = buildClientPortalUrl(r, file)
    if (!url) return

    storeClientPortalEditIntent(r, file)
    rememberClientPortalReport(r)
    $window.open(url, '_blank')
  }

  $scope.createPdf = function (r) {
    $scope.pdfGenerating = true
    safeApply($scope)

    $http.post('/report/createPdf', {
      prop_id: r.prop_id,
      user_id: r.user_id,
      tax_year: $scope.tax_year,
      user_token: (r && (r.user_token || r.token)) ? String(r.user_token || r.token) : ''
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        loadReports()
      } else {
        showMessageModal('Error creating PDF: ' + (resp.data.error || 'Unknown error'))
      }
    }).finally(function () {
      $scope.pdfGenerating = false
      safeApply($scope)
    })
  }

  $scope.viewPdf = function (r) {
    if (r.report_info && r.report_info.report_url) {
      $window.open(r.report_info.report_url, '_blank')
    }
  }

  $scope.hasMeta = function (file) {
    return file && file.meta_json && Object.keys(file.meta_json).length > 0
  }

  $scope.parseMeta = function (meta) {
    return meta || {}
  }

  $scope.isDate = function (key) {
    return key.toLowerCase().includes('date')
  }

  $scope.isAmount = function (key) {
    return key.toLowerCase().includes('amount') || key.toLowerCase().includes('value') || key.toLowerCase().includes('cost') || key.toLowerCase().includes('price')
  }

  $scope.isBooleanKey = function (key) {
    return key === 'issue_existed_jan1'
  }

  // --- Inline editing of the client-entered evidence fields (pencil after the label; X cancels, check saves).
  // Field types and dropdown options come from the client portal's allowedFileTypesConfig; the server checks the
  // value against the same definition and saves it in the portal's format (server updateEvidenceMetaField).
  const EDITABLE_EVIDENCE_META_TYPES = ['date', 'select', 'amount', 'text', 'textarea']

  $scope.getEvidenceMetaField = function (file, key) {
    try {
      const typeConfig = allowedFileTypesConfig && file ? allowedFileTypesConfig[String(file.content_type_key || '').toUpperCase()] : null
      const fields = typeConfig && Array.isArray(typeConfig.fields) ? typeConfig.fields : []
      return fields.find(function (f) { return f && f.key === key }) || null
    } catch (e) {
      return null
    }
  }

  $scope.canEditEvidenceMeta = function (file, key) {
    const field = $scope.getEvidenceMetaField(file, key)
    return !!(field && EDITABLE_EVIDENCE_META_TYPES.indexOf(field.type) > -1)
  }

  function isEvidenceMetaFieldShown(field, meta) {
    const rule = field && field.showWhen
    if (!rule || !rule.key) return true
    const current = meta[rule.key]
    if (Array.isArray(rule.in)) return rule.in.indexOf(current) > -1
    if (Object.prototype.hasOwnProperty.call(rule, 'equals')) return current === rule.equals
    return true
  }

  function isEvidenceMetaValueEmpty(value) {
    return value === null || value === undefined || String(value).trim() === ''
  }

  // Rows for a file's details table: every field the client portal asks for on that file type, in the portal's
  // order - including ones the client left blank (row.missing, so the agent can fill them in) - then any other keys
  // already stored. Conditional "other" fields only appear when their dropdown is set to Other; a blank checkbox is
  // skipped (checkboxes are read-only here). Cached on the file so ng-repeat sees the same row objects each digest.
  $scope.getEvidenceMetaRows = function (file) {
    try {
      if (!file) return []
      const meta = file.meta_json || {}
      const cacheKey = String(file.content_type_key || '') + '|' + JSON.stringify(meta)
      if (file._metaRows && file._metaRowsKey === cacheKey) return file._metaRows

      const typeConfig = allowedFileTypesConfig ? allowedFileTypesConfig[String(file.content_type_key || '').toUpperCase()] : null
      const fields = typeConfig && Array.isArray(typeConfig.fields) ? typeConfig.fields : []
      const rows = []
      const seen = {}

      fields.forEach(function (field) {
        if (!field || !field.key || !isEvidenceMetaFieldShown(field, meta)) return
        const value = meta[field.key]
        const missing = isEvidenceMetaValueEmpty(value)
        if (missing && EDITABLE_EVIDENCE_META_TYPES.indexOf(field.type) === -1) return
        seen[field.key] = true
        rows.push({ key: field.key, value: value, missing: missing })
      })

      Object.keys(meta).forEach(function (key) {
        if (seen[key] || isEvidenceMetaValueEmpty(meta[key])) return
        // The PDF / Word file a photo was taken from is shown as its own "From:" link below the table
        if (key === 'source_file') return
        // A leftover "other" text whose dropdown is no longer Other stays hidden, like in the portal
        const field = fields.find(function (f) { return f && f.key === key })
        if (field && !isEvidenceMetaFieldShown(field, meta)) return
        rows.push({ key: key, value: meta[key], missing: false })
      })

      file._metaRowsKey = cacheKey
      file._metaRows = rows
      return rows
    } catch (e) {
      return []
    }
  }

  $scope.isEditingEvidenceMeta = function (file, key) {
    return !!(file && file._metaEdit && file._metaEdit.key === key)
  }

  // A notes (textarea) field being edited: its row drops the label cell so the editor spans the table
  $scope.isEditingEvidenceNotes = function (file, key) {
    return $scope.isEditingEvidenceMeta(file, key) && file._metaEdit.field && file._metaEdit.field.type === 'textarea'
  }

  // Local midnight for a stored date (the portal saves the date input's value, e.g. 2026-03-09T05:00:00.000Z)
  function toEditableDate(value) {
    const d = value ? new Date(value) : new Date()
    const base = isNaN(d.getTime()) ? new Date() : d
    return new Date(base.getFullYear(), base.getMonth(), base.getDate())
  }

  $scope.startEvidenceMetaEdit = function (file, key, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const field = $scope.getEvidenceMetaField(file, key)
    if (!field || !$scope.canEditEvidenceMeta(file, key)) return

    const current = (file.meta_json || {})[key]
    let value = current
    if (field.type === 'date') value = toEditableDate(current) // today when empty, so the calendar opens there
    else if (field.type === 'amount') value = (current === null || current === undefined || current === '') ? null : Math.round(toMoneyNumber(current))
    else if (field.type === 'text' || field.type === 'textarea') value = current == null ? '' : String(current)

    file._metaEdit = { key: key, field: field, value: value, saving: false, error: null }

    // Focus the editor; the date field opens its calendar straight away
    $window.setTimeout(function () {
      try {
        const el = document.getElementById('epMetaEdit-' + file.id + '-' + key)
        if (!el) return
        el.focus()
        if (field.type === 'date' && typeof el.showPicker === 'function') el.showPicker()
      } catch (e) { }
    }, 0)
  }

  $scope.cancelEvidenceMetaEdit = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (file && file._metaEdit && !file._metaEdit.saving) file._metaEdit = null
  }

  $scope.onEvidenceMetaEditKeydown = function (file, $event) {
    if (!$event) return
    // Notes are a text area: Enter adds a line, Ctrl+Enter saves
    const isTextarea = !!(file && file._metaEdit && file._metaEdit.field && file._metaEdit.field.type === 'textarea')
    if ($event.key === 'Enter' && (!isTextarea || $event.ctrlKey || $event.metaKey)) {
      $event.preventDefault()
      $scope.saveEvidenceMetaEdit(file, $event)
    } else if ($event.key === 'Escape') {
      $event.preventDefault()
      $scope.cancelEvidenceMetaEdit(file, $event)
    }
  }

  $scope.saveEvidenceMetaEdit = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const edit = file && file._metaEdit
    if (!edit || edit.saving) return

    edit.saving = true
    edit.error = null
    $http.post('/review/updateEvidenceMetaField', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      key: edit.key,
      value: edit.value
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        file.meta_json = resp.data.data.meta_json || {}
        if (resp.data.data.updated_at) file.updated_at = resp.data.data.updated_at
        // The server keeps the saved AI result in step with the edit
        if (resp.data.data.ai_verification) {
          setAiResult(file, resp.data.data.ai_verification)
        } else if (file._ai && file._ai.result && file._ai.result.fields) {
          delete file._ai.result.fields[edit.key]
        }
        file._metaEdit = null
      } else {
        edit.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      edit.error = 'Unable to save.'
    }).finally(function () {
      edit.saving = false
      safeApply($scope)
    })
  }

  // --- Verify with AI: Claude reads the PDF / photo and checks each field the client entered (server
  // verifyEvidenceWithAi). Filled fields get a check or an X; blank fields may get a suggested value (shown in red)
  // that the agent accepts (saved through updateEvidenceMetaField) or dismisses. The server saves each result
  // (z_evidence_portal_3_ai_verification) and sends it back with the file as ai_verification, so it survives a reload.
  $scope.canVerifyWithAi = function (file) {
    return $scope.isPdf(file) || $scope.isImage(file)
  }

  function setAiResult(file, result) {
    if (!file) return
    if (!file._ai) file._ai = { loading: false, error: null, result: null, accepting: {} }
    file._ai.result = result || null
  }

  function restoreAiVerification(file) {
    let saved = file ? file.ai_verification : null
    if (typeof saved === 'string') {
      try { saved = JSON.parse(saved) } catch (e) { saved = null }
    }
    if (file) delete file.ai_verification
    if (saved && typeof saved === 'object') setAiResult(file, saved)

    let change = file ? file.ai_type_change : null
    if (typeof change === 'string') {
      try { change = JSON.parse(change) } catch (e) { change = null }
    }
    if (file) {
      delete file.ai_type_change
      file._aiTypeChange = (change && typeof change === 'object') ? change : null
      file._aiSummaryOnReport = Number(file.ai_summary_on_report) === 1
      delete file.ai_summary_on_report

      let fileChange = file.ai_file_change
      if (typeof fileChange === 'string') {
        try { fileChange = JSON.parse(fileChange) } catch (e) { fileChange = null }
      }
      delete file.ai_file_change
      file._aiFileChange = (fileChange && typeof fileChange === 'object') ? fileChange : null

      // A rotate / crop saved from the fullscreen preview (the original is kept for Restore)
      let imageEdit = file.image_edit
      if (typeof imageEdit === 'string') {
        try { imageEdit = JSON.parse(imageEdit) } catch (e) { imageEdit = null }
      }
      delete file.image_edit
      file._imageEdit = (imageEdit && typeof imageEdit === 'object') ? imageEdit : null

      // Why it's set to Do Not Use on Report (the agent's or the AI's reason)
      let usageNote = file.usage_note
      if (typeof usageNote === 'string') {
        try { usageNote = JSON.parse(usageNote) } catch (e) { usageNote = null }
      }
      delete file.usage_note
      file._usageNote = (usageNote && typeof usageNote === 'object' && usageNote.reason) ? usageNote : null
    }
  }

  // The AI's file conversion (single-photo PDF -> JPG, or a picture of an estimate / invoice -> PDF), while the
  // file is still the converted one
  $scope.getAiFileChange = function (file) {
    const change = file && file._aiFileChange
    return (change && String(file.detected_ext || '').toLowerCase() === change.to_ext) ? change : null
  }

  function extLabel(ext) {
    return String(ext || '').replace('.', '').toUpperCase()
  }

  $scope.getAiFileChangeFrom = function (file) {
    const change = $scope.getAiFileChange(file)
    return change ? extLabel(change.from_ext) : ''
  }

  $scope.getAiFileChangeTo = function (file) {
    const change = $scope.getAiFileChange(file)
    return change ? extLabel(change.to_ext) : ''
  }

  // What the conversion was, after "Converted from X to Y."
  $scope.getAiFileChangeNote = function (file) {
    const change = $scope.getAiFileChange(file)
    if (!change) return ''
    if (change.to_ext === '.pdf') {
      return 'The ' + extLabel(change.from_ext) + ' was a picture of a document, so it is now a one-page PDF (the original ' + extLabel(change.from_ext) + ' is kept).'
    }
    return 'The PDF held a single photo, so it is now a Photo (the original PDF is kept).'
  }

  function formatTooltipWhen(value) {
    try {
      const d = new Date(value)
      if (isNaN(d.getTime())) return ''
      return d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' }) + ' @ ' +
        d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    } catch (e) {
      return ''
    }
  }

  $scope.getAiFileChangeTooltip = function (file) {
    const change = $scope.getAiFileChange(file)
    if (!change) return ''
    const when = formatTooltipWhen(change.converted_at)
    const from = extLabel(change.from_ext)
    const to = extLabel(change.to_ext)
    const note = change.to_ext === '.pdf'
      ? 'The ' + from + ' was a picture of a document. The original ' + from + ' is kept in storage.'
      : 'The PDF held a single photo. The original PDF is kept in storage.'
    return (
      '<div class="text-start">' +
      '<div class="fw-bold">Converted by AI</div>' +
      '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
      '<div>Original: ' + escapeTooltipHtml(from) + ' - ' + escapeTooltipHtml(getTypeLabel(change.from_type)) + '</div>' +
      (change.original_name ? '<div>File: ' + escapeTooltipHtml(change.original_name) + '</div>' : '') +
      '<div>Now: ' + escapeTooltipHtml(to) + ' - ' + escapeTooltipHtml(getTypeLabel(change.to_type)) + '</div>' +
      (when ? '<div>On: ' + escapeTooltipHtml(when) + '</div>' : '') +
      (change.converted_by_name ? '<div>Verified by: ' + escapeTooltipHtml(change.converted_by_name) + '</div>' : '') +
      '<div class="mt-1 fst-italic">' + escapeTooltipHtml(note) + '</div>' +
      '</div>'
    )
  }

  // Show / Do Not Show the AI summary on the property's report (saved right away). The button shows the current
  // setting: "Show on Report" means it is on the report.
  $scope.toggleAiSummaryOnReport = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (!file || !file._ai || file._ai.summarySaving) return
    const next = !file._aiSummaryOnReport

    file._ai.summarySaving = true
    file._ai.error = null
    $http.post('/review/setAiSummaryOnReport', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      show: next
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        file._aiSummaryOnReport = Number(resp.data.data.summary_on_report) === 1
      } else {
        file._ai.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      file._ai.error = 'Unable to save.'
    }).finally(function () {
      file._ai.summarySaving = false
      safeApply($scope)
    })
  }

  // Collapsing the AI summary box (chevron in its header). Remembered per file in this browser only - a viewing
  // preference, so it lives in localStorage (guarded: storage can be blocked) rather than on the server.
  const AI_COLLAPSED_STORAGE_KEY = 'ep-review-ai-collapsed'
  let aiCollapsedIds = null

  function loadAiCollapsedIds() {
    if (aiCollapsedIds) return aiCollapsedIds
    aiCollapsedIds = {}
    try {
      const saved = JSON.parse($window.localStorage.getItem(AI_COLLAPSED_STORAGE_KEY) || '[]')
      if (Array.isArray(saved)) saved.forEach(function (id) { aiCollapsedIds[String(id)] = true })
    } catch (e) { }
    return aiCollapsedIds
  }

  $scope.isAiResultCollapsed = function (file) {
    return !!(file && loadAiCollapsedIds()[String(file.id)])
  }

  $scope.toggleAiResultCollapsed = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (!file) return
    const ids = loadAiCollapsedIds()
    const key = String(file.id)
    if (ids[key]) delete ids[key]
    else ids[key] = true
    try { $window.localStorage.setItem(AI_COLLAPSED_STORAGE_KEY, JSON.stringify(Object.keys(ids))) } catch (e) { }
  }

  // The whole AI Summary as one text: the content summary, then a line per photo (same as fullAiSummary on the
  // server). Results saved since the summary became one text (summary_includes_photos) hold it all in summary.
  $scope.getAiSummaryText = function (file) {
    const result = file && file._ai && file._ai.result
    if (!result) return ''
    const summary = String(result.summary || '').trim()
    if (result.summary_includes_photos) return summary
    const photos = Array.isArray(result.photos) ? result.photos : []
    const lines = photos.map(function (p, i) {
      const area = p && p.area && p.area !== 'unknown' ? ' (' + p.area.charAt(0).toUpperCase() + p.area.slice(1) + ')' : ''
      const label = (photos.length > 1 ? 'Photo ' + (i + 1) + ' - ' : '') + String((p && p.location) || '').trim() + area
      const description = String((p && p.description) || '').trim()
      return label ? label + ': ' + description : description
    })
    return [summary].concat(lines).filter(Boolean).join('\n')
  }

  // Editing the AI summary as one text box (pencil after Show on Report; check saves, X cancels). The server keeps
  // an edited summary when the file is verified again.
  $scope.startAiSummaryEdit = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (!file || !file._ai || !file._ai.result) return
    file._aiSummaryEdit = { value: $scope.getAiSummaryText(file), saving: false, error: null }
    $window.setTimeout(function () {
      try {
        const el = document.getElementById('epAiSummaryEdit-' + file.id)
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length) }
      } catch (e) { }
    }, 0)
  }

  $scope.cancelAiSummaryEdit = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (file && file._aiSummaryEdit && !file._aiSummaryEdit.saving) file._aiSummaryEdit = null
  }

  $scope.onAiSummaryEditKeydown = function (file, $event) {
    if (!$event) return
    if ($event.key === 'Escape') {
      $event.preventDefault()
      $scope.cancelAiSummaryEdit(file, $event)
    } else if ($event.key === 'Enter' && ($event.ctrlKey || $event.metaKey)) {
      $event.preventDefault()
      $scope.saveAiSummaryEdit(file, $event)
    }
  }

  $scope.saveAiSummaryEdit = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const edit = file && file._aiSummaryEdit
    if (!edit || edit.saving) return
    const summary = String(edit.value || '').trim()
    if (!summary) {
      edit.error = 'The summary can\'t be empty.'
      return
    }
    if (summary === $scope.getAiSummaryText(file)) {
      file._aiSummaryEdit = null // nothing changed
      return
    }

    edit.saving = true
    edit.error = null
    $http.post('/review/updateAiSummary', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      summary: summary
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        setAiResult(file, resp.data.data)
        file._aiSummaryEdit = null
      } else {
        edit.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      edit.error = 'Unable to save.'
    }).finally(function () {
      edit.saving = false
      safeApply($scope)
    })
  }

  // Listing-site screenshot / agent CMA found by the AI: the message shown at the top of the AI Summary
  $scope.getAiReportExclusion = function (file) {
    const result = file && file._ai && file._ai.result
    const exclusion = result && result.report_exclusion
    if (!exclusion || !exclusion.message) return null
    if (result.content_type_key && result.content_type_key !== file.content_type_key) return null
    return exclusion
  }

  // The AI found a listing screenshot / CMA, but the file is set to Use on Report (an agent chose it - before the
  // check, or after the AI set it to No). Follows the file's current setting, so it clears once it's set to No.
  $scope.hasAiDiscrepancy = function (file) {
    return !!$scope.getAiReportExclusion(file) && file.usage_status === 'use_on_report'
  }

  // (what / subject were added later - an older result words it from kind / source)
  function aiExclusionWhat(exclusion) {
    if (exclusion.what) return exclusion.what
    if (exclusion.kind === 'agent_cma') return 'a CMA provided by a Real Estate Agent'
    return 'a screenshot of ' + (exclusion.source ? 'a ' + exclusion.source : 'a real estate listing') + ' website'
  }

  // The AI Summary's message, worded for the file's current setting: the discrepancy while it's Use on Report, why it
  // was set to No (by the AI, or by an agent), or what the AI found while it's Pending
  $scope.getAiExclusionMessage = function (file) {
    const exclusion = $scope.getAiReportExclusion(file)
    if (!exclusion) return ''
    const subject = exclusion.subject || (file.display_ext === 'PDF' ? 'PDF' : ($scope.isImage(file) ? 'Photo' : 'file'))
    if (file.usage_status === 'use_on_report') {
      return 'The ' + subject + ' looks like ' + aiExclusionWhat(exclusion) + ' - usually not used on the report; left on "Use on Report" as set by ' + (file.reviewed_by_name || 'an agent') + '.'
    }
    if (file.usage_status === 'do_not_use_on_report') {
      if (exclusion.applied) return exclusion.message
      return 'The ' + subject + ' is ' + aiExclusionWhat(exclusion) + ' - set to "Do Not Use" by ' + (file.reviewed_by_name || 'an agent') + '.'
    }
    return exclusion.message
  }

  $scope.getAiDiscrepancyTooltip = function (file) {
    const exclusion = $scope.getAiReportExclusion(file)
    if (!exclusion) return ''
    const subject = exclusion.subject || (file.display_ext === 'PDF' ? 'PDF' : ($scope.isImage(file) ? 'Photo' : 'file'))
    return (
      '<div class="text-start">' +
      '<div class="fw-bold">AI Discrepancy with Agent</div>' +
      '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
      '<div>The AI found the ' + escapeTooltipHtml(subject) + ' is ' + escapeTooltipHtml(aiExclusionWhat(exclusion)) + ', which is usually not used on the report.</div>' +
      (exclusion.reason ? '<div class="mt-1 fst-italic">' + escapeTooltipHtml(exclusion.reason) + '</div>' : '') +
      '<div class="mt-1">' + escapeTooltipHtml(file.reviewed_by_name || 'An agent') + ' set it to Use on Report.</div>' +
      '</div>'
    )
  }

  // Files on the property with an AI discrepancy (the property header's flag)
  $scope.getAiDiscrepancyFiles = function (report) {
    const files = (report && Array.isArray(report.evidence_files)) ? report.evidence_files : []
    return files.filter(function (f) { return f && $scope.hasAiDiscrepancy(f) })
  }

  $scope.getAiDiscrepancyHeaderTooltip = function (report) {
    const files = $scope.getAiDiscrepancyFiles(report)
    if (!files.length) return ''
    return (
      '<div class="text-start">' +
      '<div class="fw-bold">AI Discrepancy with Agent</div>' +
      '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
      '<div>' + files.length + ' item' + (files.length === 1 ? ' is' : 's are') + ' set to Use on Report, but the AI found ' +
      (files.length === 1 ? 'it is' : 'they are') + ' a real estate listing screenshot or an agent CMA:</div>' +
      files.map(function (f) {
        const ex = $scope.getAiReportExclusion(f)
        return '<div class="mt-1">- ' + escapeTooltipHtml(f.content_type_key || '') + (f.original_name ? ' (' + escapeTooltipHtml(f.original_name) + ')' : '') +
          ': ' + escapeTooltipHtml(aiExclusionWhat(ex)) + '</div>'
      }).join('') +
      '</div>'
    )
  }

  // The AI's Photo -> document type change, while the file is still that type
  $scope.getAiTypeChange = function (file) {
    const change = file && file._aiTypeChange
    return (change && change.to === file.content_type_key) ? change : null
  }

  function escapeTooltipHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
  }

  function getTypeLabel(typeKey) {
    const cfg = allowedFileTypesConfig ? allowedFileTypesConfig[String(typeKey || '').toUpperCase()] : null
    return (cfg && cfg.label) ? cfg.label : String(typeKey || '')
  }

  $scope.getAiTypeChangeTooltip = function (file) {
    const change = $scope.getAiTypeChange(file)
    if (!change) return ''
    let when = ''
    try {
      const d = new Date(change.changed_at)
      if (!isNaN(d.getTime())) {
        when = d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' }) + ' @ ' +
          d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
      }
    } catch (e) { }
    return (
      '<div class="text-start">' +
      '<div class="fw-bold">Type changed by AI</div>' +
      '<div style="border-top: 1px solid rgba(255,255,255,0.35); margin: 6px 0;"></div>' +
      '<div>From: ' + escapeTooltipHtml(change.from_label || getTypeLabel(change.from)) + '</div>' +
      '<div>To: ' + escapeTooltipHtml(change.to_label || getTypeLabel(change.to)) + '</div>' +
      (when ? '<div>On: ' + escapeTooltipHtml(when) + '</div>' : '') +
      (change.changed_by_name ? '<div>Verified by: ' + escapeTooltipHtml(change.changed_by_name) + '</div>' : '') +
      (change.reason ? '<div class="mt-1 fst-italic">' + escapeTooltipHtml(change.reason) + '</div>' : '') +
      '</div>'
    )
  }

  // A field value in the form the AI checked it (matches toCheckedValue in the server's aiVerifyController)
  function aiCheckedValue(type, value) {
    if (value === null || value === undefined || String(value).trim() === '') return null
    if (type === 'date') {
      const s = String(value)
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
      const d = new Date(s)
      return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10)
    }
    if (type === 'amount') {
      const n = Number(String(value).replace(/[^0-9.\-]/g, ''))
      return isFinite(n) ? Math.round(n) : null
    }
    return String(value).trim()
  }

  // After the server changes a file's type (AI reclassified a photo, or the agent undid it), update the file and the
  // property's counts and type filter chips to match
  function applyEvidenceTypeChange(report, file, data) {
    file.content_type_key = data.content_type_key
    file.meta_json = data.meta_json || {}
    if (data.updated_at) file.updated_at = data.updated_at
    if (!report) return

    if (Array.isArray(report.uniqueTypes) && !report.uniqueTypes.some(function (t) { return t.name === file.content_type_key })) {
      report.uniqueTypes.push({ name: file.content_type_key, selected: true })
      report.uniqueTypes.sort(function (a, b) { return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0) })
    }
    if (Array.isArray(report.evidence_files)) {
      report.photo_count = report.evidence_files.filter(function (f) { return f && f.content_type_key === 'PHOTO' }).length
      report.document_count = report.evidence_files.length - report.photo_count
    }
    recomputeReportReviewedToggle(report)
  }

  // Returns a promise resolving to true when the file was verified (used by the property's "Verify with AI" batch)
  $scope.verifyEvidenceWithAi = function (report, file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if (!file || (file._ai && file._ai.loading)) return Promise.resolve(false)

    // Any earlier result stays on screen until the new one arrives (and if this run fails)
    setAiResult(file, file._ai ? file._ai.result : null)
    file._ai.loading = true
    file._ai.error = null
    let ok = false
    return $http.post('/review/verifyEvidenceWithAi', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        const data = resp.data.data
        if (data.type_change) {
          applyEvidenceTypeChange(report, file, data)
          file._aiTypeChange = data.type_change
        }
        // Single-photo PDF became a Photo JPG: point the file at the new JPG (the preview switches to the image)
        if (data.file_change && data.file) {
          Object.keys(data.file).forEach(function (k) { file[k] = data.file[k] })
          file.display_ext = String(file.detected_ext || '').replace('.', '').toUpperCase()
          file._pdfInteractive = false
          applyEvidenceTypeChange(report, file, data)
          file._aiFileChange = data.file_change
        }
        // A listing-site screenshot / agent CMA: the server set it to Do Not Use on Report
        if (data.usage) {
          // keep_reviewer: the file already was Do Not Use - only the AI's reason was added
          if (!data.usage.keep_reviewer) {
            file.active = data.usage.active === 1 ? 1 : 0
            file.reviewed_by_id = data.usage.reviewed_by_id ? Number(data.usage.reviewed_by_id) : null
            file.reviewed_by_name = data.usage.reviewed_by_name ? String(data.usage.reviewed_by_name) : null
            file.reviewed_by_initials = data.usage.reviewed_by_initials ? String(data.usage.reviewed_by_initials).trim().toUpperCase() : null
            file.reviewed_on = data.usage.reviewed_on ? $scope.portalDate(data.usage.reviewed_on) : null
            syncEvidenceUsageState(file)
            if (report) recomputeReportReviewedToggle(report)
          }
          if (data.usage.usage_note) file._usageNote = data.usage.usage_note
        }
        file._ai.result = data
        ok = true
        if (data.saved === false) file._ai.error = 'This result could not be saved and will not show after a refresh.'
      } else {
        file._ai.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'AI verification failed.'
      }
    }, function () {
      file._ai.error = 'AI verification failed.'
    }).finally(function () {
      file._ai.loading = false
      safeApply($scope)
    }).then(function () {
      return ok
    })
  }

  // --- Property header "Verify with AI" split button: runs the single-file verify over the property's PDFs and
  // photos concurrently (Promise.all over up to AI_BATCH_CONCURRENCY parallel lanes; a property with more items
  // starts the next one as each finishes). Main button = files not yet verified; the dropdown adds re-verify / all.
  const AI_BATCH_CONCURRENCY = 8

  function hasAiResult(file) {
    return !!(file && file._ai && file._ai.result)
  }

  $scope.getAiBatchTargets = function (report, mode) {
    const files = (report && Array.isArray(report.evidence_files)) ? report.evidence_files : []
    return files.filter(function (f) {
      if (!f || !$scope.canVerifyWithAi(f)) return false
      if (mode === 'unchecked') return !hasAiResult(f)
      if (mode === 'checked') return hasAiResult(f)
      return true
    })
  }

  $scope.runAiBatch = function (report, mode, $event) {
    try { if ($event) $event.preventDefault() } catch (e) { }
    if (!report || (report._aiBatch && report._aiBatch.running)) return

    // Nothing to do: the buttons are disabled for that, so just return
    const targets = $scope.getAiBatchTargets(report, mode)
    if (!targets.length) return

    const batch = { running: true, stopping: false, total: targets.length, done: 0, failed: 0 }
    report._aiBatch = batch
    const queue = targets.slice()

    function worker() {
      if (batch.stopping || !queue.length) return Promise.resolve()
      const file = queue.shift()
      return $scope.verifyEvidenceWithAi(report, file).then(function (ok) {
        batch.done++
        if (!ok) batch.failed++
        safeApply($scope)
        return worker()
      })
    }

    // Lane count fixed up front - each worker() takes an item off the queue as it starts
    const lanes = Math.min(AI_BATCH_CONCURRENCY, queue.length)
    const workers = []
    for (let i = 0; i < lanes; i++) workers.push(worker())
    Promise.all(workers).then(function () {
      batch.running = false
      safeApply($scope)
    })
  }

  // Every PDF / photo on the property has an AI result (the main button then reads "AI Verified")
  $scope.isAiBatchAllVerified = function (report) {
    return $scope.getAiBatchTargets(report, 'all').length > 0 && $scope.getAiBatchTargets(report, 'unchecked').length === 0
  }

  $scope.stopAiBatch = function (report, $event) {
    try { if ($event) $event.preventDefault() } catch (e) { }
    if (report && report._aiBatch && report._aiBatch.running) report._aiBatch.stopping = true
  }

  $scope.getAiBatchTitle = function (report) {
    const b = report && report._aiBatch
    if (b && b.running) return b.stopping ? 'Stopping after the items in progress...' : 'Verifying ' + b.done + ' of ' + b.total + ' items'
    const pending = $scope.getAiBatchTargets(report, 'unchecked').length
    let title = pending ? 'Verify the ' + pending + ' item' + (pending === 1 ? '' : 's') + ' not yet checked by AI' : 'Every item has been checked by AI'
    if (b && b.done) title += ' (last run: ' + (b.done - b.failed) + ' verified' + (b.failed ? ', ' + b.failed + ' failed' : '') + ')'
    return title
  }

  // The AI result for a field - only while the file is still the type it was checked as and the field still holds
  // the value that was checked (a change made elsewhere, e.g. in the client portal, makes the result stale)
  $scope.getAiFieldResult = function (file, key) {
    const ai = file && file._ai && file._ai.result
    const result = ai && ai.fields ? ai.fields[key] : null
    if (!result || result.dismissed) return null
    if (ai.content_type_key && ai.content_type_key !== file.content_type_key) return null
    if (Object.prototype.hasOwnProperty.call(result, 'checked_value')) {
      const field = $scope.getEvidenceMetaField(file, key)
      const current = aiCheckedValue(field ? field.type : '', (file.meta_json || {})[key])
      if (String(current) !== String(result.checked_value)) return null
    }
    return result
  }

  // "2026-03-09" -> local midnight, the same form the inline date editor saves
  function aiDateToLocal(value) {
    const parts = String(value || '').split('-').map(Number)
    return parts.length === 3 ? new Date(parts[0], parts[1] - 1, parts[2]) : null
  }

  $scope.formatAiValue = function (file, key) {
    const result = $scope.getAiFieldResult(file, key)
    if (!result || result.document_value === null || result.document_value === undefined) return ''
    const value = result.document_value
    const field = $scope.getEvidenceMetaField(file, key)
    const type = field ? field.type : ''
    try {
      if (type === 'date') {
        const d = aiDateToLocal(value)
        return d ? d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : String(value)
      }
      if (type === 'amount') {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value))
      }
      if (type === 'select') {
        const opt = (field.options || []).find(function (o) { return o && o.value === value })
        return opt ? (opt.group ? opt.group + ' - ' + opt.label : opt.label) : String(value)
      }
    } catch (e) { }
    return String(value)
  }

  $scope.acceptAiSuggestion = function (file, key, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const result = $scope.getAiFieldResult(file, key)
    if (!result || file._ai.accepting[key]) return
    const field = $scope.getEvidenceMetaField(file, key)
    const value = (field && field.type === 'date') ? aiDateToLocal(result.document_value) : result.document_value

    file._ai.accepting[key] = true
    result.error = null
    $http.post('/review/updateEvidenceMetaField', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      key: key,
      value: value
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        // The server marks the accepted value as checked in the saved result; fall back to marking it here
        if (resp.data.data.ai_verification) {
          file._ai.result = resp.data.data.ai_verification
        } else {
          result.status = 'match'
          result.checked_value = aiCheckedValue(field ? field.type : '', resp.data.data.value)
        }
        file.meta_json = resp.data.data.meta_json || {}
        if (resp.data.data.updated_at) file.updated_at = resp.data.data.updated_at
      } else {
        result.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      result.error = 'Unable to save.'
    }).finally(function () {
      file._ai.accepting[key] = false
      safeApply($scope)
    })
  }

  // Put an AI-reclassified file back to a Photo with the photo fields it had before
  $scope.undoAiTypeChange = function (report, file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const change = $scope.getAiTypeChange(file)
    if (!change) return
    setAiResult(file, file._ai ? file._ai.result : null)
    if (file._ai.undoing) return

    file._ai.undoing = true
    file._ai.error = null
    $http.post('/review/revertEvidenceTypeChange', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      previous_meta: change.previous_meta || {}
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        // The estimate / invoice PDF made from the photo: back to the original image
        if (resp.data.data.file) {
          Object.keys(resp.data.data.file).forEach(function (k) { file[k] = resp.data.data.file[k] })
          file.display_ext = String(file.detected_ext || '').replace('.', '').toUpperCase()
          file._pdfInteractive = false
          file._aiFileChange = null
        }
        applyEvidenceTypeChange(report, file, resp.data.data)
        file._ai.result = null // the suggestions were for the document type
        file._aiTypeChange = null
        file._aiSummaryOnReport = false
        file._aiSummaryEdit = null
      } else {
        file._ai.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to undo.'
      }
    }, function () {
      file._ai.error = 'Unable to undo.'
    }).finally(function () {
      file._ai.undoing = false
      safeApply($scope)
    })
  }

  // The file shows a different value: keep the one entered (keep = true) or undo that (false). Shown at once; the
  // server saves it on the field's AI result.
  $scope.keepEnteredValue = function (file, key, keep, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const result = $scope.getAiFieldResult(file, key)
    if (!result || result.status !== 'mismatch' || file._ai.accepting[key]) return
    const before = { kept: result.kept, kept_by_name: result.kept_by_name, kept_at: result.kept_at }
    result.kept = !!keep
    result.error = null
    file._ai.accepting[key] = true
    $http.post('/review/keepEnteredValue', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      key: key,
      keep: !!keep
    }).then(function (resp) {
      if (resp.data && resp.data.success && resp.data.data) {
        file._ai.result = resp.data.data
      } else {
        Object.assign(result, before)
        result.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      Object.assign(result, before)
      result.error = 'Unable to save.'
    }).finally(function () {
      file._ai.accepting[key] = false
      safeApply($scope)
    })
  }

  $scope.getKeptEnteredTitle = function (file, key) {
    const result = $scope.getAiFieldResult(file, key)
    if (!result || !result.kept) return ''
    const when = formatTooltipWhen(result.kept_at)
    return 'Entered value kept' + (result.kept_by_name ? ' by ' + result.kept_by_name : '') + (when ? ' on ' + when : '') +
      ' - the file shows ' + $scope.formatAiValue(file, key)
  }

  $scope.dismissAiSuggestion = function (file, key, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    const result = $scope.getAiFieldResult(file, key)
    if (!result) return
    result.dismissed = true // hide it now; the server saves it so it stays gone after a refresh
    $http.post('/review/dismissAiSuggestion', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      key: key
    }).then(function (resp) {
      if (!resp.data || !resp.data.success) {
        result.dismissed = false
        result.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to remove.'
      }
    }, function () {
      result.dismissed = false
      result.error = 'Unable to remove.'
    }).finally(function () {
      safeApply($scope)
    })
  }

  function toMoneyNumber(value) {
    if (value === null || value === undefined) return 0
    if (typeof value === 'number') return isFinite(value) ? value : 0
    if (typeof value === 'string') {
      var cleaned = value.replace(/[^0-9.\-]/g, '')
      var parsed = parseFloat(cleaned)
      return isFinite(parsed) ? parsed : 0
    }
    return 0
  }

  function normalizeRevisedConditionValue(value) {
    if (value === null || value === undefined) return ''
    if (typeof value === 'number') return isFinite(value) ? String(value) : ''
    var cleaned = String(value).replace(/[^0-9\-]/g, '').trim()
    if (!cleaned) return ''
    var parsed = parseInt(cleaned, 10)
    return isFinite(parsed) ? String(parsed) : cleaned
  }

  function sanitizeRevisedConditionValueInput(value) {
    if (value === null || value === undefined) return ''

    var input = String(value).replace(/[^0-9\-]/g, '')
    if (!input) return ''

    var isNegative = input.charAt(0) === '-'
    input = input.replace(/-/g, '')

    var whole = input.replace(/^0+(?=\d)/, '')
    if (!whole) whole = '0'

    var sanitized = whole
    if (isNegative && sanitized && sanitized !== '0') {
      sanitized = '-' + sanitized
    }

    return sanitized
  }

  function formatRevisedConditionCurrency(value) {
    var normalizedValue = normalizeRevisedConditionValue(value)
    if (!normalizedValue) return ''

    var parsed = parseInt(normalizedValue, 10)
    if (!isFinite(parsed)) return ''

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(parsed)
    } catch (e) {
      return '$' + String(parsed).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }

  function getRevisedConditionRawValue(report) {
    if (!report) return ''
    if (report.revisedConditionValueRaw !== undefined && report.revisedConditionValueRaw !== null) {
      return sanitizeRevisedConditionValueInput(report.revisedConditionValueRaw)
    }
    return sanitizeRevisedConditionValueInput(report.revisedConditionValue || report.revisedConditionValueDraft)
  }

  function applyRevisedConditionValue(report, rawValue, isDirty) {
    if (!report) return

    var sanitizedValue = sanitizeRevisedConditionValueInput(rawValue)
    report.revisedConditionValueRaw = sanitizedValue
    report.revisedConditionValue = normalizeRevisedConditionValue(sanitizedValue)
    report.revisedConditionValueDraft = formatRevisedConditionCurrency(sanitizedValue)
    report.revisedConditionValueDirty = !!isDirty
  }

  function sumRepairReductionAmount(report, contentTypeKeys) {
    try {
      if (!report || !Array.isArray(report.evidence_files)) return 0

      var allowedKeys = Array.isArray(contentTypeKeys) ? contentTypeKeys : []

      return report.evidence_files.reduce(function (sum, file) {
        if (!file || !shouldIncludeInRepairReduction(file)) return sum

        var contentTypeKey = String(file.content_type_key || '').trim().toUpperCase()
        if (allowedKeys.length && allowedKeys.indexOf(contentTypeKey) === -1) return sum

        var amountField = REPAIR_REDUCTION_AMOUNT_FIELDS[contentTypeKey]
        if (!amountField) return sum

        var meta = file.meta_json || {}
        return sum + toMoneyNumber(meta[amountField])
      }, 0)
    } catch (e) {
      return 0
    }
  }

  $scope.getTotalEstimates = function (report) {
    return sumRepairReductionAmount(report, ['ESTIMATE_NEEDED_REPAIR'])
  }

  $scope.getTotalInvoices = function (report) {
    return sumRepairReductionAmount(report, ['INVOICE_REPAIRS_COMPLETED'])
  }

  $scope.getTotalInsuranceClaims = function (report) {
    return sumRepairReductionAmount(report, ['INSURANCE_CLAIM_DAMAGE'])
  }

  $scope.getRepairReductionSummaryTotal = function (report) {
    return sumRepairReductionAmount(report, [
      'ESTIMATE_NEEDED_REPAIR',
      'INVOICE_REPAIRS_COMPLETED',
      'INSURANCE_CLAIM_DAMAGE'
    ])
  }

  $scope.formatMetaKey = function (key) {
    if (!key) return ''
    // Replace underscores with spaces
    let formatted = key.replace(/_/g, ' ')
    // Capitalize first letter of each word
    formatted = formatted.replace(/\b\w/g, function (l) { return l.toUpperCase() })
    return formatted
  }

  $scope.formatMetaValue = function (key, value) {
    if (!value) return ''
    if (key === 'estimate_scope' || key === 'photo_location' || key === 'appraisal_purpose') {
      let formatted = value.replace(/_/g, ' ')
      formatted = formatted.replace(/\b\w/g, function (l) { return l.toUpperCase() })
      return formatted
    }
    return value
  }

  $scope.evidenceFilter = function (report) {
    return function (file) {
      if ($scope.itemsToReviewOnly) {
        var usageStatus = getEvidenceUsageStatus(file)
        if (usageStatus !== 'pending' && usageStatus !== 'do_not_use_on_report') return false
      }
      if (!report.uniqueTypes) return true
      for (var i = 0; i < report.uniqueTypes.length; i++) {
        if (report.uniqueTypes[i].name === file.content_type_key) {
          return report.uniqueTypes[i].selected
        }
      }
      return true
    }
  }

  $scope.selectAllTypes = function (report) {
    if (report.uniqueTypes) {
      report.uniqueTypes.forEach(function (t) { t.selected = true })
    }
  }

  $scope.selectNoTypes = function (report) {
    if (report.uniqueTypes) {
      report.uniqueTypes.forEach(function (t) { t.selected = false })
    }
  }

  $scope.expandAllEvidence = function (report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!report || !Array.isArray(report.evidence_files)) return
      const filterFn = (typeof $scope.evidenceFilter === 'function') ? $scope.evidenceFilter(report) : null
      report.evidence_files.forEach(function (f) {
        if (!f) return
        if (filterFn && !filterFn(f)) return
        f.expanded = true
      })
      safeApply($scope)
    } catch (e) { }
  }

  $scope.collapseAllEvidence = function (report, $event) {
    try {
      try {
        if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
        if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
      } catch (e) { }

      if (!report || !Array.isArray(report.evidence_files)) return
      const filterFn = (typeof $scope.evidenceFilter === 'function') ? $scope.evidenceFilter(report) : null
      report.evidence_files.forEach(function (f) {
        if (!f) return
        if (filterFn && !filterFn(f)) return
        f.expanded = false
      })
      safeApply($scope)
    } catch (e) { }
  }

  $scope.currentEvidence = null
  var evidenceModal = null

  // --- Zoom in the fullscreen modal: a slider from -100 (zoomed out, 25%) through 0 (fit, 100%) to 100 (zoomed in,
  // 400%) - each 50 steps doubles or halves the size.
  // The mouse wheel (or a trackpad pinch) over the photo / PDF zooms it and moves the slider, keeping the spot
  // under the pointer where it is.
  // Photo: scaled with a transform written straight to the image (no digest per mouse move); dragged to look
  // around when zoomed in.
  // PDF: drawn page by page with PDF.js (below) at the zoomed size, so text stays sharp; the pages scroll (drag,
  // the scrollbars, or Shift + wheel).
  const ZOOM_MIN = -100
  const ZOOM_MAX = 100
  const ZOOM_WHEEL_STEP = 10 // slider steps per mouse-wheel notch
  const ZOOM_PINCH_FACTOR = 0.5 // slider steps per pixel of a trackpad pinch (its deltas are small)
  $scope.evidenceZoom = { value: 0, x: 0, y: 0, dragging: false }
  $scope.evidenceZoomTicks = [
    { value: -100, label: '25%' },
    { value: -50, label: '50%' },
    { value: 0, label: '100%' },
    { value: 50, label: '200%' },
    { value: 100, label: '400%' }
  ]

  function zoomScale(value) {
    return Math.pow(2, (Number(value) || 0) / 50)
  }

  $scope.getEvidenceZoomPercent = function () {
    return Math.round(zoomScale($scope.evidenceZoom.value) * 100)
  }

  // Where the thumb sits along the track (0-100), and the lit stretch between the 100% mark and the thumb. Unitless:
  // the CSS turns them into positions that allow for the thumb's width.
  $scope.getEvidenceZoomPos = function () {
    return ((Number($scope.evidenceZoom.value) || 0) - ZOOM_MIN) / (ZOOM_MAX - ZOOM_MIN) * 100
  }

  $scope.getEvidenceZoomTrackStyle = function () {
    const pos = $scope.getEvidenceZoomPos()
    return '--ep-zoom-lo: ' + Math.min(50, pos) + '; --ep-zoom-hi: ' + Math.max(50, pos) + '; --ep-zoom-pos: ' + pos
  }

  // The zoom bar shows for a photo, and for a PDF drawn here (not when it fell back to the browser's viewer)
  $scope.canZoomEvidence = function () {
    const file = $scope.currentEvidence
    return $scope.isPdf(file) ? !$scope.evidencePdf.failed : $scope.isImage(file)
  }

  function getZoomImage() {
    return document.getElementById('epEvidenceZoomImg')
  }

  // Keeps the dragged photo from leaving the viewing area: it can move only as far as it overflows
  function clampZoomPan() {
    const z = $scope.evidenceZoom
    const img = getZoomImage()
    if (!img || !img.naturalWidth || !img.naturalHeight) { z.x = 0; z.y = 0; return }
    const boxW = img.clientWidth
    const boxH = img.clientHeight
    const fit = Math.min(boxW / img.naturalWidth, boxH / img.naturalHeight) // object-fit: contain
    const scale = zoomScale(z.value)
    const maxX = Math.max(0, (img.naturalWidth * fit * scale - boxW) / 2)
    const maxY = Math.max(0, (img.naturalHeight * fit * scale - boxH) / 2)
    z.x = Math.max(-maxX, Math.min(maxX, z.x))
    z.y = Math.max(-maxY, Math.min(maxY, z.y))
  }

  // anchor: { clientX, clientY, prevScale } - keep the spot under the pointer in place (the wheel); otherwise the
  // middle of the view stays put (slider / buttons)
  function applyEvidenceZoom(anchor) {
    if ($scope.isPdf($scope.currentEvidence)) {
      layoutPdfPages(true, anchor)
      return
    }
    const photo = getZoomImage()
    if (anchor && photo && photo.parentElement && anchor.prevScale) {
      // The photo is scaled about the middle of its (untransformed) box, which fills its wrapper
      const box = photo.parentElement.getBoundingClientRect()
      const z = $scope.evidenceZoom
      const mx = anchor.clientX - (box.left + box.width / 2)
      const my = anchor.clientY - (box.top + box.height / 2)
      const ratio = zoomScale(z.value) / anchor.prevScale
      z.x = mx - ratio * (mx - z.x)
      z.y = my - ratio * (my - z.y)
    }
    clampZoomPan()
    const img = getZoomImage()
    if (!img) return
    const z = $scope.evidenceZoom
    img.style.transform = 'translate(' + z.x + 'px, ' + z.y + 'px) scale(' + zoomScale(z.value) + ')'
    img.classList.toggle('is-zoomed', zoomScale(z.value) > 1)
  }

  $scope.onEvidenceZoomChange = function (anchor) {
    $scope.evidenceZoom.value = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, Number($scope.evidenceZoom.value) || 0))
    applyEvidenceZoom(anchor)
  }

  // anchor (optional): the pointer's { clientX, clientY } to zoom around
  $scope.stepEvidenceZoom = function (delta, anchor) {
    const before = Number($scope.evidenceZoom.value) || 0
    $scope.evidenceZoom.value = before + delta
    $scope.onEvidenceZoomChange(anchor ? { clientX: anchor.clientX, clientY: anchor.clientY, prevScale: zoomScale(before) } : null)
  }

  $scope.resetEvidenceZoom = function () {
    $scope.evidenceZoom.value = 0
    $scope.evidenceZoom.x = 0
    $scope.evidenceZoom.y = 0
    applyEvidenceZoom()
  }

  // --- PDF pages drawn with PDF.js (loaded from cdnjs the first time a PDF is opened here). Each page is a canvas
  // sized to the modal's width x the zoom. While the slider moves, the drawn pages are stretched at once and then
  // redrawn at the new size a moment later. Only pages in or near view are drawn; pages scrolled far away give their
  // canvas back (a 400% page is a big bitmap). If PDF.js or the file can't be loaded, the browser's viewer is used.
  const PDFJS_BASE = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/'
  const PDF_VIEW_PADDING_PX = 16
  const PDF_MAX_CANVAS_PIXELS = 16 * 1024 * 1024
  const PDF_REDRAW_DELAY_MS = 120
  $scope.evidencePdf = { loading: false, failed: false, pageCount: 0 }
  const pdfView = { token: 0, loadingTask: null, pages: [], observer: null, redrawTimer: null }
  let pdfjsPromise = null

  function loadPdfJs() {
    if ($window.pdfjsLib) return Promise.resolve($window.pdfjsLib)
    if (!pdfjsPromise) {
      pdfjsPromise = new Promise(function (resolve, reject) {
        const script = document.createElement('script')
        script.src = PDFJS_BASE + 'pdf.min.js'
        script.async = true
        script.onload = function () {
          const lib = $window.pdfjsLib
          if (!lib) return reject(new Error('PDF.js did not load'))
          lib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + 'pdf.worker.min.js'
          resolve(lib)
        }
        script.onerror = function () {
          pdfjsPromise = null // try again next time
          reject(new Error('PDF.js could not be loaded'))
        }
        document.head.appendChild(script)
      })
    }
    return pdfjsPromise
  }

  function getPdfViewEl() {
    return document.getElementById('epEvidencePdfView')
  }

  function isPdfViewActive() {
    return $scope.isPdf($scope.currentEvidence) && !$scope.evidencePdf.failed
  }

  function closePdfView() {
    pdfView.token++
    if (pdfView.redrawTimer) { $window.clearTimeout(pdfView.redrawTimer); pdfView.redrawTimer = null }
    if (pdfView.observer) { try { pdfView.observer.disconnect() } catch (e) { } pdfView.observer = null }
    pdfView.pages.forEach(function (page) {
      if (page.renderTask) { try { page.renderTask.cancel() } catch (e) { } }
    })
    pdfView.pages = []
    if (pdfView.loadingTask) { try { pdfView.loadingTask.destroy() } catch (e) { } pdfView.loadingTask = null }
    const view = getPdfViewEl()
    const holder = view && view.querySelector('.ep-pdf-view__pages')
    if (holder) holder.innerHTML = ''
    if (view) { view.scrollTop = 0; view.scrollLeft = 0 }
  }

  function openPdfView(file) {
    closePdfView()
    const token = pdfView.token
    $scope.evidencePdf = { loading: true, failed: false, pageCount: 0 }
    const url = $scope.getEvidenceAssetUrl(file)

    loadPdfJs().then(function (lib) {
      if (token !== pdfView.token) return null
      pdfView.loadingTask = lib.getDocument({ url: url })
      return pdfView.loadingTask.promise
    }).then(function (doc) {
      if (!doc || token !== pdfView.token) return null
      const numbers = []
      for (let i = 1; i <= doc.numPages; i++) numbers.push(i)
      return Promise.all(numbers.map(function (n) { return doc.getPage(n) }))
    }).then(function (pdfPages) {
      if (!pdfPages || token !== pdfView.token) return
      buildPdfPages(pdfPages)
      $scope.$applyAsync(function () { $scope.evidencePdf = { loading: false, failed: false, pageCount: pdfPages.length } })
    }).catch(function (err) {
      if (token !== pdfView.token) return
      console.error('PDF preview: using the browser viewer instead', err)
      $scope.$applyAsync(function () { $scope.evidencePdf = { loading: false, failed: true, pageCount: 0 } })
    })
  }

  function buildPdfPages(pdfPages) {
    const view = getPdfViewEl()
    const holder = view && view.querySelector('.ep-pdf-view__pages')
    if (!holder) return
    holder.innerHTML = ''
    pdfView.pages = pdfPages.map(function (pdfPage, i) {
      const el = document.createElement('div')
      el.className = 'ep-pdf-view__page'
      el.setAttribute('role', 'img')
      el.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pdfPages.length)
      holder.appendChild(el)
      return {
        pdfPage: pdfPage,
        el: el,
        canvas: null,
        base: pdfPage.getViewport({ scale: 1 }), // the page's size in PDF points, turned by its /Rotate
        scale: 0, // CSS scale the page is laid out at
        drawnScale: 0, // scale its canvas was drawn at (0 = not drawn)
        visible: false,
        renderTask: null
      }
    })

    // Draw pages as they come near the view; give back the canvases of pages far from it
    pdfView.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const page = pdfView.pages.find(function (p) { return p.el === entry.target })
        if (!page) return
        page.visible = entry.isIntersecting
        if (page.visible) drawPdfPage(page)
        else releasePdfPage(page)
      })
    }, { root: view, rootMargin: '100% 0px' })

    layoutPdfPages(false)
    pdfView.pages.forEach(function (page) { pdfView.observer.observe(page.el) })
  }

  // Sizes every page to the view's width x the zoom. keepCentre: keep the point in the middle of the view (or, with
  // anchor, the point under the pointer) where it is while zooming.
  function layoutPdfPages(keepCentre, anchor) {
    const view = getPdfViewEl()
    if (!view || !pdfView.pages.length) return
    const available = view.clientWidth - PDF_VIEW_PADDING_PX * 2
    if (available <= 0) return

    // The fixed point, from the view's top-left corner
    let fixX = view.clientWidth / 2
    let fixY = view.clientHeight / 2
    if (anchor) {
      const rect = view.getBoundingClientRect()
      fixX = Math.max(0, Math.min(view.clientWidth, anchor.clientX - rect.left))
      fixY = Math.max(0, Math.min(view.clientHeight, anchor.clientY - rect.top))
    }
    const centreX = view.scrollWidth ? (view.scrollLeft + fixX) / view.scrollWidth : 0.5
    const centreY = view.scrollHeight ? (view.scrollTop + fixY) / view.scrollHeight : 0
    const zoom = zoomScale($scope.evidenceZoom.value)

    function sizePages(width) {
      pdfView.pages.forEach(function (page) {
        page.scale = (width / page.base.width) * zoom
        page.el.style.width = Math.floor(page.base.width * page.scale) + 'px'
        page.el.style.height = Math.floor(page.base.height * page.scale) + 'px'
      })
    }
    sizePages(available)
    // The pages brought in (or took away) the vertical scrollbar, which changed the width they fit into
    const settled = view.clientWidth - PDF_VIEW_PADDING_PX * 2
    if (settled > 0 && settled !== available) sizePages(settled)

    if (keepCentre) {
      view.scrollLeft = centreX * view.scrollWidth - fixX
      view.scrollTop = centreY * view.scrollHeight - fixY
    }

    // Redraw at the new size once the slider settles (the stretched canvases fill in meanwhile)
    if (pdfView.redrawTimer) $window.clearTimeout(pdfView.redrawTimer)
    pdfView.redrawTimer = $window.setTimeout(function () {
      pdfView.redrawTimer = null
      pdfView.pages.forEach(function (page) { if (page.visible) drawPdfPage(page) })
    }, PDF_REDRAW_DELAY_MS)
  }

  function drawPdfPage(page) {
    if (!page.scale || page.drawnScale === page.scale) return
    if (page.renderTask) { try { page.renderTask.cancel() } catch (e) { } page.renderTask = null }

    // Sharp on high-DPI screens, but capped so a zoomed-in page stays a sensible bitmap
    const dpr = Math.min($window.devicePixelRatio || 1, 2)
    let drawScale = page.scale * dpr
    const pixels = page.base.width * page.base.height * drawScale * drawScale
    if (pixels > PDF_MAX_CANVAS_PIXELS) drawScale *= Math.sqrt(PDF_MAX_CANVAS_PIXELS / pixels)
    const viewport = page.pdfPage.getViewport({ scale: drawScale })

    // Drawn off to the side, then swapped in, so the page never flashes blank
    const canvas = document.createElement('canvas')
    canvas.width = Math.floor(viewport.width)
    canvas.height = Math.floor(viewport.height)
    const scale = page.scale
    const token = pdfView.token
    const task = page.pdfPage.render({ canvasContext: canvas.getContext('2d'), viewport: viewport })
    page.renderTask = task
    task.promise.then(function () {
      if (token !== pdfView.token || page.renderTask !== task) return
      page.renderTask = null
      if (page.canvas) {
        page.canvas.width = 0
        page.canvas.height = 0
        page.el.removeChild(page.canvas)
      }
      page.el.appendChild(canvas)
      page.canvas = canvas
      page.drawnScale = scale
    }, function () {
      // Cancelled (zoomed again, scrolled away or closed) - nothing to do
      if (page.renderTask === task) page.renderTask = null
    })
  }

  function releasePdfPage(page) {
    if (page.renderTask) { try { page.renderTask.cancel() } catch (e) { } page.renderTask = null }
    if (page.canvas) {
      page.canvas.width = 0
      page.canvas.height = 0
      page.el.removeChild(page.canvas)
      page.canvas = null
    }
    page.drawnScale = 0
  }

  // --- Rotate / crop a photo in the fullscreen modal (footer buttons). While editing, the photo is drawn on a canvas
  // turned by the rotation, with a crop box over it (drag inside to move it, the handles to resize it, or drag on
  // the photo outside it to draw a new one). Save sends the quarter turns (clockwise) and the crop - fractions of
  // the turned photo - to the server, which edits the stored image (imageEditController). The first save keeps the
  // original, and Restore original goes back to it.
  const IMAGE_EDIT_EXTS = ['jpg', 'jpeg', 'png', 'webp']
  const CROP_MIN_PX = 24 // smallest crop box on screen
  const IMAGE_EDIT_PADDING_PX = 16
  function newImageEditState() {
    return { active: false, rotation: 0, crop: null, saving: false, restoring: false, error: null }
  }
  $scope.imageEdit = newImageEditState()
  const cropView = { width: 0, height: 0, left: 0, top: 0 } // the canvas on screen, in the stage

  $scope.canEditEvidenceImage = function () {
    const file = $scope.currentEvidence
    if (!file || $scope.isPdf(file) || !$scope.isImage(file)) return false
    return IMAGE_EDIT_EXTS.includes(String(file.detected_ext || '').toLowerCase().replace('.', ''))
  }

  $scope.hasImageEditChanges = function () {
    const e = $scope.imageEdit
    return e.active && (e.rotation !== 0 || !!e.crop)
  }

  $scope.getImageEditTitle = function () {
    const edit = $scope.currentEvidence && $scope.currentEvidence._imageEdit
    if (!edit) return ''
    const when = formatTooltipWhen(edit.edited_at)
    return 'Edited' + (edit.edited_by_name ? ' by ' + edit.edited_by_name : '') + (when ? ' on ' + when : '') +
      ' - restore the photo as it was uploaded'
  }

  function startImageEdit() {
    const e = $scope.imageEdit
    if (e.active) return
    e.active = true
    e.rotation = 0
    e.crop = null
    e.error = null
    // Edits are made on the fitted photo
    $scope.evidenceZoom.value = 0
    $scope.evidenceZoom.x = 0
    $scope.evidenceZoom.y = 0
    applyEvidenceZoom()
  }

  // The crop turns with the photo: a quarter turn clockwise maps (x, y) of the old picture to (1 - y - h, x)
  function turnCrop(crop, clockwise) {
    if (!crop) return null
    return clockwise
      ? { x: 1 - crop.y - crop.h, y: crop.x, w: crop.h, h: crop.w }
      : { x: crop.y, y: 1 - crop.x - crop.w, w: crop.h, h: crop.w }
  }

  // dir: 1 = clockwise, -1 = counter-clockwise
  $scope.rotateEvidenceImage = function (dir) {
    if (!$scope.canEditEvidenceImage() || $scope.imageEdit.saving) return
    startImageEdit()
    const e = $scope.imageEdit
    e.rotation = (e.rotation + (dir > 0 ? 90 : 270)) % 360
    e.crop = turnCrop(e.crop, dir > 0)
    $window.setTimeout(renderImageEdit, 0) // after the stage is shown
  }

  $scope.toggleEvidenceCrop = function () {
    if (!$scope.canEditEvidenceImage() || $scope.imageEdit.saving) return
    startImageEdit()
    const e = $scope.imageEdit
    e.crop = e.crop ? null : { x: 0.1, y: 0.1, w: 0.8, h: 0.8 }
    $window.setTimeout(renderImageEdit, 0)
  }

  $scope.cancelImageEdit = function () {
    if ($scope.imageEdit.saving) return
    $scope.imageEdit = newImageEditState()
  }

  function getImageEditStage() {
    return document.getElementById('epImageEditStage')
  }

  // Draws the photo turned by the rotation, as large as the stage allows, then places the crop box
  function renderImageEdit() {
    const e = $scope.imageEdit
    const stage = getImageEditStage()
    const canvas = document.getElementById('epImageEditCanvas')
    const img = getZoomImage()
    if (!e.active || !stage || !canvas || !img || !img.naturalWidth) return

    const nw = img.naturalWidth
    const nh = img.naturalHeight
    const turned = e.rotation % 180 !== 0
    const rw = turned ? nh : nw
    const rh = turned ? nw : nh
    const fit = Math.min((stage.clientWidth - IMAGE_EDIT_PADDING_PX * 2) / rw, (stage.clientHeight - IMAGE_EDIT_PADDING_PX * 2) / rh)
    if (!(fit > 0)) return
    const cssW = Math.floor(rw * fit)
    const cssH = Math.floor(rh * fit)
    const dpr = Math.min($window.devicePixelRatio || 1, 2)

    canvas.width = Math.floor(cssW * dpr)
    canvas.height = Math.floor(cssH * dpr)
    canvas.style.width = cssW + 'px'
    canvas.style.height = cssH + 'px'
    const ctx = canvas.getContext('2d')
    ctx.setTransform(1, 0, 0, 1, 0, 0)
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(e.rotation * Math.PI / 180)
    const s = fit * dpr
    ctx.drawImage(img, -nw * s / 2, -nh * s / 2, nw * s, nh * s)

    cropView.width = cssW
    cropView.height = cssH
    cropView.left = canvas.offsetLeft
    cropView.top = canvas.offsetTop
    placeCropBox()
  }

  function placeCropBox() {
    const box = document.getElementById('epImageEditCrop')
    const crop = $scope.imageEdit.crop
    if (!box) return
    if (!crop || !cropView.width) { box.style.display = 'none'; return }
    box.style.display = 'block'
    box.style.left = (cropView.left + crop.x * cropView.width) + 'px'
    box.style.top = (cropView.top + crop.y * cropView.height) + 'px'
    box.style.width = (crop.w * cropView.width) + 'px'
    box.style.height = (crop.h * cropView.height) + 'px'
  }

  // Dragging the crop box (move), a handle (n, s, e, w and the corners) or a new box drawn on the photo
  function bindCropEvents(stage) {
    let drag = null
    stage.addEventListener('pointerdown', function (ev) {
      const e = $scope.imageEdit
      if (!e.active || e.saving || ev.button !== 0 || !cropView.width) return
      const rect = stage.getBoundingClientRect()
      const fx = (ev.clientX - rect.left - cropView.left) / cropView.width
      const fy = (ev.clientY - rect.top - cropView.top) / cropView.height
      const handle = ev.target && ev.target.getAttribute && ev.target.getAttribute('data-crop-handle')
      const previous = e.crop ? Object.assign({}, e.crop) : null
      let mode = null
      if (handle) mode = handle
      else if (e.crop && ev.target && ev.target.closest && ev.target.closest('#epImageEditCrop')) mode = 'move'
      else if (fx >= 0 && fx <= 1 && fy >= 0 && fy <= 1) {
        // A new box from this point, sized by the drag (the se corner follows the pointer)
        e.crop = { x: fx, y: fy, w: 0, h: 0 }
        mode = 'new'
      }
      if (!mode) return
      ev.preventDefault()
      ev.stopPropagation()
      // start: the box before this drag (for a new box, the one it replaces - put back if nothing was drawn)
      drag = { mode: mode, px: ev.clientX, py: ev.clientY, start: previous, ax: fx, ay: fy }
      stage.classList.add('is-cropping')
      try { stage.setPointerCapture(ev.pointerId) } catch (err) { }
    })
    stage.addEventListener('pointermove', function (ev) {
      if (!drag) return
      const e = $scope.imageEdit
      const dx = (ev.clientX - drag.px) / cropView.width
      const dy = (ev.clientY - drag.py) / cropView.height
      const minW = Math.min(1, CROP_MIN_PX / cropView.width)
      const minH = Math.min(1, CROP_MIN_PX / cropView.height)
      const s = drag.start
      let x1 = s.x
      let y1 = s.y
      let x2 = s.x + s.w
      let y2 = s.y + s.h

      if (drag.mode === 'move') {
        const nx = Math.max(0, Math.min(1 - s.w, s.x + dx))
        const ny = Math.max(0, Math.min(1 - s.h, s.y + dy))
        e.crop = { x: nx, y: ny, w: s.w, h: s.h }
        placeCropBox()
        return
      }
      if (drag.mode === 'new') {
        // Either direction from where the drag began
        const px = Math.max(0, Math.min(1, drag.ax + dx))
        const py = Math.max(0, Math.min(1, drag.ay + dy))
        x1 = Math.min(drag.ax, px); x2 = Math.max(drag.ax, px)
        y1 = Math.min(drag.ay, py); y2 = Math.max(drag.ay, py)
      } else {
        if (drag.mode.indexOf('w') > -1) x1 = Math.max(0, Math.min(x2 - minW, s.x + dx))
        if (drag.mode.indexOf('e') > -1) x2 = Math.min(1, Math.max(x1 + minW, s.x + s.w + dx))
        if (drag.mode.indexOf('n') > -1) y1 = Math.max(0, Math.min(y2 - minH, s.y + dy))
        if (drag.mode.indexOf('s') > -1) y2 = Math.min(1, Math.max(y1 + minH, s.y + s.h + dy))
      }
      e.crop = { x: x1, y: y1, w: x2 - x1, h: y2 - y1 }
      placeCropBox()
    })
    function endCropDrag() {
      if (!drag) return
      const e = $scope.imageEdit
      // A click (or a tiny drag) that didn't draw a box: back to the box it had
      if (drag.mode === 'new' && e.crop && (e.crop.w * cropView.width < CROP_MIN_PX || e.crop.h * cropView.height < CROP_MIN_PX)) {
        e.crop = drag.start
        placeCropBox()
      }
      drag = null
      stage.classList.remove('is-cropping')
      $scope.$applyAsync() // Save / the crop button follow the crop
    }
    stage.addEventListener('pointerup', endCropDrag)
    stage.addEventListener('pointercancel', endCropDrag)
  }

  function applySavedImage(file, data) {
    if (data.file) Object.keys(data.file).forEach(function (k) { file[k] = data.file[k] })
    file.display_ext = String(file.detected_ext || '').replace('.', '').toUpperCase()
    if (data.updated_at) file.updated_at = data.updated_at
    file._imageEdit = data.image_edit || null
  }

  $scope.saveImageEdit = function () {
    const e = $scope.imageEdit
    const file = $scope.currentEvidence
    if (!file || !$scope.hasImageEditChanges() || e.saving) return
    e.saving = true
    e.error = null
    $http.post('/review/saveImageEdit', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      rotation: e.rotation,
      crop: e.crop
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        applySavedImage(file, resp.data.data)
        $scope.imageEdit = newImageEditState()
      } else {
        e.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save the photo.'
      }
    }, function () {
      e.error = 'Unable to save the photo.'
    }).finally(function () {
      e.saving = false
      safeApply($scope)
    })
  }

  // Back to the original upload - from the modal's footer or the edited-photo popover. The busy flag / error are
  // kept on the file (file._imageRestore) so both show them.
  $scope.restoreEvidenceImage = function (file) {
    if (!file || !file._imageEdit) return
    if (file._imageRestore && file._imageRestore.busy) return
    if (file === $scope.currentEvidence && $scope.imageEdit.active) return
    file._imageRestore = { busy: true, error: null }
    $http.post('/review/restoreImageEdit', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        applySavedImage(file, resp.data.data)
        file._imageRestore = null
        if (file === $scope.currentEvidence) $scope.resetEvidenceZoom()
        if ($scope.imageEditPop.file === file) $scope.closeImageEditPop()
      } else {
        file._imageRestore = { busy: false, error: (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to restore the photo.' }
      }
    }, function () {
      file._imageRestore = { busy: false, error: 'Unable to restore the photo.' }
    }).finally(function () {
      safeApply($scope)
    })
  }

  // --- Edited-photo popover: the icon beside "Open Photo Fullscreen" opens it with the edit's details, the original
  // image and Restore. It sits at the page level (fixed, placed at the icon): the evidence rows clip what overflows
  // them. It closes on a click elsewhere, Esc, or when the page scrolls.
  $scope.imageEditPop = { file: null }
  const IMAGE_EDIT_POP_GAP_PX = 6
  const IMAGE_EDIT_POP_MARGIN_PX = 8
  let imageEditPopAnchor = null

  function placeImageEditPop() {
    if (!$scope.imageEditPop.file) return
    placeFixedPop(document.getElementById('epImageEditPop'), imageEditPopAnchor)
  }

  // A page-level popover (position: fixed) under its anchor - above it if there's no room below; kept on screen
  function placeFixedPop(pop, anchor) {
    if (!pop || !anchor) return
    const a = anchor.getBoundingClientRect()
    const w = pop.offsetWidth
    const h = pop.offsetHeight
    const vw = $window.innerWidth
    const vh = $window.innerHeight
    // Below the icon if it fits, else above it; kept on screen sideways
    let top = a.bottom + IMAGE_EDIT_POP_GAP_PX
    if (top + h > vh - IMAGE_EDIT_POP_MARGIN_PX && a.top - IMAGE_EDIT_POP_GAP_PX - h >= IMAGE_EDIT_POP_MARGIN_PX) top = a.top - IMAGE_EDIT_POP_GAP_PX - h
    const left = Math.max(IMAGE_EDIT_POP_MARGIN_PX, Math.min(vw - w - IMAGE_EDIT_POP_MARGIN_PX, a.left))
    pop.style.top = Math.max(IMAGE_EDIT_POP_MARGIN_PX, top) + 'px'
    pop.style.left = left + 'px'
    pop.style.visibility = 'visible'
  }

  $scope.toggleImageEditPop = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if ($scope.imageEditPop.file === file) { $scope.closeImageEditPop(); return }
    $scope.closeUsageNotePop()
    imageEditPopAnchor = $event && $event.currentTarget
    $scope.imageEditPop.file = file
    const pop = document.getElementById('epImageEditPop')
    if (pop) pop.style.visibility = 'hidden' // until it's placed
    $window.setTimeout(placeImageEditPop, 0) // after it has rendered (its size is known then)
  }

  $scope.closeImageEditPop = function () {
    $scope.imageEditPop.file = null
    imageEditPopAnchor = null
  }

  // Placed again once the original image has loaded (the popover grows; load doesn't bubble, so caught on the way down)
  document.addEventListener('load', function (e) {
    const pop = document.getElementById('epImageEditPop')
    if (pop && e.target && e.target.tagName === 'IMG' && pop.contains(e.target)) placeImageEditPop()
  }, true)

  // "Rotated 90° clockwise and cropped" - what the saved edit did
  $scope.getImageEditSummary = function (file) {
    const info = file && file._imageEdit
    const edit = info && info.edit
    if (!edit) return 'Edited'
    const parts = []
    const turn = Number(edit.rotation) || 0
    if (turn === 90) parts.push('Rotated 90° clockwise')
    else if (turn === 180) parts.push('Rotated 180°')
    else if (turn === 270) parts.push('Rotated 90° counter-clockwise')
    if (edit.crop) parts.push(parts.length ? 'cropped' : 'Cropped')
    return parts.join(' and ') || 'Edited'
  }

  $scope.getImageEditWhen = function (file) {
    const info = file && file._imageEdit
    return info ? formatTooltipWhen(info.edited_at) : ''
  }

  $scope.formatImageBytes = function (bytes) {
    const n = Number(bytes)
    if (!n) return ''
    if (n < 1024 * 1024) return Math.max(1, Math.round(n / 1024)) + ' KB'
    return (n / (1024 * 1024)).toFixed(1) + ' MB'
  }

  document.addEventListener('mousedown', function (e) {
    if (!$scope.imageEditPop.file) return
    const pop = document.getElementById('epImageEditPop')
    if ((pop && pop.contains(e.target)) || (imageEditPopAnchor && imageEditPopAnchor.contains(e.target))) return
    $scope.$applyAsync($scope.closeImageEditPop)
  })
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $scope.imageEditPop.file) $scope.$applyAsync($scope.closeImageEditPop)
  })
  // Any scroll (the page, the review table, the evidence column) would leave it behind - close it
  $window.addEventListener('scroll', function (e) {
    if (!$scope.imageEditPop.file) return
    const pop = document.getElementById('epImageEditPop')
    if (pop && e.target && pop.contains && e.target !== document && pop.contains(e.target)) return
    $scope.$applyAsync($scope.closeImageEditPop)
  }, true)
  $window.addEventListener('resize', function () {
    if ($scope.imageEditPop.file) placeImageEditPop()
  })

  // --- Do Not Use on Report reason: the icon left of a row's "No" opens this popover to add, edit or delete the
  // optional reason. The AI's reason (a listing screenshot / CMA it set to No) shows as the AI's until an agent
  // edits it. Page level and fixed like the edited-photo popover.
  $scope.usageNotePop = { file: null, text: '', saving: false, deleting: false, error: null }
  let usageNotePopAnchor = null

  function openUsageNotePop(file, anchor) {
    $scope.closeImageEditPop()
    usageNotePopAnchor = anchor || null
    $scope.usageNotePop = { file: file, text: file._usageNote ? String(file._usageNote.reason || '') : '', saving: false, deleting: false, error: null }
    const pop = document.getElementById('epUsageNotePop')
    if (pop) pop.style.visibility = 'hidden' // until it's placed
    $window.setTimeout(function () {
      placeFixedPop(document.getElementById('epUsageNotePop'), usageNotePopAnchor)
      const box = document.getElementById('epUsageNoteText')
      if (box) { box.focus(); box.setSelectionRange(box.value.length, box.value.length) }
    }, 0)
  }

  $scope.toggleUsageNotePop = function (file, $event) {
    try { if ($event) $event.stopPropagation() } catch (e) { }
    if ($scope.usageNotePop.file === file) { $scope.closeUsageNotePop(); return }
    openUsageNotePop(file, $event && $event.currentTarget)
  }

  $scope.closeUsageNotePop = function () {
    if ($scope.usageNotePop.saving || $scope.usageNotePop.deleting) return
    $scope.usageNotePop = { file: null, text: '', saving: false, deleting: false, error: null }
    usageNotePopAnchor = null
  }

  $scope.canSaveUsageNote = function () {
    const pop = $scope.usageNotePop
    const text = String(pop.text || '').trim()
    if (!pop.file || !text || pop.saving || pop.deleting) return false
    const note = pop.file._usageNote
    return !note || text !== String(note.reason || '').trim() || note.source === 'ai'
  }

  $scope.onUsageNoteKeydown = function ($event) {
    if ($event.key === 'Escape') {
      $event.preventDefault()
      $scope.closeUsageNotePop()
    } else if ($event.key === 'Enter' && ($event.ctrlKey || $event.metaKey)) {
      $event.preventDefault()
      $scope.saveUsageNote()
    }
  }

  $scope.saveUsageNote = function () {
    const pop = $scope.usageNotePop
    const file = pop.file
    if (!$scope.canSaveUsageNote()) return
    pop.saving = true
    pop.error = null
    $http.post('/review/saveUsageNote', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id,
      reason: String(pop.text || '').trim()
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        file._usageNote = resp.data.data.usage_note
        pop.saving = false
        $scope.closeUsageNotePop()
      } else {
        pop.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to save.'
      }
    }, function () {
      pop.error = 'Unable to save.'
    }).finally(function () {
      pop.saving = false
      safeApply($scope)
    })
  }

  $scope.deleteUsageNote = function () {
    const pop = $scope.usageNotePop
    const file = pop.file
    if (!file || !file._usageNote || pop.saving || pop.deleting) return
    pop.deleting = true
    pop.error = null
    $http.post('/review/deleteUsageNote', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id
    }).then(function (resp) {
      if (resp.data && resp.data.success) {
        file._usageNote = null
        pop.deleting = false
        $scope.closeUsageNotePop()
      } else {
        pop.error = (resp.data && resp.data.error) ? String(resp.data.error) : 'Unable to delete.'
      }
    }, function () {
      pop.error = 'Unable to delete.'
    }).finally(function () {
      pop.deleting = false
      safeApply($scope)
    })
  }

  // "Set by AI (run by Glenn Goodrich) · 10/1/26 @ 2:07 PM" / "Glenn Goodrich · 10/1/26 @ 2:07 PM"
  $scope.getUsageNoteByline = function (note) {
    if (!note) return ''
    const when = formatTooltipWhen(note.updated_at)
    const who = note.source === 'ai'
      ? 'Set by AI' + (note.author_name ? ' (run by ' + note.author_name + ')' : '')
      : (note.author_name || 'Agent')
    return who + (when ? ' · ' + when : '')
  }

  // The icon's tooltip: the reason and who wrote it, or how to add one
  $scope.getUsageNoteTitle = function (file) {
    const note = file && file._usageNote
    if (!note) return 'Add a reason for Do Not Use (optional)'
    return note.reason + ' - ' + $scope.getUsageNoteByline(note)
  }

  // Closes on a click elsewhere, Esc (in the box), or any scroll; placed again on resize
  document.addEventListener('mousedown', function (e) {
    if (!$scope.usageNotePop.file) return
    const pop = document.getElementById('epUsageNotePop')
    if ((pop && pop.contains(e.target)) || (usageNotePopAnchor && usageNotePopAnchor.contains(e.target))) return
    $scope.$applyAsync($scope.closeUsageNotePop)
  })
  $window.addEventListener('scroll', function (e) {
    if (!$scope.usageNotePop.file) return
    const pop = document.getElementById('epUsageNotePop')
    if (pop && e.target && e.target !== document && pop.contains(e.target)) return
    $scope.$applyAsync($scope.closeUsageNotePop)
  }, true)
  $window.addEventListener('resize', function () {
    if ($scope.usageNotePop.file) placeFixedPop(document.getElementById('epUsageNotePop'), usageNotePopAnchor)
  })

  // Wheel and drag on the modal body (it stays in the page; the photo / PDF inside it comes and goes)
  function bindEvidenceZoomEvents(modalEl) {
    const body = modalEl && modalEl.querySelector('.modal-body')
    if (!body) return

    // The wheel zooms (up = in). A mouse notch is ZOOM_WHEEL_STEP slider steps; a trackpad's many small deltas add
    // up to the same, so zooming stays smooth. Shift + wheel scrolls a PDF's pages instead.
    let wheelSteps = 0
    body.addEventListener('wheel', function (e) {
      if ($scope.imageEdit.active) { e.preventDefault(); return } // editing a photo: no zoom
      const pdf = isPdfViewActive()
      if (!pdf && (!$scope.isImage($scope.currentEvidence) || !getZoomImage())) return
      e.preventDefault()

      if (pdf && e.shiftKey) {
        const view = getPdfViewEl()
        if (view) view.scrollTop += (e.deltaY || e.deltaX) * (e.deltaMode === 1 ? 33 : 1)
        return
      }

      const pixels = e.deltaY * (e.deltaMode === 1 ? 33 : (e.deltaMode === 2 ? 800 : 1)) // lines / pages -> px
      const pinch = e.ctrlKey && e.deltaMode === 0 && Math.abs(e.deltaY) < 50
      wheelSteps += -pixels * (pinch ? ZOOM_PINCH_FACTOR : ZOOM_WHEEL_STEP / 100)
      const steps = Math.trunc(wheelSteps)
      if (!steps) return
      wheelSteps -= steps
      const anchor = { clientX: e.clientX, clientY: e.clientY }
      $scope.$applyAsync(function () {
        $scope.stepEvidenceZoom(steps, anchor)
      })
    }, { passive: false })

    // Photo: moves the zoomed-in photo. PDF: scrolls the pages, at any zoom.
    let start = null
    body.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || $scope.imageEdit.active) return
      const pdfEl = isPdfViewActive() ? getPdfViewEl() : null
      if (pdfEl) {
        if (!pdfEl.contains(e.target)) return
        if (pdfEl.scrollHeight <= pdfEl.clientHeight && pdfEl.scrollWidth <= pdfEl.clientWidth) return
        // Leave the scrollbars to the browser
        const rect = pdfEl.getBoundingClientRect()
        if (e.clientX > rect.left + pdfEl.clientWidth || e.clientY > rect.top + pdfEl.clientHeight) return
        e.preventDefault()
        start = { pdf: pdfEl, px: e.clientX, py: e.clientY, left: pdfEl.scrollLeft, top: pdfEl.scrollTop }
        pdfEl.classList.add('is-dragging')
      } else {
        const img = getZoomImage()
        if (!img || zoomScale($scope.evidenceZoom.value) <= 1) return
        e.preventDefault()
        start = { px: e.clientX, py: e.clientY, x: $scope.evidenceZoom.x, y: $scope.evidenceZoom.y }
        img.classList.add('is-dragging')
      }
      try { body.setPointerCapture(e.pointerId) } catch (err) { }
    })
    body.addEventListener('pointermove', function (e) {
      if (!start) return
      if (start.pdf) {
        start.pdf.scrollLeft = start.left - (e.clientX - start.px)
        start.pdf.scrollTop = start.top - (e.clientY - start.py)
        return
      }
      $scope.evidenceZoom.x = start.x + (e.clientX - start.px)
      $scope.evidenceZoom.y = start.y + (e.clientY - start.py)
      applyEvidenceZoom()
    })
    function endDrag() {
      if (!start) return
      if (start.pdf) start.pdf.classList.remove('is-dragging')
      start = null
      const img = getZoomImage()
      if (img) img.classList.remove('is-dragging')
      $scope.$applyAsync() // Reset turns on once the photo has been moved
    }
    body.addEventListener('pointerup', endDrag)
    body.addEventListener('pointercancel', endDrag)
    body.addEventListener('dblclick', function () {
      if ($scope.imageEdit.active) return
      if (getZoomImage() || isPdfViewActive()) $scope.$applyAsync($scope.resetEvidenceZoom)
    })
    // The photo loaded (load doesn't bubble, so caught on the way down): its natural size is known now
    body.addEventListener('load', function (e) {
      if (e.target && e.target.id === 'epEvidenceZoomImg') applyEvidenceZoom()
    }, true)

    // PDF pages follow the modal's width: once it has opened (it has no size while hidden) and when the window
    // is resized. Closing it lets go of the PDF.
    modalEl.addEventListener('shown.bs.modal', function () { layoutPdfPages(false) })
    modalEl.addEventListener('hidden.bs.modal', function () {
      closePdfView()
      $scope.$applyAsync(function () {
        $scope.evidencePdf = { loading: false, failed: false, pageCount: 0 }
        $scope.imageEdit = newImageEditState() // closing drops an unsaved edit
      })
    })
    $window.addEventListener('resize', function () {
      if (pdfView.pages.length) layoutPdfPages(true)
      if ($scope.imageEdit.active) renderImageEdit()
    })

    const stage = getImageEditStage()
    if (stage) bindCropEvents(stage)
  }

  $scope.viewEvidence = function (file) {
    $scope.closeImageEditPop()
    $scope.currentEvidence = file
    $scope.imageEdit = newImageEditState()
    $scope.evidenceZoom.value = 0
    $scope.evidenceZoom.x = 0
    $scope.evidenceZoom.y = 0
    if (!evidenceModal) {
      const modalEl = document.getElementById('evidenceModal')
      evidenceModal = new $window.bootstrap.Modal(modalEl)
      bindEvidenceZoomEvents(modalEl)
    }
    if ($scope.isPdf(file)) openPdfView(file)
    else closePdfView()
    evidenceModal.show()
    // Back to 100% - also on a photo element reused from the last one shown
    $window.setTimeout(applyEvidenceZoom, 0)
  }


  $scope.openEvidenceFullscreen = function (file, $event) {
    try {
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
    } catch (e) { }
    $scope.viewEvidence(file)
  }

  // Download beside Open PDF / Photo Fullscreen: the server sends the file as an attachment (Cloud Storage is another
  // origin, where a download link would just open it), saved to the browser's download folder
  $scope.downloadEvidenceFile = function (file, $event) {
    try {
      if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
      if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
    } catch (e) { }
    if (!file || !file.id || file._downloading) return
    file._downloading = true
    $http.post('/review/downloadEvidenceFile', {
      crm_user_id: $scope.crm_user_id,
      crm_user_password: $scope.crm_user_password,
      id: file.id
    }, { responseType: 'blob' }).then(function (resp) {
      const blob = resp.data
      const type = String((resp.headers && resp.headers('content-type')) || '')
      // An error comes back as JSON
      if (/application\/json/i.test(type)) {
        return blob.text().then(function (text) {
          let error = 'The file could not be downloaded.'
          try { error = JSON.parse(text).error || error } catch (e) { }
          showMessageModal(error, 'Download')
        })
      }
      const disposition = String((resp.headers && resp.headers('content-disposition')) || '')
      const match = disposition.match(/filename\*=UTF-8''([^;]+)/i) || disposition.match(/filename="([^"]+)"/i)
      let name = file.original_name || ('evidence-' + file.id)
      try { if (match) name = decodeURIComponent(match[1]) } catch (e) { }
      const url = $window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = name
      document.body.appendChild(link)
      link.click()
      link.remove()
      $window.setTimeout(function () { $window.URL.revokeObjectURL(url) }, 60000)
    }, function () {
      showMessageModal('The file could not be downloaded.', 'Download')
    }).finally(function () {
      file._downloading = false
      safeApply($scope)
    })
  }

  $scope.isImage = function (file) {
    if (!file) return false
    const ext = (file.detected_ext || '').toLowerCase()
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext.replace('.', '')) || file.content_type_key === 'PHOTO'
  }

  $scope.isPdf = function (file) {
    if (!file) return false
    const ext = (file.detected_ext || '').toLowerCase()
    return ['pdf'].includes(ext.replace('.', ''))
  }

  $scope.trustSrc = function (src) {
    return $sce.trustAsResourceUrl(src)
  }

  $scope.trustPdfSrc = function (src) {
    try {
      const base = String(src || '')
      if (!base) return $sce.trustAsResourceUrl(base)
      const fitParams = 'view=FitH&toolbar=0&navpanes=0'
      const withParams = base.includes('#') ? `${base}&${fitParams}` : `${base}#${fitParams}`
      return $sce.trustAsResourceUrl(withParams)
    } catch (e) {
      return $sce.trustAsResourceUrl(src)
    }
  }

  $scope.closeEvidenceModal = function (event) {
    try {
      if (!event || !event.target) {
        if (evidenceModal) evidenceModal.hide()
        return
      }
      if (event.target && event.target.id === 'evidenceModal') {
        if (evidenceModal) evidenceModal.hide()
      }
    } catch (e) {
      if (evidenceModal) evidenceModal.hide()
    }
  }

  $scope.returnToCrm = function () {
    $window.location.href = `https://crm.propertytax.io/${$scope.crm_user_id}/${$scope.crm_user_password}`
  }

  init()
})
